import React, { useState, useEffect, useCallback } from 'react';
import { performanceApi, humanApi, abonoApi } from '../lib/api';
import api from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../components/ui/table';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Checkbox } from '../components/ui/checkbox';
import { 
  Loader2,
  User,
  Users,
  Calendar,
  Clock,
  MapPin,
  FileText,
  AlertTriangle,
  CheckCircle,
  ChevronLeft,
  ChevronRight,
  Download,
  XCircle,
  FileSpreadsheet,
  TrendingUp,
  Moon,
  Coffee,
  Shield,
  Ban,
  Tag,
  Settings2,
  ArrowRight,
  Wrench,
  ClipboardX,
  BedDouble,
  Edit3,
  Save,
  MessageSquare,
  Lock,
  Unlock,
  FileDown,
  FileWarning,
  DollarSign,
  Plus,
  X,
  Upload,
  FileUp,
  AlertCircle,
  Check,
  RefreshCw,
} from 'lucide-react';
import { toast } from 'sonner';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../components/ui/tooltip';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// Remove emojis/símbolos que o jsPDF não renderiza (viram caracteres corrompidos e quebram o layout)
const stripEmojis = (str) => {
  if (!str) return str;
  return String(str)
    .replace(/[\u{1F000}-\u{1FFFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}\u{20E3}\u{2190}-\u{21FF}\u{2300}-\u{23FF}]/gu, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
};

// Abrevia textos de situação para siglas (legenda no rodapé do PDF)
const abreviarSituacao = (texto) => {
  if (!texto) return texto;
  return texto
    .replace(/FALTA BATIDA — REGISTRO MANUAL PRESUMIDO \(horário da escala\)/gi, 'FB-P (ADVERTIR)')
    .replace(/REINCIDÊNCIA DE FALTA BATIDA — apontou horário dormindo como trabalhado — impossível mensurar horas reais/gi, 'FB-R (hora dormindo) (ADVERTIR)')
    .replace(/REINCIDÊNCIA DE FALTA BATIDA — impossibilitando as próprias horas extras/gi, 'FB-R (ADVERTIR)')
    .replace(/\*FALTA BATIDA \(ENTRADA\/SAÍDA\)/g, 'FB Entrada+Saída (ADVERTIR)')
    .replace(/\*FALTA BATIDA \(ENTRADA\)/g, 'FB Entrada (ADVERTIR)')
    .replace(/\*FALTA BATIDA \(SAÍDA\)/g, 'FB Saída (ADVERTIR)')
    .replace(/\*FALTA BATIDA/g, 'FB (ADVERTIR)')
    .replace(/APONTAMENTO DESCONSIDERADO \(ocorrência\) — horas zeradas, dia neutro/gi, 'APONT. DESCONSIDERADO (neutro)')
    .replace(/FALTA — apontamento desconsiderado \(ocorrência\)/gi, 'FALTA (apont. desconsiderado)')
    .replace(/Intervalo 12:00-13:12 coberto pelo turno — sem supressão/gi, 'Intervalo coberto')
    .replace(/Intrajornada suprimida: 1h a 50%/gi, 'IS 1h a 50%')
    .replace(/Intrajornada paga \(FDS\)/gi, 'IP (FDS)')
    .replace(/Jornada noturna \(cruzou meia-noite\)/gi, 'JN (cruzou 00h)')
    .replace(/SEM APONTAMENTO COMPLETO/gi, 'S/APONT')
    .replace(/ADICIONAL NOTURNO:/gi, 'NOT:')
    .replace(/INTERJORNADA/g, 'IJ')
    .replace(/ATRASO ABONADO:/gi, 'ATR-AB:')
    .replace(/ATRASO:/gi, 'ATR:')
    .replace(/ABONADO:/gi, 'AB:')
    .replace(/EXTRA 100%/gi, 'E100')
    .replace(/EXTRA 50%/gi, 'E50')
    .replace(/OCORRÊNCIA:/gi, 'OC:')
    .replace(/IRREGULARIDADE/gi, 'IRREG')
    .replace(/Folga \(fim de semana\)/gi, 'Folga FDS');
};

const FolhaCltPage = () => {
  // Verificar se usuário é admin
  const userInfo = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = ['admin', 'super_admin', 'diretoria'].includes(userInfo.role);

  const [loading, setLoading] = useState(false);
  const [loadingHumans, setLoadingHumans] = useState(true);
  const [cltHumans, setCltHumans] = useState([]);
  const [selectedHuman, setSelectedHuman] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [jornadaData, setJornadaData] = useState(null);
  const [viewMode, setViewMode] = useState('individual');
  const [allCltData, setAllCltData] = useState([]);
  
  // Aba de Auditoria
  const [showAuditoria, setShowAuditoria] = useState(false);
  const [auditoriaData, setAuditoriaData] = useState(null);
  const [auditoriaLoading, setAuditoriaLoading] = useState(false);
  const [auditoriaFiltro, setAuditoriaFiltro] = useState('todos');
  
  // Modal de abono
  const [showAbonoModal, setShowAbonoModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [abonoMotivo, setAbonoMotivo] = useState('');
  const [abonoObs, setAbonoObs] = useState('');
  const [savingAbono, setSavingAbono] = useState(false);
  // Irregularidade (hora dormindo)
  const [irregularidadeTipo, setIrregularidadeTipo] = useState('');
  const [irregularidadeDesc, setIrregularidadeDesc] = useState('');
  const [apontamentoOriginalEntrada, setApontamentoOriginalEntrada] = useState('');
  const [apontamentoOriginalSaida, setApontamentoOriginalSaida] = useState('');

  // Modal de classificação
  const [showClassifModal, setShowClassifModal] = useState(false);
  const [classifRecord, setClassifRecord] = useState(null);
  const [classifValue, setClassifValue] = useState('normal');
  const [classifObs, setClassifObs] = useState('');
  const [classifJornadaInicio, setClassifJornadaInicio] = useState('');
  const [classifJornadaFim, setClassifJornadaFim] = useState('');
  const [classifTurno1Inicio, setClassifTurno1Inicio] = useState('');
  const [classifTurno1Fim, setClassifTurno1Fim] = useState('');
  const [classifTurno2Inicio, setClassifTurno2Inicio] = useState('');
  const [classifTurno2Fim, setClassifTurno2Fim] = useState('');
  const [classifLocal1, setClassifLocal1] = useState('');
  const [classifLocal2, setClassifLocal2] = useState('');
  const [savingClassif, setSavingClassif] = useState(false);
  const [previewImpacto, setPreviewImpacto] = useState(null);
  const [loadingPreview, setLoadingPreview] = useState(false);

  // Controle de observação da folha
  const [observacaoFechamento, setObservacaoFechamento] = useState('');
  const [showFechamentoModal, setShowFechamentoModal] = useState(false);
  const [savingFechamento, setSavingFechamento] = useState(false);
  const [pagamentosParciais, setPagamentosParciais] = useState([]);
  const [novoPagamento, setNovoPagamento] = useState({ data: '', descricao: '', valor: '' });

  // Controle de competência (fechamento de edição)
  const [competenciaStatus, setCompetenciaStatus] = useState('aberta');
  const [competenciaInfo, setCompetenciaInfo] = useState(null);
  const [showReabrirModal, setShowReabrirModal] = useState(false);
  const [motivoReabertura, setMotivoReabertura] = useState('');
  const [savingCompetencia, setSavingCompetencia] = useState(false);
  const [exportingPdf, setExportingPdf] = useState(false);
  const [exportingPdfConsolidado, setExportingPdfConsolidado] = useState(false);
  const [exportingFolhaContador, setExportingFolhaContador] = useState(false);
  const [showFolhaConfigModal, setShowFolhaConfigModal] = useState(false);
  const [folhaConfig, setFolhaConfig] = useState({ nao_descontar_faltas: false, nao_descontar_banco: false });
  const [savingFolhaConfig, setSavingFolhaConfig] = useState(false);
  const [userName, setUserName] = useState('Admin');
  
  // Seleção em lote de dias para Folga BH
  const [selectedDays, setSelectedDays] = useState([]);
  const [applyingBatchBH, setApplyingBatchBH] = useState(false);
  const [showBatchBHModal, setShowBatchBHModal] = useState(false);
  const [batchBHMotivo, setBatchBHMotivo] = useState('folga_bh');

  // Textos institucionais editáveis
  const [textosInstitucionais, setTextosInstitucionais] = useState({
    lembrete: { titulo: 'Lembrete', conteudo: '' },
    cultura: { titulo: 'Cultura', conteudo: '' }
  });
  const [editingTexto, setEditingTexto] = useState(null); // 'lembrete' ou 'cultura'
  const [textoEditConteudo, setTextoEditConteudo] = useState('');
  const [savingTexto, setSavingTexto] = useState(false);

  // Modal de abonar atraso (interjornada)
  const [showAbonoAtrasoModal, setShowAbonoAtrasoModal] = useState(false);
  const [abonoAtrasoRecord, setAbonoAtrasoRecord] = useState(null);
  const [abonoAtrasoMotivo, setAbonoAtrasoMotivo] = useState('interjornada');
  const [abonoAtrasoObs, setAbonoAtrasoObs] = useState('');
  const [savingAbonoAtraso, setSavingAbonoAtraso] = useState(false);

  // Modal para adicionar ocorrência em dias sem registro
  const [showOcorrenciaModal, setShowOcorrenciaModal] = useState(false);
  const [ocorrenciaDia, setOcorrenciaDia] = useState(null);
  const [ocorrenciaTexto, setOcorrenciaTexto] = useState('');
  const [ocorrenciaTipo, setOcorrenciaTipo] = useState('irregularidade');
  const [ocorrenciaTratamento, setOcorrenciaTratamento] = useState('manter');
  const [savingOcorrencia, setSavingOcorrencia] = useState(false);

  // Modal de Upload AFD
  const [showAfdModal, setShowAfdModal] = useState(false);
  const [afdFile, setAfdFile] = useState(null);
  const [afdLoading, setAfdLoading] = useState(false);
  const [afdResult, setAfdResult] = useState(null);
  const [afdMapeamento, setAfdMapeamento] = useState({});
  const [afdAcoes, setAfdAcoes] = useState({});
  const [applyingAfd, setApplyingAfd] = useState(false);

  const months = [
    { value: 1, label: 'Janeiro' },
    { value: 2, label: 'Fevereiro' },
    { value: 3, label: 'Março' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Maio' },
    { value: 6, label: 'Junho' },
    { value: 7, label: 'Julho' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Setembro' },
    { value: 10, label: 'Outubro' },
    { value: 11, label: 'Novembro' },
    { value: 12, label: 'Dezembro' },
  ];

  const motivosAbono = [
    { value: 'folga_banco_horas', label: 'Folga Banco de Horas' },
    { value: 'servico_externo', label: 'Serviço Externo' },
    { value: 'reincidencia_descanso', label: 'Reincidência - apontou descanso como trabalho' },
    { value: 'reincidencia_ponto', label: 'Reincidência - falta batida' },
    { value: 'apontamento_incoerente', label: 'Apontamento incoerente (hora dormindo)' },
    { value: 'atestado_medico', label: 'Atestado Médico' },
    { value: 'falta_justificada', label: 'Falta Justificada' },
    { value: 'outro', label: 'Outro motivo (especificar na observação)' },
  ];

  const motivosAbonoAtraso = [
    { value: 'folga_banco_horas', label: 'Folga Banco de Horas' },
    { value: 'outro', label: 'Outro motivo (especificar)' },
  ];

  // Tipos de irregularidade
  const tiposIrregularidade = [
    { value: '', label: 'Nenhuma' },
    { value: 'hora_dormindo', label: 'Hora dormindo apontada como trabalhada' },
    { value: 'apontamento_fraudulento', label: 'Apontamento fraudulento' },
  ];

  // Classificações de dia disponíveis
  const classificacoes = [
    { value: 'normal', label: 'Normal', desc: 'Jornada padrão 08:00-18:00 (8h48)', color: 'bg-slate-100 text-slate-700' },
    { value: 'atraso', label: 'Atraso', desc: 'Confirma atraso real - gera débito', color: 'bg-red-100 text-red-700' },
    { value: 'escala_noturna', label: 'Escala Noturna', desc: 'Trabalhado vira crédito + noturno', color: 'bg-purple-100 text-purple-700' },
    { value: 'jornada_especial', label: 'Jornada Especial', desc: 'Jornada fora do padrão diurno', color: 'bg-indigo-100 text-indigo-700' },
    { value: 'turno_dividido', label: 'Turno Dividido', desc: 'Dois locais/turnos - horas SOMAM', color: 'bg-amber-100 text-amber-700' },
    { value: 'compensacao', label: 'Compensação', desc: 'Dia de compensação de banco', color: 'bg-green-100 text-green-700' },
    { value: 'servico_externo', label: 'Serviço Externo', desc: 'Sem controle de ponto - neutro', color: 'bg-cyan-100 text-cyan-700' },
  ];

  const weekdays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
  const years = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i + 1);

  // Carregar lista de funcionários CLT
  useEffect(() => {
    const loadHumans = async () => {
      try {
        const res = await humanApi.list({ status: 'ativo' });
        const cltOnly = (res.data || []).filter(h => {
          const contractType = h.contract_type || '';
          const tipo = h.type || 'colaborador';
          const subtipo = h.subtype || '';
          return contractType !== 'diaria' && 
                 tipo !== 'terceiro' && 
                 !['freelancer', 'ajudante', 'motorista_caminhao'].includes(subtipo);
        }).sort((a, b) => a.name.localeCompare(b.name));
        setCltHumans(cltOnly);
      } catch (error) {
        console.error('Erro ao carregar funcionários:', error);
      } finally {
        setLoadingHumans(false);
      }
    };
    loadHumans();
    
    // Carregar textos institucionais
    const loadTextosInstitucionais = async () => {
      try {
        const res = await api.get('/textos-institucionais');
        setTextosInstitucionais(res.data);
      } catch (error) {
        console.error('Erro ao carregar textos institucionais:', error);
      }
    };
    loadTextosInstitucionais();
  }, []);

  // Carregar jornada CLT
  const loadJornada = useCallback(async () => {
    if (!selectedHuman) return;
    
    setLoading(true);
    try {
      const res = await performanceApi.getJornadaClt(selectedHuman, selectedMonth, selectedYear);
      setJornadaData(res.data);
      
      // Carregar observação e pagamentos da folha
      try {
        const fechamentoRes = await api.get(`/folha-fechamento?human_id=${selectedHuman}&mes=${selectedMonth}&ano=${selectedYear}`);
        setObservacaoFechamento(fechamentoRes.data?.observacao || '');
        setPagamentosParciais(fechamentoRes.data?.pagamentos_parciais || []);
      } catch {
        setObservacaoFechamento('');
        setPagamentosParciais([]);
      }
      
      // Carregar status da competência
      try {
        const compRes = await api.get(`/competencias/${selectedYear}/${selectedMonth}`);
        setCompetenciaStatus(compRes.data?.status || 'aberta');
        setCompetenciaInfo(compRes.data);
      } catch {
        setCompetenciaStatus('aberta');
        setCompetenciaInfo(null);
      }
    } catch (error) {
      console.error('Erro ao carregar jornada:', error);
      toast.error('Erro ao carregar dados de jornada');
      setJornadaData(null);
    } finally {
      setLoading(false);
      setSelectedDays([]); // Limpar seleção ao carregar novos dados
    }
  }, [selectedHuman, selectedMonth, selectedYear]);

  // Carregar todos os CLT
  const loadAllClt = useCallback(async () => {
    if (cltHumans.length === 0) return;
    
    setLoading(true);
    try {
      const promises = cltHumans.map(h => 
        performanceApi.getJornadaClt(h.id, selectedMonth, selectedYear)
          .then(res => ({ human: h, data: res.data }))
          .catch(() => null)
      );
      const results = await Promise.all(promises);
      setAllCltData(results.filter(r => r !== null));
    } catch (error) {
      console.error('Erro ao carregar todos:', error);
    } finally {
      setLoading(false);
    }
  }, [cltHumans, selectedMonth, selectedYear]);

  useEffect(() => {
    if (viewMode === 'individual' && selectedHuman) {
      loadJornada();
    } else if (viewMode === 'todos' && cltHumans.length > 0) {
      loadAllClt();
    }
  }, [viewMode, selectedHuman, cltHumans.length, loadJornada, loadAllClt]);

  const handlePreviousMonth = () => {
    if (selectedMonth === 1) {
      setSelectedMonth(12);
      setSelectedYear(selectedYear - 1);
    } else {
      setSelectedMonth(selectedMonth - 1);
    }
  };

  const handleNextMonth = () => {
    if (selectedMonth === 12) {
      setSelectedMonth(1);
      setSelectedYear(selectedYear + 1);
    } else {
      setSelectedMonth(selectedMonth + 1);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}`;
    }
    return dateStr;
  };

  const formatMinutes = (mins) => {
    if (mins === undefined || mins === null) return '-';
    const sign = mins < 0 ? '-' : '';
    const absMins = Math.abs(mins);
    const h = Math.floor(absMins / 60);
    const m = absMins % 60;
    return `${sign}${h}h${m.toString().padStart(2, '0')}`;
  };

  // Formato com duas casas na hora: 02h07
  const formatMinutesHM = (mins) => {
    if (mins === undefined || mins === null) return '00h00';
    const absMins = Math.abs(mins);
    const h = Math.floor(absMins / 60);
    const m = absMins % 60;
    return `${h.toString().padStart(2, '0')}h${m.toString().padStart(2, '0')}`;
  };

  // Abrir modal de fechamento
  const openFechamentoModal = () => {
    setShowFechamentoModal(true);
  };

  // Salvar status de fechamento da folha
  const handleSaveFechamento = async () => {
    if (!selectedHuman) return;
    
    setSavingFechamento(true);
    try {
      await api.post('/folha-fechamento', {
        human_id: selectedHuman,
        mes: selectedMonth,
        ano: selectedYear,
        quitada: true,
        observacao: observacaoFechamento,
        pagamentos_parciais: pagamentosParciais
      });
      toast.success('Observacao e pagamentos salvos');
      setShowFechamentoModal(false);
    } catch (error) {
      console.error('Erro ao salvar:', error);
      toast.error('Erro ao salvar');
    } finally {
      setSavingFechamento(false);
    }
  };
  
  // Adicionar pagamento parcial
  const handleAddPagamento = () => {
    if (!novoPagamento.data || !novoPagamento.descricao || !novoPagamento.valor) {
      toast.error('Preencha todos os campos');
      return;
    }
    setPagamentosParciais([...pagamentosParciais, {
      id: Date.now(),
      data: novoPagamento.data,
      descricao: novoPagamento.descricao,
      valor: parseFloat(novoPagamento.valor)
    }]);
    setNovoPagamento({ data: '', descricao: '', valor: '' });
  };
  
  // Remover pagamento parcial
  const handleRemovePagamento = (id) => {
    setPagamentosParciais(pagamentosParciais.filter(p => p.id !== id));
  };

  // Abrir modal de abono
  const openAbonoModal = (dia) => {
    setSelectedRecord(dia);
    setAbonoMotivo('');
    setAbonoObs('');
    setIrregularidadeTipo('');
    setIrregularidadeDesc('');
    setApontamentoOriginalEntrada(dia.entrada || '');
    setApontamentoOriginalSaida(dia.saida || '');
    setShowAbonoModal(true);
  };

  // Salvar abono
  const handleSaveAbono = async () => {
    if (!abonoMotivo) {
      toast.error('Selecione um motivo para o abono');
      return;
    }
    
    setSavingAbono(true);
    try {
      const payload = {
        motivo: abonoMotivo,
        observacao: abonoObs
      };
      
      // Se há irregularidade a registrar
      if (irregularidadeTipo) {
        payload.irregularidade_tipo = irregularidadeTipo;
        payload.irregularidade_descricao = irregularidadeDesc || 
          'Horário de descanso (DORMINDO) apontado como hora trabalhada. É proibido apontar hora dormindo como hora trabalhada. Apontamento incoerente com o serviço prestado — medição anulada. Dia ABONADO como meio-termo, sem horas extras.';
        payload.apontamento_original_entrada = apontamentoOriginalEntrada;
        payload.apontamento_original_saida = apontamentoOriginalSaida;
      }
      
      // Se tem record_id, usa endpoint tradicional. Senão, usa novo endpoint por data
      if (selectedRecord?.record_id) {
        await abonoApi.abonar(selectedRecord.record_id, payload);
      } else {
        // Abonar por human_id + data
        await abonoApi.abonarPorData({
          human_id: selectedHuman,
          date: selectedRecord?.data,
          motivo: abonoMotivo,
          observacao: abonoObs
        });
      }
      
      toast.success('Dia abonado com sucesso');
      setShowAbonoModal(false);
      loadJornada(); // Recarregar dados
    } catch (error) {
      console.error('Erro ao abonar:', error);
      toast.error(error.response?.data?.detail || 'Erro ao abonar dia');
    } finally {
      setSavingAbono(false);
    }
  };

  // Remover abono
  const handleRemoverAbono = async (recordId) => {
    if (!confirm('Deseja remover o abono deste dia?')) return;
    
    try {
      await abonoApi.remover(recordId);
      toast.success('Abono removido');
      loadJornada();
    } catch (error) {
      console.error('Erro ao remover abono:', error);
      toast.error('Erro ao remover abono');
    }
  };

  // ==================== ABONAR ATRASO/SAÍDA ANTECIPADA (FOLGA BANCO DE HORAS) ====================
  
  // Abrir modal de abonar atraso/saída antecipada
  const openAbonoAtrasoModal = (dia) => {
    setAbonoAtrasoRecord(dia);
    setAbonoAtrasoMotivo('folga_banco_horas');
    setAbonoAtrasoObs('');
    setShowAbonoAtrasoModal(true);
  };

  // Salvar abono de atraso
  const handleSaveAbonoAtraso = async () => {
    if (!abonoAtrasoRecord?.record_id) {
      toast.error('Registro inválido');
      return;
    }
    
    if (abonoAtrasoMotivo === 'outro' && !abonoAtrasoObs) {
      toast.error('Informe o motivo do abono');
      return;
    }
    
    setSavingAbonoAtraso(true);
    try {
      await api.post(`/day-records/${abonoAtrasoRecord.record_id}/abonar-atraso`, {
        motivo: abonoAtrasoMotivo,
        observacao: abonoAtrasoObs
      });
      toast.success('Atraso abonado com sucesso');
      setShowAbonoAtrasoModal(false);
      loadJornada();
    } catch (error) {
      console.error('Erro ao abonar atraso:', error);
      toast.error(error.response?.data?.detail || 'Erro ao abonar atraso');
    } finally {
      setSavingAbonoAtraso(false);
    }
  };

  // Remover abono de atraso
  const handleRemoverAbonoAtraso = async (recordId) => {
    if (!confirm('Deseja remover o abono do atraso deste dia?')) return;
    
    try {
      await api.post(`/day-records/${recordId}/remover-abono-atraso`);
      toast.success('Abono de atraso removido');
      loadJornada();
    } catch (error) {
      console.error('Erro ao remover abono de atraso:', error);
      toast.error('Erro ao remover abono de atraso');
    }
  };

  // Toggle seleção de dia para folga BH em lote
  const toggleDaySelection = (dia) => {
    const dayKey = dia.data;
    if (selectedDays.includes(dayKey)) {
      setSelectedDays(selectedDays.filter(d => d !== dayKey));
    } else {
      setSelectedDays([...selectedDays, dayKey]);
    }
  };
  
  // Selecionar/Deselecionar todos os dias elegíveis
  const toggleSelectAll = () => {
    if (!jornadaData?.dias) return;
    
    const eligibleDays = jornadaData.dias.filter(dia => {
      const ehFds = ['Sábado', 'Domingo', 'Sáb', 'Dom'].includes(dia.dia_semana);
      return !ehFds && (dia.atraso || dia.banco_minutos < 0) && !dia.atraso_abonado && dia.record_id;
    }).map(dia => dia.data);
    
    if (selectedDays.length === eligibleDays.length) {
      setSelectedDays([]);
    } else {
      setSelectedDays(eligibleDays);
    }
  };
  
  // Aplicar Folga BH em lote
  const handleApplyBatchBH = async () => {
    if (selectedDays.length === 0) return;
    
    setApplyingBatchBH(true);
    let successCount = 0;
    let errorCount = 0;
    
    for (const dayData of selectedDays) {
      const dia = jornadaData.dias.find(d => d.data === dayData);
      if (!dia?.record_id) continue;
      
      try {
        await api.post(`/day-records/${dia.record_id}/abonar-atraso`, {
          motivo: batchBHMotivo,
          observacao: ''
        });
        successCount++;
      } catch (error) {
        console.error(`Erro ao abonar dia ${dayData}:`, error);
        errorCount++;
      }
    }
    
    setApplyingBatchBH(false);
    setShowBatchBHModal(false);
    setSelectedDays([]);
    setBatchBHMotivo('folga_bh');
    
    if (successCount > 0) {
      toast.success(`Folga BH aplicada em ${successCount} dia(s)`);
      loadJornada();
    }
    if (errorCount > 0) {
      toast.error(`Falha em ${errorCount} dia(s)`);
    }
  };

  // Converter Falta em Folga Justificada (quando escala era folga/banco)
  const handleConverterFaltaEmFolga = async (dia) => {
    if (!dia) return;
    
    const confirmMsg = `Converter FALTA em FOLGA JUSTIFICADA para ${dia.data}?\n\nA escala indicava "${dia.local_evento || dia.escala_dia || 'folga/banco'}".`;
    if (!window.confirm(confirmMsg)) return;
    
    try {
      // Usar o endpoint de abono por data (cria registro se não existir)
      await abonoApi.abonarPorData({
        human_id: selectedHuman,
        date: dia.data,
        motivo: 'folga_justificada',
        observacao: `Convertido de FALTA para FOLGA JUSTIFICADA. Escala original: ${dia.local_evento || dia.escala_dia || 'Banco de Horas/Folga'}`
      });
      
      toast.success('Falta convertida em folga justificada');
      loadJornada(); // Recarregar dados
    } catch (error) {
      console.error('Erro ao converter falta:', error);
      toast.error(error.response?.data?.detail || 'Erro ao converter falta em folga');
    }
  };

  // Configuração da competência (não descontar faltas/banco)
  const openFolhaConfigModal = async () => {
    try {
      const res = await api.get(`/folha-config/${selectedYear}/${selectedMonth}`);
      setFolhaConfig(res.data);
    } catch (e) {
      setFolhaConfig({ nao_descontar_faltas: false, nao_descontar_banco: false });
    }
    setShowFolhaConfigModal(true);
  };

  const handleSaveFolhaConfig = async () => {
    setSavingFolhaConfig(true);
    try {
      await api.put(`/folha-config/${selectedYear}/${selectedMonth}`, {
        nao_descontar_faltas: folhaConfig.nao_descontar_faltas,
        nao_descontar_banco: folhaConfig.nao_descontar_banco
      });
      toast.success('Configuração da competência salva');
      setShowFolhaConfigModal(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro ao salvar configuração');
    } finally {
      setSavingFolhaConfig(false);
    }
  };

  // Marcar/desmarcar dia como REGISTRO MANUAL PRESUMIDO (horário da escala)
  const handleTogglePresumido = async (dia) => {
    if (!dia.record_id) return;
    try {
      await api.post(`/day-records/${dia.record_id}/marcar-presumido`, { presumido: !dia.registro_presumido });
      toast.success(!dia.registro_presumido
        ? 'Dia marcado como FALTA BATIDA — Registro Manual Presumido'
        : 'Marcação de registro presumido removida');
      loadJornada();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao marcar registro presumido');
    }
  };

  // Abrir modal de ocorrência para dias sem registro
  const openOcorrenciaModal = (dia) => {
    setOcorrenciaDia(dia);
    setOcorrenciaTexto(dia.ocorrencia_obs || '');
    setOcorrenciaTipo(dia.ocorrencia_tipo || 'irregularidade');
    setOcorrenciaTratamento(dia.ocorrencia_tratamento || 'manter');
    setShowOcorrenciaModal(true);
  };

  // Salvar ocorrência (cria registro se não existir)
  const handleSaveOcorrencia = async () => {
    if (!ocorrenciaDia || !ocorrenciaTexto.trim()) {
      toast.error('Informe a ocorrência');
      return;
    }
    
    setSavingOcorrencia(true);
    try {
      await api.post(`/day-records/criar-ocorrencia`, {
        human_id: selectedHuman,
        date: ocorrenciaDia.data,
        tipo: ocorrenciaTipo,
        observacao: ocorrenciaTexto.trim(),
        tratamento_horas: ocorrenciaTratamento
      });
      toast.success('Ocorrência registrada com sucesso');
      setShowOcorrenciaModal(false);
      loadJornada();
    } catch (error) {
      console.error('Erro ao salvar ocorrência:', error);
      toast.error(error.response?.data?.detail || 'Erro ao salvar ocorrência');
    } finally {
      setSavingOcorrencia(false);
    }
  };

  // Abrir modal de classificação
  const openClassifModal = (dia) => {
    setClassifRecord(dia);
    setClassifValue(dia.classificacao_dia || 'normal');
    setClassifObs('');
    setClassifJornadaInicio('');
    setClassifJornadaFim('');
    setClassifTurno1Inicio('');
    setClassifTurno1Fim('');
    setClassifTurno2Inicio('');
    setClassifTurno2Fim('');
    setClassifLocal1('');
    setClassifLocal2('');
    setPreviewImpacto(null);
    setShowClassifModal(true);
  };

  // Carregar preview do impacto
  const loadPreviewImpacto = useCallback(async () => {
    if (!classifRecord?.record_id) return;
    
    setLoadingPreview(true);
    try {
      const res = await api.post(`/day-records/${classifRecord.record_id}/preview-classificacao`, {
        classificacao: classifValue,
        jornada_prevista_inicio: classifJornadaInicio || undefined,
        jornada_prevista_fim: classifJornadaFim || undefined,
        turno_1_inicio: classifTurno1Inicio || undefined,
        turno_1_fim: classifTurno1Fim || undefined,
        turno_2_inicio: classifTurno2Inicio || undefined,
        turno_2_fim: classifTurno2Fim || undefined,
        local_turno_1: classifLocal1 || undefined,
        local_turno_2: classifLocal2 || undefined
      });
      setPreviewImpacto(res.data);
    } catch (error) {
      console.error('Erro ao carregar preview:', error);
    } finally {
      setLoadingPreview(false);
    }
  }, [classifRecord?.record_id, classifValue, classifJornadaInicio, classifJornadaFim, 
      classifTurno1Inicio, classifTurno1Fim, classifTurno2Inicio, classifTurno2Fim, 
      classifLocal1, classifLocal2]);

  // Effect para carregar preview quando classificação muda
  useEffect(() => {
    if (showClassifModal && classifRecord?.record_id) {
      loadPreviewImpacto();
    }
  }, [showClassifModal, classifRecord?.record_id, loadPreviewImpacto]);

  // Salvar classificação
  const handleSaveClassif = async () => {
    if (!classifRecord?.record_id) {
      toast.error('Registro inválido');
      return;
    }
    
    setSavingClassif(true);
    try {
      await api.post(`/day-records/${classifRecord.record_id}/classificar`, {
        classificacao: classifValue,
        jornada_prevista_inicio: classifJornadaInicio || undefined,
        jornada_prevista_fim: classifJornadaFim || undefined,
        turno_1_inicio: classifTurno1Inicio || undefined,
        turno_1_fim: classifTurno1Fim || undefined,
        turno_2_inicio: classifTurno2Inicio || undefined,
        turno_2_fim: classifTurno2Fim || undefined,
        local_turno_1: classifLocal1 || undefined,
        local_turno_2: classifLocal2 || undefined,
        observacao: classifObs || undefined
      });
      toast.success(`Dia classificado como "${classificacoes.find(c => c.value === classifValue)?.label}"`);
      setShowClassifModal(false);
      loadJornada(); // Recarregar dados
    } catch (error) {
      console.error('Erro ao classificar:', error);
      toast.error(error.response?.data?.detail || 'Erro ao classificar dia');
    } finally {
      setSavingClassif(false);
    }
  };

  // Helper para obter cor da classificação
  const getClassifColor = (classif) => {
    const c = classificacoes.find(cl => cl.value === classif);
    return c?.color || 'bg-slate-100 text-slate-700';
  };

  // Exportar CSV
  const handleExportCSV = () => {
    if (!jornadaData) return;

    const mesNome = months.find(m => m.value === selectedMonth)?.label;
    
    const headers = ['Data', 'Dia', 'Entrada', 'Saída', 'Escala/OS', 'Visão Hrs', 'Trabalhado', 'Banco', 'Extra 50%', 'Extra 100%', 'Noturno', 'Situação'];
    const rows = jornadaData.dias.map(dia => [
      formatDate(dia.data),
      dia.dia_semana,
      dia.entrada || '-',
      dia.saida || '-',
      dia.escala_dia?.replace(/\n/g, ' | ') || '-',
      dia.divergencia || '-',
      formatMinutes(dia.trabalhado_minutos),
      formatMinutes(dia.banco_minutos),
      formatMinutes(dia.extra_50_minutos),
      formatMinutes(dia.extra_100_minutos),
      formatMinutes(dia.noturno_minutos),
      dia.situacao?.join('; ') || '-'
    ]);

    const csvContent = [
      `PONTO CLT COM OBS. - ${jornadaData.funcionario.nome} - ${mesNome}/${selectedYear}`,
      '',
      `Resumo:`,
      `Banco de Horas: ${jornadaData.resumo.banco_horas}`,
      `Extra 50% (Sábados): ${jornadaData.resumo.extra_50}`,
      `Extra 100% (Dom/Feriados): ${jornadaData.resumo.extra_100}`,
      `Adicional Noturno: ${jornadaData.resumo.adicional_noturno}`,
      `Intrajornada: ${jornadaData.resumo.intrajornada}`,
      `Interjornada: ${jornadaData.resumo.interjornada_count} ocorrências`,
      '',
      headers.join(';'),
      ...rows.map(row => row.join(';'))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const nomeArquivo = jornadaData.funcionario.nome.replace(/\s+/g, '_');
    link.setAttribute('download', `ponto_clt_${nomeArquivo}_${mesNome}_${selectedYear}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    toast.success('CSV exportado!');
  };

  // Exportar PDF do espelho de ponto - Formatação visual idêntica à web
  // Renderiza o espelho de ponto COMPLETO de um funcionário (layout do PDF individual)
  const renderEspelhoPDF = (doc, jornada, opts) => {
    const { mesNome, dataHoraEmissao, usuarioLogado, isCompetenciaAberta, startPage = 1 } = opts;
    const nomeFunc = jornada.funcionario.nome;
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginLeft = 8;
      const marginRight = 8;
      const marginTop = 8;
      const marginBottom = 18;
      const contentWidth = pageWidth - marginLeft - marginRight;
      
      // Cores consistentes com a web (r, g, b)
      const colors = {
        blue: [59, 130, 246],
        blueLight: [239, 246, 255],
        green: [16, 185, 129],
        greenLight: [236, 253, 245],
        red: [239, 68, 68],
        redLight: [254, 242, 242],
        amber: [245, 158, 11],
        amberLight: [255, 251, 235],
        slate: [71, 85, 105],
        slateLight: [248, 250, 252],
        purple: [139, 92, 246],
        purpleLight: [245, 243, 255],
        orange: [249, 115, 22],
        gray: [156, 163, 175]  // Para valores neutros/zero
      };
      
      // Helper functions para setar cores de forma segura
      const setFill = (color) => doc.setFillColor(color[0], color[1], color[2]);
      const setDraw = (color) => doc.setDrawColor(color[0], color[1], color[2]);
      const setText = (color) => doc.setTextColor(color[0], color[1], color[2]);
      
      // Função para formatar horas - retorna "—" para zero em dias sem jornada
      const formatHoursDisplay = (minutos, isDiaFolga = false) => {
        if (isDiaFolga || minutos === 0 || minutos === undefined || minutos === null) {
          return isDiaFolga ? '—' : formatMinutes(minutos);
        }
        return formatMinutes(minutos);
      };
      
      // Função para obter cor do banco de horas
      const getBancoColor = (minutos) => {
        if (minutos > 0) return colors.green;
        if (minutos < 0) return colors.red;
        return colors.gray; // Zero/neutro em cinza
      };
      
      let yPos = marginTop;
      
      // === PÁGINA 1: CABEÇALHO + CULTURA + FOLHA RESUMO ===
      
      // Cabeçalho com nome do funcionário (estilo card)
      setFill(colors.slateLight);
      doc.roundedRect(marginLeft, yPos, contentWidth, 14, 2, 2, 'F');
      setDraw(colors.blue);
      doc.setLineWidth(0.8);
      doc.line(marginLeft, yPos, marginLeft, yPos + 14); // Borda azul esquerda
      
      // Ícone user (círculo azul com inicial)
      setFill(colors.blueLight);
      doc.circle(marginLeft + 8, yPos + 7, 5, 'F');
      doc.setFontSize(10);
      setText(colors.blue);
      doc.setFont('helvetica', 'bold');
      doc.text(nomeFunc.charAt(0).toUpperCase(), marginLeft + 5.8, yPos + 9);
      
      // Nome e badge CLT
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(30, 41, 59);
      doc.text(nomeFunc.toUpperCase(), marginLeft + 18, yPos + 6);
      
      // Badge CLT
      setFill(colors.blueLight);
      doc.roundedRect(marginLeft + 18, yPos + 8, 12, 4, 1, 1, 'F');
      doc.setFontSize(6);
      setText(colors.blue);
      doc.text('CLT', marginLeft + 21, yPos + 11);
      
      // Mês/Ano
      doc.setFontSize(8);
      doc.setTextColor(100, 116, 139);
      doc.text(`${mesNome} ${selectedYear}`, marginLeft + 33, yPos + 11);
      
      // "Dias / Abonados" removido do cabeçalho a pedido do usuário (2026-08)
      const diasPresumidosHdr = jornada.resumo.dias_registro_presumido || 0;
      if (diasPresumidosHdr > 0) {
        doc.setFontSize(8);
        doc.setTextColor(100, 116, 139);
        doc.text(`Presumidos: ${diasPresumidosHdr}`, pageWidth - marginRight - 2, yPos + 8, { align: 'right' });
      }
      
      yPos += 18;
      
      // Bloco "Cultura" (se existir) - MOSTRAR TEXTO COMPLETO com altura dinâmica
      if (textosInstitucionais?.cultura?.conteudo) {
        // Sanitizar texto - manter acentuação, apenas setas que não renderizam
        const culturaTexto = textosInstitucionais.cultura.conteudo
          .replace(/→/g, ' > ')
          .replace(/←/g, ' < ');
        
        doc.setFontSize(6);
        const culturaLines = doc.splitTextToSize(culturaTexto, contentWidth - 22);
        
        // Calcular altura dinâmica baseada no número de linhas (cada linha ~3mm)
        const lineHeight = 2.5;
        const boxHeight = Math.max(8, 4 + (culturaLines.length * lineHeight));
        
        doc.setFillColor(238, 242, 255); // indigo-50
        doc.roundedRect(marginLeft, yPos, contentWidth, boxHeight, 2, 2, 'F');
        doc.setDrawColor(199, 210, 254); // indigo-200
        doc.setLineWidth(0.3);
        doc.roundedRect(marginLeft, yPos, contentWidth, boxHeight, 2, 2, 'S');
        
        doc.setFontSize(6);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(79, 70, 229); // indigo-600
        doc.text('Cultura', marginLeft + 3, yPos + 4);
        
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(67, 56, 202); // indigo-700
        // Mostrar TODAS as linhas, não apenas 2
        doc.text(culturaLines, marginLeft + 17, yPos + 4);
        
        yPos += boxHeight + 3;
      }
      
      // === RESUMO ESTILO HOLERITE (Verba | Horas | Observações) ===
      const r = jornada.resumo;
      const saldoPositivo = (r.banco_horas_minutos || 0) >= 0;
      const elegivel = r.abono_08_09_elegivel !== false;
      const foiEstornado = r.abono_08_09_estornado || false;
      const bonusOk = elegivel && !foiEstornado;
      let bonusObs = 'Sem falta de batida e sem divergencia previsto x realizado no mes';
      if (!bonusOk) {
        bonusObs = 'Nao concedida: ' + (foiEstornado
          ? `ESTORNADO - ${r.abono_08_09_estornado_motivo || 'motivo nao informado'}`
          : (r.abono_08_09_motivo_inelegivel || 'falta de batida e/ou divergencia na competencia'));
      }
      const diffMinNot = Math.round((r.adicional_noturno_convertido || 0) - (r.adicional_noturno_minutos || 0));
      
      // Débitos totais = débitos de jornada (seg-sex) + jornadas descontadas por faltas
      const fmtDebMin = (m) => {
        const a = Math.abs(Math.round(m));
        return `${m < 0 ? '-' : '+'}${String(Math.floor(a / 60)).padStart(2, '0')}:${String(a % 60).padStart(2, '0')}`;
      };
      const debFaltasMin = r.banco_debito_faltas_minutos || 0;
      const debUsoBancoMin = r.banco_debito_uso_banco_minutos || 0;
      const debJornadaMin = -Math.abs(r.banco_debitos_seg_sex_minutos || 0);
      const debTotalMin = debJornadaMin - debFaltasMin - debUsoBancoMin;
      const debPartes = [`jornada ${fmtDebMin(debJornadaMin)}`];
      if (debFaltasMin > 0) debPartes.push(`faltas ${fmtDebMin(-debFaltasMin)}`);
      if (debUsoBancoMin > 0) debPartes.push(`uso banco ${fmtDebMin(-debUsoBancoMin)}`);
      const debObs = `Debitos: ${fmtDebMin(debTotalMin)}${(debFaltasMin > 0 || debUsoBancoMin > 0) ? ` (${debPartes.join(' + ')})` : ''}  |  Creditos: +${r.banco_creditos_seg_sex || '00:00'}  |  ${saldoPositivo ? '(+) CREDITO' : '(-) DEBITO'}`;
      
      const holeriteRows = [
        ['Extra 100% (Domingo/Feriado)', r.extra_100 || '00:00', `Noturnas reduzidas 100%: ${r.noturno_dom_feriado || '00:00'}`],
        ['Extra 50% (Sabado)', r.extra_50 || '00:00', `Noturnas reduzidas 50%: ${r.noturno_sabado || '00:00'}`],
        ['Banco 08h-09h (janela tolerancia)', r.banco_0809 || '00:00', 'Deficit da entrada apos 08:00 (teto -1h00/dia, satura as 09:00). Zerada pela bonificacao quando elegivel'],
        ['Banco Normal (resto do dia)', r.banco_normal || '00:00', 'Atrasos apos 09h, saidas antecipadas, faltas, uso de banco, creditos antes das 08h e extras de fim de dia'],
        ['Banco TOTAL (Seg-Sex) = 8-9h + Normal', r.banco_horas || '00:00', debObs],
        ['Bonificacao 08h-09h *', bonusOk ? `+${r.banco_horas_perdoadas || '00:00'}` : '+00:00', bonusOk ? `Zera a coluna Banco 08h-09h. ${bonusObs}` : bonusObs],
        ['Adicional Noturno (22h-05h)', r.adicional_noturno || '00:00', (r.adicional_noturno_minutos || 0) > 0 ? `Convertido (CLT Art.73, 52m30s=1h): ${r.noturno_seg_sex || '00:00'} (+${diffMinNot}min)` : '-'],
        ['Intrajornada suprimida (IS)', formatMinutes(r.intrajornada_suprimida_minutos || 0), (r.intrajornada_suprimida_count || 0) > 0 ? `${r.intrajornada_suprimida_count}x turno de madrugada sem cobertura de intervalo (1h a 50%)` : '-'],
        ['Interjornada suprimida (IJ)', r.interjornada_horas || '00:00', (r.interjornada_count || 0) > 0 ? `${r.interjornada_count}x descanso entre jornadas menor que 11h` : '-'],
      ];
      if ((r.dias_registro_presumido || 0) > 0) {
        holeriteRows.push(['Registro manual presumido (FB-P)', `${r.dias_registro_presumido}d`, 'Horario lancado pela escala prevista (sem batida no relogio) - sujeito a advertencia']);
      }
      const diasFaltaBatida = (jornada.dias || []).filter(d => (d.situacao || []).some(s => s.includes('FALTA BATIDA'))).length;
      if (diasFaltaBatida > 0) {
        holeriteRows.push(['FALTAS DE BATIDA (FB) — ADVERTIR', `${diasFaltaBatida}d`, 'Dias com horario lancado manualmente (sem batida no relogio, inclui presumidos) — sujeito a advertencia']);
      }
      if ((r.dias_falta || 0) > 0) {
        holeriteRows.push(['FALTAS (jornada descontada do banco)', `${r.dias_falta}d`, `Descontado do banco: ${r.banco_debito_faltas || '00:00'} (jornada prevista por dia de falta)`]);
        holeriteRows.push(['DSR PERDIDO (verba propria - folha)', `${r.dsr_perdidos || 0} sem.`, 'Desconto sobre a remuneracao semanal (nao e banco de horas) — 1 DSR por semana com falta injustificada. Valor em R$ calculado na Folha Contador']);
      }
      
      autoTable(doc, {
        startY: yPos,
        head: [[`FOLHA ${mesNome.toUpperCase()}/${selectedYear}`, 'HORAS', `OBSERVACOES - ${nomeFunc.toUpperCase()}`]],
        body: holeriteRows,
        margin: { left: marginLeft, right: marginRight },
        styles: { fontSize: 6, cellPadding: 1.2, lineColor: [226, 232, 240], lineWidth: 0.1, overflow: 'linebreak' },
        headStyles: { fillColor: [51, 65, 85], textColor: [255, 255, 255], fontSize: 6.5, fontStyle: 'bold' },
        columnStyles: {
          0: { cellWidth: 52, fontStyle: 'bold', textColor: [51, 65, 85] },
          1: { cellWidth: 20, halign: 'center', fontStyle: 'bold' },
          2: { cellWidth: 'auto', textColor: [100, 116, 139], fontSize: 5.5 }
        },
        didParseCell: (data) => {
          if (data.section !== 'body') return;
          const rowLabel = holeriteRows[data.row.index]?.[0] || '';
          if (data.column.index === 1) {
            if (rowLabel.startsWith('Extra 100')) data.cell.styles.textColor = [37, 99, 235];
            else if (rowLabel.startsWith('Extra 50')) data.cell.styles.textColor = [22, 163, 74];
            else if (rowLabel.startsWith('Banco')) data.cell.styles.textColor = saldoPositivo ? [22, 163, 74] : [220, 38, 38];
            else if (rowLabel.startsWith('Bonifica')) data.cell.styles.textColor = bonusOk ? [180, 83, 9] : [220, 38, 38];
            else if (rowLabel.startsWith('Registro manual')) data.cell.styles.textColor = [180, 83, 9];
            else if (rowLabel.startsWith('FALTAS DE BATIDA')) data.cell.styles.textColor = [220, 38, 38];
            else if (rowLabel.startsWith('Intrajornada') || rowLabel.startsWith('Interjornada')) data.cell.styles.textColor = [234, 88, 12];
          }
          if (data.column.index === 0 && rowLabel.startsWith('FALTAS DE BATIDA')) {
            data.cell.styles.textColor = [220, 38, 38];
          }
          if (data.column.index === 2 && rowLabel.startsWith('Bonifica') && !bonusOk) {
            data.cell.styles.textColor = [185, 28, 28];
          }
        }
      });
      yPos = doc.lastAutoTable.finalY + 2;
      
      // Nota de rodapé sobre abono
      doc.setFillColor(255, 251, 235);
      doc.rect(marginLeft, yPos, contentWidth, 8, 'F');
      doc.setFontSize(4);
      doc.setTextColor(146, 64, 14);
      const notaAbono = '* Abono 08h-09h: Restrito a apuracao de jornada desta competencia. NAO constitui atestado de ausencia de outras irregularidades (material, conduta, dano patrimonial). Divergencia ou ocorrencia identificada posteriormente reverte automaticamente o abono, mediante registro em trilha de auditoria.';
      const notaLines = doc.splitTextToSize(notaAbono, contentWidth - 6);
      doc.text(notaLines, marginLeft + 3, yPos + 3);
      yPos += 10;
      
      // Card de observação (se houver)
      if (observacaoFechamento) {
        doc.setFillColor(255, 251, 235);
        doc.setDrawColor(252, 211, 77);
        doc.setLineWidth(0.5);
        
        // Calcular altura dinâmica baseada no texto
        doc.setFontSize(6);
        const obsLines = doc.splitTextToSize(observacaoFechamento, contentWidth - 10);
        const cardHeight = Math.max(12, 6 + (obsLines.length * 3));
        
        doc.roundedRect(marginLeft, yPos, contentWidth, cardHeight, 2, 2, 'FD');
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(146, 64, 14);
        doc.text('Obs.:', marginLeft + 3, yPos + 4);
        
        doc.setFont('helvetica', 'italic');
        doc.text(obsLines, marginLeft + 3, yPos + 8);
        
        yPos += cardHeight + 2;
      }
      
      // Saldo negativo destacado
      if ((jornada.resumo.banco_horas_minutos || 0) < 0) {
        doc.setFontSize(7);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(185, 28, 28);
        doc.text(`Saldo de horas negativas a descontar: ${jornada.resumo.banco_horas}`, pageWidth / 2, yPos + 3, { align: 'center' });
        yPos += 8;
      }
      
      // === TABELA DETALHAMENTO DIÁRIO (continua na mesma página) ===
      // Verificar se há espaço mínimo (40mm) para começar a tabela, senão adiciona página
      if (yPos > pageHeight - 60) {
        doc.addPage();
        yPos = marginTop;
      } else {
        yPos += 5; // Pequeno espaçamento
      }
      
      // Título da tabela diária - mais destacado
      doc.setFillColor(30, 58, 95); // azul escuro
      doc.roundedRect(marginLeft, yPos, contentWidth, 10, 1, 1, 'F');
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(255, 255, 255);
      doc.text(`ESPELHO DE PONTO`, marginLeft + 4, yPos + 6);
      
      // Mês/Ano e Nome do funcionário
      doc.setFontSize(9);
      doc.text(`${mesNome.toUpperCase()} ${selectedYear}`, marginLeft + 55, yPos + 6);
      doc.text(nomeFunc, pageWidth - marginRight - 4, yPos + 6, { align: 'right' });
      yPos += 12;
      
      // Legenda de cores antes da tabela
      doc.setFillColor(250, 250, 252);
      doc.roundedRect(marginLeft, yPos, contentWidth, 6, 1, 1, 'F');
      doc.setFontSize(5.5);
      doc.setFont('helvetica', 'bold');
      
      let legendX = marginLeft + 3;
      // OK
      doc.setFillColor(220, 252, 231);
      doc.rect(legendX, yPos + 1.5, 8, 3, 'F');
      doc.setTextColor(22, 163, 74);
      doc.text('OK', legendX + 2, yPos + 3.5);
      legendX += 12;
      // FALTA
      doc.setFillColor(254, 226, 226);
      doc.rect(legendX, yPos + 1.5, 12, 3, 'F');
      doc.setTextColor(220, 38, 38);
      doc.text('FALTA', legendX + 2, yPos + 3.5);
      legendX += 16;
      // ATRASO
      doc.setFillColor(254, 243, 199);
      doc.rect(legendX, yPos + 1.5, 14, 3, 'F');
      doc.setTextColor(180, 83, 9);
      doc.text('ATRASO', legendX + 2, yPos + 3.5);
      legendX += 18;
      // FOLGA
      doc.setFillColor(241, 245, 249);
      doc.rect(legendX, yPos + 1.5, 12, 3, 'F');
      doc.setTextColor(100, 116, 139);
      doc.text('FOLGA', legendX + 2, yPos + 3.5);
      legendX += 16;
      // ABONO
      doc.setFillColor(207, 250, 254);
      doc.rect(legendX, yPos + 1.5, 14, 3, 'F');
      doc.setTextColor(6, 182, 212);
      doc.text('ABONO', legendX + 2, yPos + 3.5);
      
      // Legenda de colunas
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(100, 100, 100);
      doc.setFontSize(4);
      doc.text('E50D/N=Extra 50% Diurna/Not. | E100D/N=Extra 100% Diurna/Not. | NOT=Ad.Noturno | INTRAJ/INTERJ=Intra/Interjornada', pageWidth - marginRight - 4, yPos + 3.5, { align: 'right' });
      
      yPos += 8;
      
      // Preparar dados da tabela COM ESCALA COMPLETA E OBSERVAÇÕES
      const tableData = jornada.dias.map(dia => {
        // Verificar situação
        const situacaoLower = (dia.situacao?.join(' ') || '').toLowerCase();
        const isFeriado = situacaoLower.includes('feriado') || dia.is_feriado;
        const isFolgaFDS = situacaoLower.includes('folga') && (situacaoLower.includes('fim de semana') || situacaoLower.includes('fds'));
        
        // IMPORTANTE: Feriado COM trabalho NÃO é folga - deve mostrar os horários!
        const temTrabalho = dia.entrada || dia.saida || dia.trabalhado_minutos > 0;
        const isDiaFolga = (isFolgaFDS || (isFeriado && !temTrabalho) || 
                          (!temTrabalho && !dia.entrada && !dia.saida && situacaoLower.includes('folga')));
        
        // Feriado trabalhado deve mostrar tudo normalmente
        const isFeriadoTrabalhado = isFeriado && temTrabalho;
        
        // === ESCALA COMPLETA: Local + Horário Previsto (SEM número da OS) ===
        let escalaCompleta = '';
        let localEvento = '';
        let horarioPrevisto = '';
        
        // Primeiro, tentar pegar dos oss_dia
        if (dia.oss_dia?.length > 0) {
          const osInfo = dia.oss_dia[0];
          localEvento = osInfo.local || osInfo.local_evento || osInfo.nome || osInfo.os || '';
          
          // Horário previsto pode vir de diferentes campos
          if (osInfo.horario_previsto) {
            horarioPrevisto = osInfo.horario_previsto;
          } else if (osInfo.horario_inicio && osInfo.horario_fim) {
            horarioPrevisto = `${osInfo.horario_inicio}-${osInfo.horario_fim}`;
          } else if (osInfo.hora_inicio && osInfo.hora_fim) {
            horarioPrevisto = `${osInfo.hora_inicio}-${osInfo.hora_fim}`;
          }
        }
        
        // Se não tem oss_dia, tentar extrair do escala_dia
        if (!localEvento && dia.escala_dia) {
          // Formato típico: "OS 123 — Local (tipo HH:MM)" ou "RESIDENCIA JARDIM Prev: 08:00-16:00"
          const localMatch = dia.escala_dia.match(/(?:—|–)\s*([^(]+)/);
          if (localMatch) {
            localEvento = localMatch[1].trim();
          } else {
            // Pode ser apenas o nome do local - remover "OS XXX" se existir
            localEvento = dia.escala_dia.replace(/OS\s*\d+\s*/i, '').replace(/Prev:.*$/i, '').trim();
          }
          
          // Tentar extrair horário previsto
          const prevMatch = dia.escala_dia.match(/Prev[:\s]*(\d{1,2}:\d{2})\s*[-–]\s*(\d{1,2}:\d{2})/i);
          if (prevMatch) {
            horarioPrevisto = `${prevMatch[1]}-${prevMatch[2]}`;
          }
        }
        
        // Usar local_evento direto se disponível
        if (!localEvento && dia.local_evento) {
          localEvento = dia.local_evento;
        }
        if (!localEvento && dia.local) {
          localEvento = dia.local;
        }
        
        // Fallback: horário previsto da escala do dia (record)
        if (!horarioPrevisto && dia.escala_prevista_inicio) {
          horarioPrevisto = dia.escala_prevista_fim
            ? `${dia.escala_prevista_inicio}-${dia.escala_prevista_fim}`
            : dia.escala_prevista_inicio;
        }
        
        // Separar Local e Evento (formato típico: "LOCAL - NOME DO EVENTO")
        let nomeLocal = localEvento;
        let nomeEvento = '';
        const sepMatch = localEvento.match(/^(.+?)\s*[-–—]\s+(.+)$/);
        if (sepMatch) {
          nomeLocal = sepMatch[1].trim();
          nomeEvento = sepMatch[2].trim();
        }
        
        // Montar escala completa: Local → Horário Previsto → Evento (SEM OS number)
        const escalaLinhas = [];
        if (nomeLocal) escalaLinhas.push(nomeLocal);
        if (horarioPrevisto) escalaLinhas.push(`ref. ${horarioPrevisto}`);
        if (nomeEvento) escalaLinhas.push(nomeEvento);
        escalaCompleta = escalaLinhas.length > 0 ? escalaLinhas.join('\n') : '-';
        
        // === SITUAÇÃO/OBSERVAÇÕES COMPLETAS ===
        let situacaoCompleta = [];
        
        // Adicionar situações do array
        if (dia.situacao?.length > 0) {
          situacaoCompleta = situacaoCompleta.concat(dia.situacao);
        }
        
        // Adicionar informações de extras (evitar duplicar se o backend já incluiu)
        if (dia.extra_100_minutos > 0 && !situacaoLower.includes('extra 100')) {
          const isFeriado = situacaoLower.includes('feriado');
          const isDomingo = dia.dia_semana?.toLowerCase().includes('dom');
          situacaoCompleta.push(isFeriado ? 'EXTRA 100% (Feriado)' : isDomingo ? 'EXTRA 100% (Dom)' : 'EXTRA 100%');
        }
        if (dia.extra_50_minutos > 0 && dia.dia_semana?.toLowerCase().includes('sáb') && !situacaoLower.includes('extra 50')) {
          situacaoCompleta.push('EXTRA 50% (Sábado)');
        }
        
        // Intrajornada e Interjornada agora têm colunas próprias na tabela (não duplicar na situação)
        
        // Banco de horas (mostrar crédito/débito)
        if (dia.banco_minutos && dia.banco_minutos !== 0) {
          const sinal = dia.banco_minutos > 0 ? '+' : '';
          situacaoCompleta.push(`BH: ${sinal}${formatMinutes(dia.banco_minutos)}`);
        }
        
        // Atraso
        if (dia.atraso_minutos > 0) {
          situacaoCompleta.push(`ATRASO: ${formatMinutes(dia.atraso_minutos)}`);
        }
        
        // Observações do dia e do revisor (renderizadas com cores próprias na célula)
        const obsDiaTexto = stripEmojis(dia.observacao || '').trim();
        const obsRevisorTexto = stripEmojis(dia.obs_auditoria || '').trim();
        
        // Divergência
        if (dia.divergencia && dia.divergencia !== '-' && dia.divergencia.trim() !== '') {
          situacaoCompleta.push(`Div: ${dia.divergencia}`);
        }
        
        // Irregularidades
        if (dia.irregularidade_tipo) {
          const irregTexto = { 
            'hora_dormindo': 'IRREG: Hora dormindo', 
            'apontamento_fraudulento': 'IRREG: Fraude' 
          }[dia.irregularidade_tipo] || `IRREG: ${dia.irregularidade_tipo}`;
          situacaoCompleta.push(irregTexto);
        }
        
        // Abono
        if (dia.abonado && dia.motivo_abono) {
          const abonoTexto = { 
            'servico_externo': 'ABONADO: Serv.Externo', 
            'reincidencia_descanso': 'ABONADO: Reinc.Desc', 
            'reincidencia_ponto': 'ABONADO: Reinc.Ponto' 
          }[dia.motivo_abono] || `ABONADO: ${dia.motivo_abono}`;
          situacaoCompleta.push(abonoTexto);
        }
        
        // Juntar situação - siglas (legenda no rodapé), sem truncar; autoTable quebra linha
        let situacaoTexto = abreviarSituacao(stripEmojis(situacaoCompleta.filter(s => s).join(' | ')));
        if (!situacaoTexto) situacaoTexto = '-';
        
        // Determinar STATUS visual
        let statusTipo = 'ok';
        if (isDiaFolga) {
          statusTipo = situacaoLower.includes('feriado') ? 'feriado' : 'folga';
        } else if (situacaoLower.includes('falta') || situacaoLower.includes('sem apontamento')) {
          statusTipo = 'falta';
        } else if (situacaoLower.includes('atraso') || dia.atraso_minutos > 0) {
          statusTipo = 'atraso';
        } else if (dia.abonado) {
          statusTipo = 'abono';
        } else if (dia.entrada && dia.saida) {
          statusTipo = 'ok';
        } else if (dia.entrada || dia.saida) {
          statusTipo = 'incompleto';
        }
        
        // Extrair extras DIURNAS e NOTURNAS separadas
        const extra50Diurna = dia.extra_50_diurna_minutos || 0;
        const extra50Noturna = dia.extra_50_noturna_minutos || 0;
        const extra100Diurna = dia.extra_100_diurna_minutos || 0;
        const extra100Noturna = dia.extra_100_noturna_minutos || 0;
        
        // Origem da marcação: sem marca = batida real | (i) = informado/manual | (p) = presumido
        const marcaOrigem = (src) => dia.registro_presumido ? ' (p)' : (src === 'manual' ? ' (i)' : '');
        
        return {
          data: formatDate(dia.data),
          dia: dia.dia_semana?.substring(0, 3).toUpperCase() || '-',
          escala: isDiaFolga ? (isFeriado ? 'FERIADO' : 'FOLGA') : (isFeriadoTrabalhado ? `FERIADO\n${escalaCompleta}` : escalaCompleta),
          previsto: isDiaFolga ? '-' : (dia.previsto || '-'),
          entrada: isDiaFolga ? '-' : (dia.entrada ? `${dia.entrada}${marcaOrigem(dia.entrada_source)}` : '-'),
          saida: isDiaFolga ? '-' : (dia.saida ? `${dia.saida}${marcaOrigem(dia.saida_source)}` : '-'),
          entradaReal: !isDiaFolga && !!dia.entrada && dia.entrada_source !== 'manual' && !dia.registro_presumido,
          saidaReal: !isDiaFolga && !!dia.saida && dia.saida_source !== 'manual' && !dia.registro_presumido,
          trabalhado: isDiaFolga ? '-' : formatMinutes(dia.trabalhado_minutos),
          banco: isDiaFolga ? '-' : formatMinutes(dia.banco_minutos),
          banco0809: (dia.banco_0809_minutos || 0) !== 0 ? formatMinutes(dia.banco_0809_minutos) : (isDiaFolga ? '-' : '00:00'),
          bancoNormal: isDiaFolga ? '-' : formatMinutes((dia.banco_minutos || 0) - (dia.banco_0809_minutos || 0)),
          bancoMinutos: dia.banco_minutos || 0,
          e50d: isDiaFolga ? '-' : formatMinutes(extra50Diurna),
          e50n: isDiaFolga ? '-' : formatMinutes(extra50Noturna),
          e100d: isDiaFolga ? '-' : formatMinutes(extra100Diurna),
          e100n: isDiaFolga ? '-' : formatMinutes(extra100Noturna),
          noturno: isDiaFolga ? '-' : formatMinutes(dia.adicional_noturno_minutos || 0),
          intraj: isDiaFolga ? '-' : formatMinutes((dia.intrajornada_minutos || 0) + (dia.intrajornada_suprimida_minutos || 0)),
          interj: isDiaFolga ? '-' : formatMinutes(dia.interjornada_minutos || 0),
          situacao: situacaoTexto,
          obsDia: obsDiaTexto,
          obsRevisor: obsRevisorTexto,
          obsAssinavel: stripEmojis(dia.obs_assinavel || '').trim(),
          statusTipo: statusTipo,
          isFolga: isDiaFolga,
          isFeriadoTrabalhado: isFeriadoTrabalhado,
          // Guardar valores para coloração
          extra50DiurnaMin: extra50Diurna,
          extra50NoturnaMin: extra50Noturna,
          extra100DiurnaMin: extra100Diurna,
          extra100NoturnaMin: extra100Noturna,
          noturnoMin: dia.adicional_noturno_minutos || 0
        };
      });
      
      // Converter para array simples - COM ESCALA E SITUAÇÃO
      const tableDataArray = tableData.map(row => [
        row.data,
        row.dia,
        row.escala,
        row.previsto,
        row.entrada,
        row.saida,
        row.trabalhado,
        row.banco0809,
        row.bancoNormal,
        row.banco,
        row.e50d,
        row.e50n,
        row.e100d,
        row.e100n,
        row.noturno,
        row.intraj,
        row.interj,
        row.situacao + (row.obsDia ? `\nOBS: ${row.obsDia}` : '') + (row.obsRevisor ? `\nREV: ${row.obsRevisor}` : '')
      ]);
      
      // Adicionar linha de TOTAIS no final - formato compacto para evitar quebra
      const formatCompact = (val) => {
        if (!val || val === '00:00') return '0';
        // Converter "HH:MM" para "HHhMM" para evitar quebra no ":"
        return val.replace(':', 'h');
      };
      
      const totaisRow = [
        'TOTAIS',
        '',
        '',
        '',
        '',
        '',
        formatCompact(jornada.resumo.trabalhado),
        formatCompact(jornada.resumo.banco_0809),
        formatCompact(jornada.resumo.banco_normal),
        formatCompact(jornada.resumo.banco_horas),
        formatCompact(jornada.resumo.extra_50_diurna),
        formatCompact(jornada.resumo.extra_50_noturna),
        formatCompact(jornada.resumo.extra_100_diurna),
        formatCompact(jornada.resumo.extra_100_noturna),
        formatCompact(jornada.resumo.adicional_noturno),
        formatCompact(formatMinutes((jornada.resumo.intrajornada_minutos || 0) + (jornada.resumo.intrajornada_suprimida_minutos || 0))),
        formatCompact(jornada.resumo.interjornada_horas),
        ''
      ];
      tableDataArray.push(totaisRow);
      
      // Gerar tabela com autoTable - COM ESCALA E SITUAÇÃO
      autoTable(doc, {
        head: [[
          'DATA', 
          'DIA', 
          'ESCALA/REF',
          'PREV.\n(contrato)',
          'ENT.', 
          'SAÍDA', 
          'TRAB.', 
          'BH\n8-9h', 
          'BH\nNORM', 
          'BH\nTOT', 
          'E50D',
          'E50N',
          'E100D',
          'E100N',
          'NOT.', 
          'INTRAJ',
          'INTERJ',
          'SITUAÇÃO/OBS'
        ]],
        body: tableDataArray,
        startY: yPos,
        margin: { left: marginLeft, right: marginRight, bottom: marginBottom },
        styles: { 
          fontSize: 5.5,
          cellPadding: 1.5, 
          overflow: 'linebreak',
          cellWidth: 'wrap',
          lineWidth: 0.2,
          lineColor: [180, 180, 180],
          halign: 'center',
          valign: 'middle',
          minCellHeight: 6
        },
        headStyles: { 
          fillColor: [51, 65, 85],
          textColor: 255, 
          fontStyle: 'bold', 
          fontSize: 5,
          halign: 'center',
          valign: 'middle'
        },
        columnStyles: {
          0: { cellWidth: 10 },   // Data
          1: { cellWidth: 8 },    // Dia
          2: { cellWidth: 14, halign: 'left', fontSize: 4.5, overflow: 'linebreak' },  // Escala/Ref
          3: { cellWidth: 13, fontSize: 4.2 },  // Previsto (contrato)
          4: { cellWidth: 11, fontSize: 5 },   // Entrada
          5: { cellWidth: 11, fontSize: 5 },   // Saída
          6: { cellWidth: 10 },   // Trabalhado
          7: { cellWidth: 9 },    // BH 8-9h
          8: { cellWidth: 9 },    // BH Normal
          9: { cellWidth: 10 },   // BH Total
          10: { cellWidth: 8.5 },  // E50D
          11: { cellWidth: 8.5 }, // E50N
          12: { cellWidth: 8.5 }, // E100D
          13: { cellWidth: 8.5 }, // E100N
          14: { cellWidth: 8.5 }, // Noturno
          15: { cellWidth: 8.5 }, // Intrajornada
          16: { cellWidth: 8.5 }, // Interjornada
          17: { cellWidth: 'auto', halign: 'left', fontSize: 4.5, overflow: 'linebreak', minCellWidth: 26 }  // Situação - texto completo com wrap
        },
        alternateRowStyles: { fillColor: [252, 252, 254] },
        rowPageBreak: 'avoid',
        showHead: 'everyPage',
        didParseCell: function(data) {
          const rowIndex = data.row.index;
          const rowData = tableData[rowIndex];
          const isLastRow = rowIndex === tableDataArray.length - 1;
          
          // Helper: Verificar se valor é zero/vazio
          const isZeroValue = (val) => {
            if (!val || val === '-') return true;
            const strVal = String(val).trim().toLowerCase();
            return strVal === '0' || strVal === '00:00' || strVal === '0h00' || 
                   strVal === '0h0' || strVal === '00h00' || strVal === '-0h00';
          };
          
          // Cor cinza padrão para zeros
          const grayColor = [180, 180, 180];
          
          // Estilizar linha de TOTAIS - impedir quebra de texto
          if (isLastRow && data.section === 'body') {
            data.cell.styles.fillColor = [30, 58, 95];
            data.cell.styles.textColor = [255, 255, 255];
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.fontSize = 5.5;
            data.cell.styles.overflow = 'visible'; // Impede quebra de linha nos totais
            data.cell.styles.cellWidth = 'wrap';
            
            // Colorir banco de horas na linha de totais (colunas 7-9)
            if (data.column.index >= 7 && data.column.index <= 9) {
              const rawTot = String(data.cell.raw || '');
              if (rawTot.startsWith('-')) {
                data.cell.styles.textColor = [252, 165, 165];
              } else if (rawTot && rawTot !== '0' && rawTot !== '00h00') {
                data.cell.styles.textColor = [134, 239, 172];
              }
            }
            return;
          }
          
          // ===== APLICAR CINZA PARA VALORES ZERO EM COLUNAS NUMÉRICAS =====
          // Colunas 4-16: Entrada, Saída, Trabalhado, BH 8-9, BH Norm, BH Tot, E50D, E50N, E100D, E100N, Noturno, Intraj, Interj
          if (data.column.index >= 4 && data.column.index <= 16 && data.section === 'body' && rowData) {
            const val = data.cell.raw;
            
            // Se é valor zero, aplicar cinza
            if (isZeroValue(val)) {
              data.cell.styles.textColor = grayColor;
              // Não retornar, permitir que lógicas específicas sobrescrevam se necessário
            }
          }
          
          // Colorir ESCALA/PREVISTO (coluna 2) - indigo para destaque
          if (data.column.index === 2 && data.section === 'body' && rowData) {
            if (rowData.isFolga) {
              data.cell.styles.textColor = [100, 116, 139]; // slate
              data.cell.styles.fillColor = [248, 250, 252];
            } else if (data.cell.raw && data.cell.raw !== '-' && !data.cell.raw.includes('FOLGA') && !data.cell.raw.includes('FERIADO')) {
              data.cell.styles.textColor = [79, 70, 229]; // indigo
              data.cell.styles.fontStyle = 'bold';
            } else {
              data.cell.styles.textColor = grayColor;
            }
          }
          
          // Coluna PREVISTO (coluna 3) - slate discreto
          if (data.column.index === 3 && data.section === 'body' && rowData) {
            data.cell.styles.textColor = rowData.isFolga ? grayColor : [71, 85, 105];
          }
          
          // Origem da marcação: ENTRADA/SAÍDA (colunas 4-5) - (i) informado = laranja | (p) presumido = âmbar
          if ((data.column.index === 4 || data.column.index === 5) && data.section === 'body' && rowData) {
            const rawVal = String(data.cell.raw || '');
            if (rawVal.includes('(p)')) {
              data.cell.styles.textColor = [180, 83, 9];
              data.cell.styles.fontStyle = 'bold';
            } else if (rawVal.includes('(i)')) {
              data.cell.styles.textColor = [234, 88, 12];
              data.cell.styles.fontStyle = 'bold';
            }
          }
          
          // Colorir células de banco de horas (colunas 7-9: 8-9h, Normal, Total)
          if (data.column.index >= 7 && data.column.index <= 9 && data.section === 'body' && rowData) {
            const val = data.cell.raw;
            
            if (isZeroValue(val)) {
              data.cell.styles.textColor = grayColor;
            } else if (String(val).startsWith('-')) {
              data.cell.styles.textColor = [220, 38, 38]; // red
              data.cell.styles.fontStyle = 'bold';
            } else {
              data.cell.styles.textColor = [22, 163, 74]; // green
              data.cell.styles.fontStyle = 'bold';
            }
          }
          
          // Colorir células de horas extras E50D, E50N, E100D, E100N (colunas 10-13)
          if (data.column.index >= 10 && data.column.index <= 13 && data.section === 'body' && rowData) {
            const val = data.cell.raw;
            if (!isZeroValue(val)) {
              // Noturnas em roxo, diurnas em azul
              if (data.column.index === 11 || data.column.index === 13) {
                data.cell.styles.textColor = [139, 92, 246]; // purple
              } else {
                data.cell.styles.textColor = [59, 130, 246]; // blue
              }
              data.cell.styles.fontStyle = 'bold';
            }
            // else: já foi colorido em cinza acima
          }
          
          // Colorir noturno (coluna 14)
          if (data.column.index === 14 && data.section === 'body' && rowData) {
            const val = data.cell.raw;
            if (!isZeroValue(val)) {
              data.cell.styles.textColor = [139, 92, 246]; // purple
              data.cell.styles.fontStyle = 'bold';
            }
            // else: já foi colorido em cinza acima
          }
          
          // Colorir intrajornada e interjornada (colunas 15-16) - laranja quando houver valor
          if ((data.column.index === 15 || data.column.index === 16) && data.section === 'body' && rowData) {
            const val = data.cell.raw;
            if (!isZeroValue(val)) {
              data.cell.styles.textColor = [234, 88, 12]; // orange
              data.cell.styles.fontStyle = 'bold';
            }
          }
          
          // Colorir coluna SITUAÇÃO (coluna 17) baseado no conteúdo (siglas)
          if (data.column.index === 17 && data.section === 'body' && rowData) {
            const situacao = (rowData.situacao || '').toLowerCase();
            
            // Colorir baseado no conteúdo
            if (situacao.includes('fb-p') || situacao.includes('presumido')) {
              data.cell.styles.textColor = [180, 83, 9]; // amber - registro manual presumido (não é irregularidade grave)
              data.cell.styles.fillColor = [255, 251, 235];
            } else if (situacao.includes('falta') || situacao.includes('flt') || /\bfb\b/.test(situacao) || situacao.includes('fb-r') || situacao.includes('irreg')) {
              data.cell.styles.textColor = [220, 38, 38]; // vermelho
              data.cell.styles.fillColor = [254, 242, 242];
            } else if (situacao.includes('atraso') || situacao.includes('atr:') || situacao.includes('atr-ab')) {
              data.cell.styles.textColor = [180, 83, 9]; // amber
              data.cell.styles.fillColor = [255, 251, 235];
            } else if (situacao.includes('extra 100') || situacao.includes('e100')) {
              data.cell.styles.textColor = [139, 92, 246]; // roxo
            } else if (situacao.includes('extra 50') || situacao.includes('e50')) {
              data.cell.styles.textColor = [59, 130, 246]; // azul
            } else if (situacao.includes('interjornada') || situacao.includes('intraj') || /\bij\b/.test(situacao) || situacao.includes('is 1h') || situacao.includes('jn (')) {
              data.cell.styles.textColor = [234, 88, 12]; // orange
            } else if (situacao.includes('abono') || situacao.includes('ab:') || situacao.includes('abn')) {
              data.cell.styles.textColor = [6, 182, 212]; // cyan
            } else if (situacao.includes('folga') || situacao.includes('feriado') || rowData.isFolga) {
              data.cell.styles.textColor = [100, 116, 139]; // slate
              data.cell.styles.fillColor = [248, 250, 252];
            }
          }
          
          // Linhas de folga com fundo levemente diferente
          if (rowData?.isFolga && data.section === 'body' && data.column.index < 2) {
            data.cell.styles.fillColor = [248, 250, 252];
            data.cell.styles.textColor = [160, 160, 160];
          }
        },
        willDrawCell: function(data) {
          // Suprimir desenho padrão da célula SITUAÇÃO quando há obs coloridas (desenho manual no didDrawCell)
          if (data.section !== 'body' || data.column.index !== 17) return;
          const rowData = tableData[data.row.index];
          if (!rowData || (!rowData.obsDia && !rowData.obsRevisor && !rowData.obsAssinavel)) return;
          data.cell.text = [];
        },
        didDrawCell: function(data) {
          // ✓ verde (ZapfDingbats) ao lado da batida real (colunas 4-5)
          if (data.section === 'body' && (data.column.index === 4 || data.column.index === 5)) {
            const rowDataEnt = tableData[data.row.index];
            if (!rowDataEnt) return;
            const ehReal = data.column.index === 4 ? rowDataEnt.entradaReal : rowDataEnt.saidaReal;
            if (ehReal) {
              doc.setFont('zapfdingbats', 'normal');
              doc.setFontSize(4.5);
              doc.setTextColor(22, 163, 74);
              doc.text('4', data.cell.x + data.cell.width - 2.3, data.cell.y + data.cell.height / 2 + 0.7);
              doc.setFont('helvetica', 'normal');
            }
            return;
          }
          // Desenhar manualmente: situação (cor do status) + OBS do dia (laranja) + REV do revisor (lilás)
          if (data.section !== 'body' || data.column.index !== 17) return;
          const rowData = tableData[data.row.index];
          if (!rowData || (!rowData.obsDia && !rowData.obsRevisor && !rowData.obsAssinavel)) return;
          const fontSize = 4.5;
          doc.setFontSize(fontSize);
          doc.setFont('helvetica', 'normal');
          const maxW = data.cell.width - 3;
          const lineH = fontSize * 0.3528 * 1.15;
          let ty = data.cell.y + 1.5 + fontSize * 0.3528 * 0.85;
          const corStatus = Array.isArray(data.cell.styles.textColor)
            ? data.cell.styles.textColor
            : [60, 60, 60];
          const segmentos = [
            { texto: rowData.situacao || '-', cor: corStatus },
            rowData.obsDia ? { texto: `OBS: ${rowData.obsDia}`, cor: [234, 88, 12] } : null,
            rowData.obsRevisor ? { texto: `REV: ${rowData.obsRevisor}`, cor: [147, 51, 234] } : null,
            rowData.obsAssinavel ? { texto: `DECISAO: ${rowData.obsAssinavel}`, cor: [13, 148, 136] } : null
          ].filter(Boolean);
          segmentos.forEach(seg => {
            doc.setTextColor(seg.cor[0], seg.cor[1], seg.cor[2]);
            const linhas = doc.splitTextToSize(seg.texto, maxW);
            linhas.forEach(l => { doc.text(l, data.cell.x + 1.5, ty); ty += lineH; });
          });
        }
      });
      
      const totalPages = doc.internal.getNumberOfPages();
      
      // Código de autenticidade do documento (rastreio de versão impressa)
      const codigoAut = `${String(jornada.funcionario.id || nomeFunc).replace(/-/g, '').slice(0, 6).toUpperCase()}-${selectedYear}${String(selectedMonth).padStart(2, '0')}-${Date.now().toString(36).toUpperCase()}`;
      
      // Legenda de siglas (rodapé de todas as páginas)
      const legendaSiglas1 = 'Legenda: PREV.=jornada contratual (08:00-12:00/13:12-18:00 seg-sex) | ESCALA/REF=contexto operacional (ref. = horario do evento, informativo) | Origem: marca verde=batida real, (i)=horario informado/manual, (p)=presumido pela escala | FB Entrada/Saida=qual batida faltou (sujeito a ADVERTENCIA)';
      const legendaSiglas2 = 'FB-P=registro presumido | FB-R=reincidencia | AB=abonado | ATR=atraso | IS=intraj. suprimida | IJ=interjornada | JN=jornada noturna | IP=intraj. paga | E50/E100=extra 50%/100% | NOT=ad. noturno | BH=banco | IRREG=irregularidade | OBS=obs. do dia (laranja) | REV=obs. do revisor (lilas) | DECISAO=observacao assinavel da revisao (verde-azulado)';
      
      // Adicionar tarja de documento provisório (cabeçalho discreto, não diagonal)
      const addProvisionalBanner = () => {
        if (isCompetenciaAberta) {
          // Tarja no topo da página
          doc.setFillColor(255, 243, 205); // amber-100
          doc.rect(0, 0, pageWidth, 6, 'F');
          doc.setFontSize(7);
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(180, 83, 9); // amber-700
          doc.text('DOCUMENTO PROVISORIO - Competencia em aberto', pageWidth / 2, 4, { align: 'center' });
        }
      };
      
      // Adicionar rodapé em todas as páginas
      for (let i = startPage; i <= totalPages; i++) {
        doc.setPage(i);
        addProvisionalBanner();
        
        // Legenda de siglas
        doc.setFontSize(4);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(130, 130, 130);
        doc.text(legendaSiglas1, pageWidth / 2, pageHeight - 13.5, { align: 'center' });
        doc.text(legendaSiglas2, pageWidth / 2, pageHeight - 11, { align: 'center' });
        
        // Rodapé de auditoria
        doc.setFontSize(6);
        doc.setTextColor(100, 100, 100);
        doc.text(`Emitido por: ${usuarioLogado} - ${dataHoraEmissao} (America/Manaus) - Pagina ${i - startPage + 1} de ${totalPages - startPage + 1}`, pageWidth / 2, pageHeight - 7.5, { align: 'center' });
        
        // Código de autenticidade
        doc.setFontSize(5);
        doc.setTextColor(150, 150, 150);
        doc.text(`Autenticacao: ${codigoAut}`, pageWidth / 2, pageHeight - 4, { align: 'center' });
      }
      
      // Adicionar área de assinatura na última página (APENAS DO FUNCIONÁRIO)
      doc.setPage(totalPages);
      const lastY = doc.lastAutoTable?.finalY || pageHeight - 50;
      if (lastY < pageHeight - 30) {
        const assinaturaY = lastY + 18;
        
        // Linha de assinatura centralizada
        doc.setDrawColor(120, 120, 120);
        doc.setLineWidth(0.4);
        doc.line(pageWidth / 2 - 45, assinaturaY, pageWidth / 2 + 45, assinaturaY);
        
        // Texto abaixo da linha
        doc.setFontSize(7);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(80, 80, 80);
        doc.text('Assinatura do Colaborador', pageWidth / 2, assinaturaY + 4, { align: 'center' });
        
        // Nome do funcionário abaixo
        doc.setFontSize(6);
        doc.setTextColor(120, 120, 120);
        doc.text(nomeFunc, pageWidth / 2, assinaturaY + 8, { align: 'center' });
      }
  };

  const handleExportPDF = async () => {
    if (!jornadaData) return;
    
    setExportingPdf(true);
    try {
      const mesNome = months.find(m => m.value === selectedMonth)?.label;
      const isCompetenciaAberta = competenciaStatus !== 'fechada';
      
      // Data/hora de emissão no fuso America/Manaus (UTC-4), via Intl (sem cálculo manual)
      const dataHoraEmissao = new Date().toLocaleString('pt-BR', {
        timeZone: 'America/Manaus',
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
      
      const userInfo = JSON.parse(localStorage.getItem('user') || '{}');
      const usuarioLogado = userInfo.name || userInfo.email || 'Administrador';
      
      const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      renderEspelhoPDF(doc, jornadaData, { mesNome, dataHoraEmissao, usuarioLogado, isCompetenciaAberta });
      
      const nomeArquivo = jornadaData.funcionario.nome.replace(/\s+/g, '_');
      salvarPdf(doc, `espelho_ponto_${nomeArquivo}_${mesNome}_${selectedYear}.pdf`);
      
      toast.success('PDF exportado com sucesso!');
    } catch (error) {
      console.error('Erro ao exportar PDF:', error);
      toast.error('Erro ao gerar PDF');
    } finally {
      setExportingPdf(false);
    }
  };

  // Exportar PDF Consolidado (todos os CLTs)
  const handleExportPDFConsolidado = async () => {
    setExportingPdfConsolidado(true);
    try {
      const mesNome = months.find(m => m.value === selectedMonth)?.label;
      
      // Buscar resumo consolidado do mês
      const resumoRes = await api.get(`/dashboard/clt-resumo-mes?mes=${selectedMonth}&ano=${selectedYear}`);
      const resumoMes = resumoRes.data;
      
      // Data/hora de emissão no fuso America/Manaus (UTC-4), via Intl (sem cálculo manual)
      const dataHoraEmissao = new Date().toLocaleString('pt-BR', {
        timeZone: 'America/Manaus',
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
      
      const userInfo = JSON.parse(localStorage.getItem('user') || '{}');
      const usuarioLogado = userInfo.name || userInfo.email || 'Administrador';
      
      // Criar documento PDF (A4 Portrait)
      const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginLeft = 10;
      const marginRight = 10;
      const marginTop = 10;
      const marginBottom = 15;
      const contentWidth = pageWidth - marginLeft - marginRight;
      
      let yPos = marginTop;
      
      // === PÁGINA 1: CAPA COM RESUMO GERAL ===
      
      // Título
      doc.setFontSize(20);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(30, 64, 175);
      doc.text('RELATORIO CONSOLIDADO', pageWidth / 2, yPos + 10, { align: 'center' });
      doc.setFontSize(16);
      doc.text(`PONTO CLT - ${mesNome?.toUpperCase()}/${selectedYear}`, pageWidth / 2, yPos + 20, { align: 'center' });
      
      yPos += 35;
      
      // Cards do Resumo Geral removidos a pedido do usuário (2026-08) — direto para a tabela por funcionário
      
      // Tabela de funcionários com resumo
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(71, 85, 105);
      doc.text('RESUMO POR FUNCIONARIO', marginLeft, yPos);
      yPos += 5;
      
      const tableData = (resumoMes.funcionarios || []).map(f => [
        f.nome,
        `${f.dias_trabalhados}d`,
        `${f.trabalhado_horas}h`,
        `${f.banco_horas >= 0 ? '+' : ''}${f.banco_horas}h`,
        `${f.extra_50_horas}h`,
        `${f.extra_100_horas}h`,
        f.irregularidades?.length > 0 ? f.irregularidades.join(', ') : 'OK'
      ]);
      
      autoTable(doc, {
        head: [['Funcionário', 'Dias', 'Trab.', 'Banco', 'E50%', 'E100%', 'Irregularidades']],
        body: tableData,
        startY: yPos,
        margin: { left: marginLeft, right: marginRight },
        styles: { fontSize: 7, cellPadding: 2 },
        headStyles: { fillColor: [30, 64, 175], textColor: 255, fontStyle: 'bold' },
        columnStyles: {
          0: { cellWidth: 50 },
          6: { cellWidth: 45, fontSize: 6 }
        },
        didParseCell: (data) => {
          // Colorir irregularidades em vermelho, OK em verde
          if (data.column.index === 6 && data.section === 'body') {
            if (data.cell.raw === 'OK') {
              data.cell.styles.textColor = [16, 185, 129];
            } else {
              data.cell.styles.textColor = [239, 68, 68];
            }
          }
          // Colorir banco negativo em vermelho
          if (data.column.index === 3 && data.section === 'body') {
            if (data.cell.raw.startsWith('-')) {
              data.cell.styles.textColor = [239, 68, 68];
            } else {
              data.cell.styles.textColor = [16, 185, 129];
            }
          }
        }
      });
      
      // Rodapé da capa
      doc.setFontSize(7);
      doc.setTextColor(156, 163, 175);
      doc.text(`Emitido em: ${dataHoraEmissao} por ${usuarioLogado}`, pageWidth / 2, pageHeight - 8, { align: 'center' });
      
      // === PÁGINAS SEGUINTES: ESPELHO COMPLETO DE CADA FUNCIONÁRIO (layout idêntico ao individual) ===
      const isCompetenciaAberta = competenciaStatus !== 'fechada';
      toast.info(`Gerando espelhos individuais... (0/${resumoMes.funcionarios?.length || 0})`);
      
      for (let idx = 0; idx < (resumoMes.funcionarios || []).length; idx++) {
        const func = resumoMes.funcionarios[idx];
        
        try {
          // Buscar dados de jornada do funcionário (mesma fonte do PDF individual)
          const jornadaRes = await api.get(`/reports/jornada-clt/${func.human_id}?mes=${selectedMonth}&ano=${selectedYear}`);
          const jornadaFunc = jornadaRes.data;
          
          if (!jornadaFunc || !jornadaFunc.dias) continue;
          
          doc.addPage();
          const startPage = doc.internal.getNumberOfPages();
          renderEspelhoPDF(doc, jornadaFunc, { mesNome, dataHoraEmissao, usuarioLogado, isCompetenciaAberta, startPage });
        } catch (err) {
          console.error(`Erro ao gerar espelho para ${func.nome}:`, err);
        }
        
        // Atualizar progresso
        if ((idx + 1) % 3 === 0) {
          toast.info(`Gerando espelhos... (${idx + 1}/${resumoMes.funcionarios.length})`);
        }
      }
      
      // Salvar PDF
      salvarPdf(doc, `ponto_consolidado_${mesNome}_${selectedYear}.pdf`);
      toast.success('PDF consolidado exportado com sucesso!');
      
    } catch (error) {
      console.error('Erro ao exportar PDF consolidado:', error);
      toast.error('Erro ao gerar PDF consolidado');
    } finally {
      setExportingPdfConsolidado(false);
    }
  };

  // ========== EXPORTAR FOLHA CONTADOR (Resumo para Contabilidade) ==========
  // Download robusto: se o download direto for bloqueado (iframe/webview), abre o PDF em nova aba
  const salvarPdf = (doc, filename) => {
    const emIframe = (() => { try { return window.self !== window.top; } catch (e) { return true; } })();
    if (emIframe) {
      const url = URL.createObjectURL(doc.output('blob'));
      const w = window.open(url, '_blank');
      if (!w) {
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      return;
    }
    doc.save(filename);
  };

  const handleExportFolhaContador = async () => {
    if (cltHumans.length === 0) {
      toast.error('Nenhum funcionário CLT encontrado');
      return;
    }
    
    setExportingFolhaContador(true);
    
    try {
      const mesNome = months.find(m => m.value === selectedMonth)?.label || String(selectedMonth);
      
      // Carregar configuração da competência (decisão de não descontar)
      let cfgComp = { nao_descontar_faltas: false, nao_descontar_banco: false };
      try {
        const cfgRes = await api.get(`/folha-config/${selectedYear}/${selectedMonth}`);
        cfgComp = cfgRes.data || cfgComp;
      } catch (e) { /* usa default */ }
      
      const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
      
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginLeft = 8;
      const marginRight = 8;
      const marginTop = 12;
      
      // Carregar dados de todos os CLTs
      const funcionariosData = [];
      
      for (const human of cltHumans) {
        try {
          const res = await api.get(`/reports/jornada-clt/${human.id}`, {
            params: { mes: selectedMonth, ano: selectedYear }
          });
          
          if (res.data?.resumo) {
            funcionariosData.push({
              nome: human.nome || human.name,
              ...res.data.resumo
            });
          }
        } catch (err) {
          console.warn(`Erro ao carregar dados de ${human.nome}:`, err);
        }
      }
      
      // FILTRAR: Remover funcionários sem dados no mês (ex: ainda não admitidos)
      const funcionariosComDados = funcionariosData.filter(func => {
        // Tem dados se: trabalhou algum dia OU tem banco de horas OU tem extras OU tem faltas
        const temDados = (func.dias_trabalhados > 0) || 
                         (func.trabalhado_minutos > 0) ||
                         (func.banco_horas_minutos && func.banco_horas_minutos !== 0) ||
                         (func.extra_50_minutos > 0) ||
                         (func.extra_100_minutos > 0) ||
                         (func.adicional_noturno_minutos > 0) ||
                         (func.dias_falta > 0) ||
                         (func.dias_abonados > 0);
        return temDados;
      });
      
      if (funcionariosComDados.length === 0) {
        toast.warning('Nenhum funcionário com dados neste mês. Verifique se há registros de ponto.');
        setExportingFolhaContador(false);
        return;
      }
      
      // Helper para formatar minutos
      const fmtHoras = (min) => {
        if (!min && min !== 0) return '';
        const absMin = Math.abs(min);
        const h = Math.floor(absMin / 60);
        const m = absMin % 60;
        const sign = min < 0 ? '-' : '';
        return `${sign}${h}:${m.toString().padStart(2, '0')}`;
      };
      
      // ===== CABEÇALHO =====
      doc.setFillColor(30, 58, 95);
      doc.rect(0, 0, pageWidth, 20, 'F');
      
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      doc.text(`FOLHA TS ${mesNome.toUpperCase()}/${selectedYear}`, marginLeft, 10);
      
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      doc.text('Computada Hora noturna reduzida', marginLeft, 16);
      
      doc.setFontSize(7);
      doc.text(`Gerado em: ${new Date().toLocaleString('pt-BR', { timeZone: 'America/Manaus' })} (America/Manaus)`, pageWidth - marginRight - 62, 10);
      
      let yPos = 26;
      
      // Nota de decisão da gestão (não descontar)
      if (cfgComp.nao_descontar_faltas || cfgComp.nao_descontar_banco) {
        const itens = [];
        if (cfgComp.nao_descontar_faltas) itens.push('FALTAS/DSR');
        if (cfgComp.nao_descontar_banco) itens.push('BANCO DE HORAS NEGATIVO');
        doc.setFillColor(254, 249, 195);
        doc.rect(marginLeft, yPos - 4, pageWidth - marginLeft - marginRight, 7, 'F');
        doc.setFontSize(7.5);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(146, 64, 14);
        const quem = cfgComp.definido_por ? ` — decisão registrada por ${cfgComp.definido_por}${cfgComp.definido_em ? ' em ' + new Date(cfgComp.definido_em).toLocaleDateString('pt-BR') : ''}` : '';
        doc.text(`DECISÃO DA GESTÃO: ${itens.join(' e ')} NÃO DESCONTADOS nesta competência (valores riscados, mantidos para auditoria)${quem}`, marginLeft + 2, yPos + 0.5);
        yPos += 7;
      }
      
      // ===== TABELA PRINCIPAL =====
      const tableHead = [
        [
          { content: 'Nome do Colaborador', rowSpan: 2, styles: { fillColor: [30, 58, 95], halign: 'left' } },
          { content: 'RECEBÍVEIS', colSpan: 8, styles: { fillColor: [59, 130, 246], halign: 'center' } },
          { content: 'DESCONTOS', colSpan: 5, styles: { fillColor: [239, 68, 68], halign: 'center' } }
        ],
        [
          { content: 'Banco Horas\nQuitar', styles: { fillColor: [30, 64, 175] } },
          { content: 'Ad. Noturno\n(convertido)', styles: { fillColor: [100, 116, 139] } },
          { content: 'E50%\nDiurna', styles: { fillColor: [59, 130, 246] } },
          { content: 'E50%\nNoturna', styles: { fillColor: [59, 130, 246] } },
          { content: 'E100%\nDiurna', styles: { fillColor: [59, 130, 246] } },
          { content: 'E100%\nNoturna', styles: { fillColor: [59, 130, 246] } },
          { content: 'INTRA\nJornada', styles: { fillColor: [59, 130, 246] } },
          { content: 'INTER\nJornada', styles: { fillColor: [59, 130, 246] } },
          { content: 'Faltas\n(dias)', styles: { fillColor: [239, 68, 68] } },
          { content: 'DSR\n(dias)', styles: { fillColor: [239, 68, 68] } },
          { content: 'Banco Horas\nDébito', styles: { fillColor: [239, 68, 68] } },
          { content: 'Abonos', styles: { fillColor: [253, 224, 71], textColor: [0, 0, 0] } },
          { content: 'Obs', styles: { fillColor: [253, 224, 71], textColor: [0, 0, 0] } }
        ]
      ];
      
      const tableBody = funcionariosComDados.map(func => {
        // Banco LÍQUIDO: saldo bruto + bonificação 08-09h perdoada (abate o débito)
        const perdoadas = func.banco_horas_perdoadas_minutos || 0;
        const bancoNet = (func.banco_horas_minutos || 0) + perdoadas;
        const bancoPositivo = bancoNet > 0 ? fmtHoras(bancoNet) : '';
        const bancoNegativo = bancoNet < 0 ? fmtHoras(Math.abs(bancoNet)) : '';
        
        // Faltas (campo correto do resumo)
        const faltas = func.dias_falta || 0;
        const dsr = func.dsr_perdidos || 0;
        
        // Valores com fallback para 0
        const adicNoturno = Math.round(func.adicional_noturno_convertido || func.adicional_noturno_minutos || 0);
        const e50d = func.extra_50_diurna_minutos || 0;
        const e50n = func.extra_50_noturna_minutos || 0;
        const e100d = func.extra_100_diurna_minutos || 0;
        const e100n = func.extra_100_noturna_minutos || 0;
        const intra = (func.intrajornada_minutos || 0) + (func.intrajornada_suprimida_minutos || 0);
        const inter = func.interjornada_minutos || 0;
        const abonos = func.dias_abonados || 0;
        
        // Observações automáticas para auditoria
        const obsParts = [];
        if ((func.dias_registro_presumido || 0) > 0) obsParts.push(`FB-P: ${func.dias_registro_presumido}d`);
        if (perdoadas > 0) {
          const bruto = func.banco_horas_minutos || 0;
          const sinal = (m) => `${m < 0 ? '-' : '+'}${fmtHoras(Math.abs(m))}`;
          obsParts.push(`Banco: bruto ${sinal(bruto)} + bonif. 08-09h ${fmtHoras(perdoadas)} = líquido ${sinal(bancoNet)}`);
        }
        if ((func.irregularidades_count || 0) > 0) obsParts.push(`IRREG: ${func.irregularidades_count}`);
        
        return [
          { content: (func.nome || '').toUpperCase(), styles: { halign: 'left', fontStyle: 'bold' } },
          { content: bancoPositivo, styles: { halign: 'center', fillColor: bancoPositivo ? [219, 234, 254] : null } },
          { content: adicNoturno ? fmtHoras(adicNoturno) : '', styles: { halign: 'center', fillColor: adicNoturno ? [226, 232, 240] : null } },
          { content: e50d ? fmtHoras(e50d) : '', styles: { halign: 'center', fillColor: e50d ? [219, 234, 254] : null } },
          { content: e50n ? fmtHoras(e50n) : '', styles: { halign: 'center', fillColor: e50n ? [219, 234, 254] : null } },
          { content: e100d ? fmtHoras(e100d) : '', styles: { halign: 'center', fillColor: e100d ? [219, 234, 254] : null } },
          { content: e100n ? fmtHoras(e100n) : '', styles: { halign: 'center', fillColor: e100n ? [219, 234, 254] : null } },
          { content: intra ? fmtHoras(intra) : '', styles: { halign: 'center' } },
          { content: inter ? fmtHoras(inter) : '', styles: { halign: 'center' } },
          { content: faltas > 0 ? String(faltas) : '', styles: { halign: 'center', fillColor: faltas > 0 ? [254, 226, 226] : null } },
          { content: dsr > 0 ? String(dsr) : '', styles: { halign: 'center', fillColor: dsr > 0 ? [254, 226, 226] : null } },
          { content: bancoNegativo, styles: { halign: 'center', fillColor: bancoNegativo ? [254, 226, 226] : null } },
          { content: abonos > 0 ? String(abonos) : '', styles: { halign: 'center', fillColor: abonos > 0 ? [254, 249, 195] : null } },
          { content: obsParts.join(' | '), styles: { halign: 'left', fontSize: 5.5 } }
        ];
      });
      
      // ===== LINHA DE TOTAIS =====
      const somar = (fn) => funcionariosComDados.reduce((acc, f) => acc + fn(f), 0);
      const bancoNetDe = (f) => (f.banco_horas_minutos || 0) + (f.banco_horas_perdoadas_minutos || 0);
      const totBancoPos = somar(f => Math.max(0, bancoNetDe(f)));
      const totBancoNeg = somar(f => Math.min(0, bancoNetDe(f)));
      const totNoturno = Math.round(somar(f => f.adicional_noturno_convertido || f.adicional_noturno_minutos || 0));
      const totE50d = somar(f => f.extra_50_diurna_minutos || 0);
      const totE50n = somar(f => f.extra_50_noturna_minutos || 0);
      const totE100d = somar(f => f.extra_100_diurna_minutos || 0);
      const totE100n = somar(f => f.extra_100_noturna_minutos || 0);
      const totIntra = somar(f => (f.intrajornada_minutos || 0) + (f.intrajornada_suprimida_minutos || 0));
      const totInter = somar(f => f.interjornada_minutos || 0);
      const totFaltas = somar(f => f.dias_falta || 0);
      const totDsr = somar(f => f.dsr_perdidos || 0);
      const totAbonos = somar(f => f.dias_abonados || 0);
      
      const totalsStyle = { fontStyle: 'bold', fillColor: [30, 58, 95], textColor: [255, 255, 255], halign: 'center' };
      const tableFoot = [[
        { content: `TOTAIS (${funcionariosComDados.length} colaboradores)`, styles: { ...totalsStyle, halign: 'left' } },
        { content: totBancoPos ? fmtHoras(totBancoPos) : '', styles: totalsStyle },
        { content: totNoturno ? fmtHoras(totNoturno) : '', styles: totalsStyle },
        { content: totE50d ? fmtHoras(totE50d) : '', styles: totalsStyle },
        { content: totE50n ? fmtHoras(totE50n) : '', styles: totalsStyle },
        { content: totE100d ? fmtHoras(totE100d) : '', styles: totalsStyle },
        { content: totE100n ? fmtHoras(totE100n) : '', styles: totalsStyle },
        { content: totIntra ? fmtHoras(totIntra) : '', styles: totalsStyle },
        { content: totInter ? fmtHoras(totInter) : '', styles: totalsStyle },
        { content: totFaltas ? String(totFaltas) : '', styles: totalsStyle },
        { content: totDsr ? String(totDsr) : '', styles: totalsStyle },
        { content: totBancoNeg ? fmtHoras(Math.abs(totBancoNeg)) : '', styles: totalsStyle },
        { content: totAbonos ? String(totAbonos) : '', styles: totalsStyle },
        { content: '', styles: totalsStyle }
      ]];
      
      autoTable(doc, {
        head: tableHead,
        body: tableBody,
        foot: tableFoot,
        startY: yPos,
        margin: { left: marginLeft, right: marginRight },
        styles: {
          fontSize: 7,
          cellPadding: 2,
          lineWidth: 0.3,
          lineColor: [200, 200, 200],
          valign: 'middle'
        },
        headStyles: {
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          fontSize: 6.5
        },
        columnStyles: {
          0: { cellWidth: 50 },  // Nome
          1: { cellWidth: 18 },  // Banco Quitar
          2: { cellWidth: 18 },  // Ad. Noturno
          3: { cellWidth: 15 },  // E50D
          4: { cellWidth: 15 },  // E50N
          5: { cellWidth: 15 },  // E100D
          6: { cellWidth: 15 },  // E100N
          7: { cellWidth: 15 },  // INTRA
          8: { cellWidth: 15 },  // INTER
          9: { cellWidth: 12 },  // Faltas
          10: { cellWidth: 12 }, // DSR
          11: { cellWidth: 18 }, // Banco Débito
          12: { cellWidth: 13 }, // Abonos
          13: { cellWidth: 'auto' }  // Obs
        },
        didParseCell: (data) => {
          // Linha de cabeçalho secundário
          if (data.section === 'head' && data.row.index === 1) {
            data.cell.styles.fontSize = 5.5;
          }
        },
        didDrawCell: (data) => {
          // RISCO em cima dos valores não descontados (decisão da gestão) - registro mantido para auditoria
          if (data.section !== 'body' && data.section !== 'foot') return;
          const colsRiscadas = [];
          if (cfgComp.nao_descontar_faltas) colsRiscadas.push(9, 10); // Faltas, DSR
          if (cfgComp.nao_descontar_banco) colsRiscadas.push(11);     // Banco Débito
          if (!colsRiscadas.includes(data.column.index)) return;
          const texto = Array.isArray(data.cell.text) ? data.cell.text.join('') : String(data.cell.text || '');
          if (!texto.trim()) return;
          doc.setDrawColor(185, 28, 28);
          doc.setLineWidth(0.5);
          const meioY = data.cell.y + data.cell.height / 2;
          doc.line(data.cell.x + 1.5, meioY, data.cell.x + data.cell.width - 1.5, meioY);
        }
      });
      
      // Rodapé
      const finalY = doc.lastAutoTable.finalY + 5;
      doc.setFontSize(6);
      doc.setTextColor(100, 116, 139);
      doc.text('* Valores em horas:minutos. Banco de Horas positivo = crédito do colaborador. Banco negativo = débito (JÁ LÍQUIDO da bonificação 08-09h, quando concedida). Ad. Noturno já convertido (CLT Art.73, 52m30s=1h). INTRA inclui intrajornada suprimida (1h a 50%). DSR = descansos perdidos (1 por semana com falta).', marginLeft, finalY);
      doc.text('Legenda Obs: FB-P = dias com registro manual presumido (escala) | Banco: bruto + bonif. 08-09h = líquido (memória de cálculo do débito) | IRREG = irregularidades no mês. Valores RISCADOS = não descontados por decisão da gestão (registro mantido para auditoria).', marginLeft, finalY + 3.5);
      
      // Rodapé de auditoria em todas as páginas
      const userInfoFC = JSON.parse(localStorage.getItem('user') || '{}');
      const emissorFC = userInfoFC.name || userInfoFC.email || 'Administrador';
      const codigoAutFC = `FC-${selectedYear}${String(selectedMonth).padStart(2, '0')}-${Date.now().toString(36).toUpperCase()}`;
      const totalPagesFC = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPagesFC; i++) {
        doc.setPage(i);
        doc.setFontSize(6);
        doc.setTextColor(120, 120, 120);
        doc.text(`Emitido por: ${emissorFC} - ${new Date().toLocaleString('pt-BR', { timeZone: 'America/Manaus' })} (America/Manaus) - Autenticacao: ${codigoAutFC} - Página ${i}/${totalPagesFC} - Folha Contábil ${mesNome}/${selectedYear}`, pageWidth / 2, pageHeight - 5, { align: 'center' });
      }
      
      // Salvar PDF
      salvarPdf(doc, `folha_contador_${mesNome.toLowerCase()}_${selectedYear}.pdf`);
      toast.success('Folha do Contador exportada com sucesso!');
      
    } catch (error) {
      console.error('Erro ao exportar Folha Contador:', error);
      toast.error('Erro ao gerar Folha do Contador');
    } finally {
      setExportingFolhaContador(false);
    }
  };

  // Fechar competência
  const handleFecharCompetencia = async () => {
    setSavingCompetencia(true);
    try {
      await api.post(`/competencias/${selectedYear}/${selectedMonth}/fechar`);
      setCompetenciaStatus('fechada');
      toast.success(`Competência ${selectedMonth.toString().padStart(2, '0')}/${selectedYear} fechada com sucesso!`);
      // Recarregar dados
      loadJornada();
    } catch (error) {
      console.error('Erro ao fechar competência:', error);
      toast.error(error.response?.data?.detail || 'Erro ao fechar competência');
    } finally {
      setSavingCompetencia(false);
    }
  };

  // Reabrir competência
  const handleReabrirCompetencia = async () => {
    if (!motivoReabertura.trim()) {
      toast.error('Informe o motivo da reabertura');
      return;
    }
    
    setSavingCompetencia(true);
    try {
      await api.post(`/competencias/${selectedYear}/${selectedMonth}/reabrir`, {
        motivo: motivoReabertura
      });
      setCompetenciaStatus('aberta');
      setShowReabrirModal(false);
      setMotivoReabertura('');
      toast.success('Competência reaberta com sucesso!');
      loadJornada();
    } catch (error) {
      console.error('Erro ao reabrir competência:', error);
      toast.error(error.response?.data?.detail || 'Erro ao reabrir competência');
    } finally {
      setSavingCompetencia(false);
    }
  };

  // Salvar texto institucional
  const handleSaveTexto = async (tipo) => {
    if (!textoEditConteudo.trim()) {
      toast.error('O conteúdo não pode estar vazio');
      return;
    }
    
    setSavingTexto(true);
    try {
      const titulo = tipo === 'lembrete' ? 'Lembrete' : 'Cultura';
      await api.put(`/textos-institucionais/${tipo}`, {
        titulo,
        conteudo: textoEditConteudo
      });
      
      setTextosInstitucionais(prev => ({
        ...prev,
        [tipo]: { ...prev[tipo], conteudo: textoEditConteudo }
      }));
      
      setEditingTexto(null);
      setTextoEditConteudo('');
      toast.success(`Texto "${titulo}" atualizado com sucesso!`);
    } catch (error) {
      console.error('Erro ao salvar texto:', error);
      toast.error(error.response?.data?.detail || 'Erro ao salvar texto');
    } finally {
      setSavingTexto(false);
    }
  };

  // Iniciar edição de texto
  const startEditTexto = (tipo) => {
    setEditingTexto(tipo);
    setTextoEditConteudo(textosInstitucionais[tipo]?.conteudo || '');
  };

  // Cancelar edição
  const cancelEditTexto = () => {
    setEditingTexto(null);
    setTextoEditConteudo('');
  };

  // ==================== FUNÇÕES DE UPLOAD AFD ====================
  
  // Processar arquivo AFD
  const handleAfdFileSelect = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setAfdFile(file);
      setAfdResult(null);
      setAfdMapeamento({});
      setAfdAcoes({});
    }
  };

  // Analisar arquivo AFD
  const handleAfdUpload = async () => {
    if (!afdFile) {
      toast.error('Selecione um arquivo AFD');
      return;
    }

    setAfdLoading(true);
    try {
      // Ler conteúdo do arquivo
      const fileContent = await afdFile.text();
      
      // Enviar para análise
      const res = await api.post('/afd/upload', {
        file_content: fileContent,
        mes: selectedMonth,
        ano: selectedYear,
        mapeamento_pis: afdMapeamento
      });

      setAfdResult(res.data);

      if (res.data.status === 'precisa_mapeamento') {
        toast.info('Por favor, mapeie os PIS encontrados para os colaboradores');
      } else if (res.data.status === 'analisado') {
        // Inicializar ações como "ignorar" por padrão
        const acoes = {};
        (res.data.inconsistencias || []).forEach((inc, idx) => {
          acoes[idx] = 'ignorar';
        });
        setAfdAcoes(acoes);
        
        if (res.data.total_inconsistencias === 0) {
          toast.success('Nenhuma inconsistência encontrada!');
        } else {
          toast.warning(`${res.data.total_inconsistencias} inconsistência(s) encontrada(s)`);
        }
      }
    } catch (error) {
      console.error('Erro ao analisar AFD:', error);
      toast.error(error.response?.data?.detail || 'Erro ao processar arquivo AFD');
    } finally {
      setAfdLoading(false);
    }
  };

  // Aplicar correções do AFD
  const handleAfdAplicar = async () => {
    if (!afdResult?.inconsistencias) return;

    const correcoes = afdResult.inconsistencias.map((inc, idx) => ({
      record_id: inc.record_id,
      acao: afdAcoes[idx] || 'ignorar',
      afd_entrada: inc.afd_entrada,
      afd_saida: inc.afd_saida,
      data_iso: inc.data_iso,
      human_id: inc.human_id,
      tipo: inc.tipo
    })).filter(c => c.acao !== 'ignorar');

    if (correcoes.length === 0) {
      toast.info('Nenhuma correção selecionada para aplicar');
      return;
    }

    setApplyingAfd(true);
    try {
      const res = await api.post('/afd/aplicar-correcao', { correcoes });
      toast.success(res.data.message);
      
      // Salvar registro de importação para auditoria
      const correcoesAplicadas = correcoes.filter(c => c.acao === 'usar_afd').length;
      await api.post('/afd/salvar-importacao', {
        mes: selectedMonth,
        ano: selectedYear,
        arquivo_nome: afdFile?.name || 'arquivo.txt',
        empresa_afd: afdResult.empresa_afd || '',
        total_registros: afdResult.total_registros_afd || 0,
        total_inconsistencias: afdResult.total_inconsistencias || 0,
        inconsistencias_resolvidas: correcoesAplicadas,
        mapeamento_usado: afdResult.mapeamento_usado || {}
      });
      
      // Recarregar dados da jornada
      if (selectedHuman) {
        loadJornada();
      }
      
      // Fechar modal
      setShowAfdModal(false);
      setAfdFile(null);
      setAfdResult(null);
      setAfdMapeamento({});
      setAfdAcoes({});
    } catch (error) {
      console.error('Erro ao aplicar correções:', error);
      toast.error(error.response?.data?.detail || 'Erro ao aplicar correções');
    } finally {
      setApplyingAfd(false);
    }
  };

  // Resetar modal AFD
  const resetAfdModal = () => {
    setShowAfdModal(false);
    setAfdFile(null);
    setAfdResult(null);
    setAfdMapeamento({});
    setAfdAcoes({});
  };

  // Obter cor do tipo de inconsistência
  const getInconsistenciaTipoColor = (tipo) => {
    switch (tipo) {
      case 'afd_sem_manual':
        return 'bg-amber-100 text-amber-800 border-amber-200';
      case 'manual_sem_afd':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'horario_diferente':
        return 'bg-red-100 text-red-800 border-red-200';
      default:
        return 'bg-slate-100 text-slate-800 border-slate-200';
    }
  };

  // Obter label do tipo de inconsistência
  const getInconsistenciaTipoLabel = (tipo) => {
    switch (tipo) {
      case 'afd_sem_manual':
        return 'AFD sem apontamento';
      case 'manual_sem_afd':
        return 'Apontamento sem AFD';
      case 'horario_diferente':
        return 'Horário diferente';
      default:
        return tipo;
    }
  };

  // Carregar dados de auditoria
  const loadAuditoria = useCallback(async () => {
    setAuditoriaLoading(true);
    try {
      const res = await api.get(`/ponto/auditoria?mes=${selectedMonth}&ano=${selectedYear}&filtro=${auditoriaFiltro}`);
      setAuditoriaData(res.data);
    } catch (error) {
      console.error('Erro ao carregar auditoria:', error);
      toast.error('Erro ao carregar dados de auditoria');
    } finally {
      setAuditoriaLoading(false);
    }
  }, [selectedMonth, selectedYear, auditoriaFiltro]);

  // Carregar auditoria quando aba for aberta
  useEffect(() => {
    if (showAuditoria) {
      loadAuditoria();
    }
  }, [showAuditoria, loadAuditoria]);

  // Verificar permissão de acesso - apenas admin
  if (!isAdmin) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Card className="max-w-md">
          <CardContent className="py-8 text-center">
            <Shield className="w-16 h-16 mx-auto text-red-400 mb-4" />
            <h2 className="text-xl font-bold text-slate-800 mb-2">Acesso Restrito</h2>
            <p className="text-slate-600">
              Esta página é restrita a administradores.
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (loadingHumans) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="folha-clt-page">
      {/* Header */}
      <div className="flex flex-col gap-4">
        <div>
          <h1 className="text-xl sm:text-2xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
            <FileSpreadsheet className="w-6 h-6 text-blue-600" />
            Ponto CLT com Obs.
          </h1>
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
            Jornada CLT completa com banco de horas, extras e observações - {cltHumans.length} funcionários
          </p>
        </div>

        {/* BLOCO LEMBRETE - Acima do seletor de mês/competência */}
        {textosInstitucionais.lembrete?.conteudo && (
          <div className="bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-4" data-testid="bloco-lembrete">
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1">
                {editingTexto === 'lembrete' ? (
                  <div className="space-y-3">
                    <div className="flex items-center gap-2">
                      <span className="font-semibold text-slate-700 dark:text-slate-300 text-sm">Lembrete.</span>
                    </div>
                    <Textarea
                      value={textoEditConteudo}
                      onChange={(e) => setTextoEditConteudo(e.target.value)}
                      className="min-h-[80px] text-sm"
                      placeholder="Digite o texto do lembrete..."
                    />
                    <div className="flex gap-2">
                      <Button
                        size="sm"
                        onClick={() => handleSaveTexto('lembrete')}
                        disabled={savingTexto}
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                      >
                        {savingTexto ? <Loader2 className="w-3 h-3 animate-spin mr-1" /> : <Save className="w-3 h-3 mr-1" />}
                        Salvar
                      </Button>
                      <Button size="sm" variant="outline" onClick={cancelEditTexto}>
                        Cancelar
                      </Button>
                    </div>
                  </div>
                ) : (
                  <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                    <span className="font-semibold text-slate-700 dark:text-slate-300">Lembrete.</span>{' '}
                    {textosInstitucionais.lembrete.conteudo}
                  </p>
                )}
              </div>
              {editingTexto !== 'lembrete' && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => startEditTexto('lembrete')}
                  className="text-slate-400 hover:text-slate-600 shrink-0"
                  title="Editar texto"
                >
                  <Edit3 className="w-4 h-4" />
                </Button>
              )}
            </div>
          </div>
        )}

        {/* Filtros */}
        <div className="flex flex-wrap items-center gap-2 bg-slate-50 dark:bg-slate-800/50 p-3 rounded-lg">
          <div className="flex items-center gap-1 bg-white dark:bg-slate-700 rounded-lg p-1">
            <Button
              variant={viewMode === 'individual' && !showAuditoria ? 'default' : 'ghost'}
              size="sm"
              onClick={() => { setViewMode('individual'); setShowAuditoria(false); }}
              className="text-xs"
            >
              <User className="w-3 h-3 mr-1" />
              Individual
            </Button>
            <Button
              variant={viewMode === 'todos' && !showAuditoria ? 'default' : 'ghost'}
              size="sm"
              onClick={() => { setViewMode('todos'); setShowAuditoria(false); }}
              className="text-xs"
            >
              <Users className="w-3 h-3 mr-1" />
              Todos CLT
            </Button>
            <Button
              variant={showAuditoria ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setShowAuditoria(true)}
              className="text-xs"
              data-testid="btn-auditoria"
            >
              <Shield className="w-3 h-3 mr-1" />
              Auditoria
            </Button>
          </div>

          {viewMode === 'individual' && !showAuditoria && (
            <Select value={selectedHuman || ''} onValueChange={setSelectedHuman}>
              <SelectTrigger className="w-56 bg-white dark:bg-slate-700">
                <SelectValue placeholder="Selecione CLT..." />
              </SelectTrigger>
              <SelectContent>
                {cltHumans.map((h) => (
                  <SelectItem key={h.id} value={h.id}>
                    {h.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}

          <div className="flex items-center gap-1">
            <Button variant="outline" size="icon" onClick={handlePreviousMonth} className="h-9 w-9">
              <ChevronLeft className="w-4 h-4" />
            </Button>
            
            <Select value={String(selectedMonth)} onValueChange={(v) => setSelectedMonth(Number(v))}>
              <SelectTrigger className="w-28 bg-white dark:bg-slate-700">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {months.map((m) => (
                  <SelectItem key={m.value} value={String(m.value)}>
                    {m.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            <Select value={String(selectedYear)} onValueChange={(v) => setSelectedYear(Number(v))}>
              <SelectTrigger className="w-20 bg-white dark:bg-slate-700">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {years.map((y) => (
                  <SelectItem key={y} value={String(y)}>
                    {y}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            <Button variant="outline" size="icon" onClick={handleNextMonth} className="h-9 w-9">
              <ChevronRight className="w-4 h-4" />
            </Button>
          </div>

          {/* Botões que sempre aparecem (não dependem de funcionário selecionado) */}
          <div className="flex items-center gap-2">
            {/* Botão Exportar Folha Contador - SEMPRE visível */}
            <Button
              onClick={handleExportFolhaContador}
              disabled={exportingFolhaContador || cltHumans.length === 0}
              variant="outline"
              className="border-amber-600 text-amber-700 hover:bg-amber-50"
              title="Exportar Folha TS para o Contador (resumo de todos os CLTs)"
            >
              {exportingFolhaContador ? (
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              ) : (
                <DollarSign className="w-4 h-4 mr-2" />
              )}
              Folha Contador
            </Button>
            
            {/* Botão Config da Competência (não descontar faltas/banco) */}
            <Button
              onClick={openFolhaConfigModal}
              variant="outline"
              size="icon"
              className="border-amber-600 text-amber-700 hover:bg-amber-50"
              title="Configurar competência: não descontar faltas / banco negativo"
              data-testid="folha-config-btn"
            >
              <Settings2 className="w-4 h-4" />
            </Button>
            
            {/* Botão Exportar PDF Consolidado (todos os CLTs) - SEMPRE visível */}
            <Button
              onClick={handleExportPDFConsolidado}
              disabled={exportingPdfConsolidado || cltHumans.length === 0}
              variant="outline"
              className="border-purple-600 text-purple-600 hover:bg-purple-50"
              title="Exportar PDF com resumo geral + ponto de todos os CLTs"
            >
              {exportingPdfConsolidado ? (
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              ) : (
                <Users className="w-4 h-4 mr-2" />
              )}
              PDF Todos
            </Button>
          </div>

          {jornadaData && (
            <div className="flex items-center gap-2">
              {/* Botão Exportar CSV */}
              <Button
                onClick={handleExportCSV}
                variant="outline"
                className="border-green-600 text-green-600 hover:bg-green-50"
              >
                <Download className="w-4 h-4 mr-2" />
                CSV
              </Button>
              
              {/* Botão Exportar PDF */}
              <Button
                onClick={handleExportPDF}
                disabled={exportingPdf}
                className="bg-red-600 hover:bg-red-700 text-white"
              >
                {exportingPdf ? (
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                ) : (
                  <FileDown className="w-4 h-4 mr-2" />
                )}
                PDF
              </Button>
              
              {/* Botão Importar AFD */}
              <Button
                onClick={() => setShowAfdModal(true)}
                variant="outline"
                className="border-amber-500 text-amber-600 hover:bg-amber-50"
                title="Importar arquivo AFD do relógio de ponto"
                data-testid="btn-importar-afd"
              >
                <FileUp className="w-4 h-4 mr-2" />
                Importar AFD
              </Button>
              
              {/* Controle de Competência */}
              {competenciaStatus === 'aberta' ? (
                <Button
                  onClick={handleFecharCompetencia}
                  disabled={savingCompetencia}
                  variant="outline"
                  className="border-orange-500 text-orange-600 hover:bg-orange-50"
                >
                  {savingCompetencia ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  ) : (
                    <Lock className="w-4 h-4 mr-2" />
                  )}
                  Fechar Mês
                </Button>
              ) : (
                <Button
                  onClick={() => setShowReabrirModal(true)}
                  disabled={savingCompetencia}
                  variant="outline"
                  className="border-purple-500 text-purple-600 hover:bg-purple-50"
                >
                  <Unlock className="w-4 h-4 mr-2" />
                  Reabrir
                </Button>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Conteúdo */}
      {loading ? (
        <div className="flex items-center justify-center py-12">
          <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
        </div>
      ) : showAuditoria ? (
        /* === ABA DE AUDITORIA === */
        <Card className="dark:bg-slate-800/50 dark:border-slate-700">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-lg">
              <Shield className="w-5 h-5 text-purple-600" />
              Auditoria de Ponto - {months.find(m => m.value === selectedMonth)?.label}/{selectedYear}
            </CardTitle>
          </CardHeader>
          <CardContent>
            {/* Filtros de Auditoria */}
            <div className="flex items-center gap-4 mb-6">
              <Label className="text-sm font-medium">Filtrar por:</Label>
              <Select value={auditoriaFiltro} onValueChange={setAuditoriaFiltro}>
                <SelectTrigger className="w-48">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="todos">Todos</SelectItem>
                  <SelectItem value="divergencias">Apenas Divergências AFD</SelectItem>
                  <SelectItem value="alteracoes_suporte">Apenas Alterações do Suporte</SelectItem>
                </SelectContent>
              </Select>
              <Button variant="outline" size="sm" onClick={loadAuditoria} disabled={auditoriaLoading}>
                {auditoriaLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />}
              </Button>
            </div>

            {auditoriaLoading ? (
              <div className="flex items-center justify-center py-12">
                <Loader2 className="w-8 h-8 animate-spin text-purple-600" />
              </div>
            ) : auditoriaData ? (
              <div className="space-y-6">
                {/* Resumo */}
                <div className="grid grid-cols-3 gap-4">
                  <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 text-center">
                    <p className="text-3xl font-bold text-blue-700">{auditoriaData.resumo?.total_importacoes || 0}</p>
                    <p className="text-sm text-blue-600">Importações AFD</p>
                  </div>
                  <div className="bg-amber-50 dark:bg-amber-900/20 rounded-lg p-4 text-center">
                    <p className="text-3xl font-bold text-amber-700">{auditoriaData.resumo?.total_alteracoes_suporte || 0}</p>
                    <p className="text-sm text-amber-600">Alterações do Suporte</p>
                  </div>
                  <div className="bg-red-50 dark:bg-red-900/20 rounded-lg p-4 text-center">
                    <p className="text-3xl font-bold text-red-700">{auditoriaData.resumo?.total_divergencias || 0}</p>
                    <p className="text-sm text-red-600">Divergências AFD</p>
                  </div>
                </div>

                {/* Histórico de Importações AFD */}
                {(auditoriaFiltro === 'todos' || auditoriaFiltro === 'divergencias') && auditoriaData.importacoes_afd?.length > 0 && (
                  <div className="space-y-3">
                    <h3 className="font-semibold text-slate-700 dark:text-slate-300 flex items-center gap-2">
                      <FileUp className="w-4 h-4 text-blue-600" />
                      Histórico de Importações AFD
                    </h3>
                    <div className="border rounded-lg overflow-hidden">
                      <Table>
                        <TableHeader>
                          <TableRow className="bg-slate-50 dark:bg-slate-800">
                            <TableHead>Data/Hora</TableHead>
                            <TableHead>Arquivo</TableHead>
                            <TableHead>Registros</TableHead>
                            <TableHead>Inconsistências</TableHead>
                            <TableHead>Resolvidas</TableHead>
                            <TableHead>Importado por</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {auditoriaData.importacoes_afd.map((imp, idx) => (
                            <TableRow key={idx}>
                              <TableCell className="text-xs">
                                {imp.created_at ? new Date(imp.created_at).toLocaleString('pt-BR') : '-'}
                              </TableCell>
                              <TableCell className="font-mono text-xs">{imp.arquivo_nome}</TableCell>
                              <TableCell className="text-center">{imp.total_registros}</TableCell>
                              <TableCell className="text-center">
                                <Badge variant={imp.total_inconsistencias > 0 ? 'destructive' : 'secondary'}>
                                  {imp.total_inconsistencias}
                                </Badge>
                              </TableCell>
                              <TableCell className="text-center">
                                <Badge variant="outline" className="text-green-600 border-green-300">
                                  {imp.inconsistencias_resolvidas || 0}
                                </Badge>
                              </TableCell>
                              <TableCell>{imp.importado_por}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  </div>
                )}

                {/* Alterações do Suporte */}
                {(auditoriaFiltro === 'todos' || auditoriaFiltro === 'alteracoes_suporte') && auditoriaData.alteracoes_suporte?.length > 0 && (
                  <div className="space-y-3">
                    <h3 className="font-semibold text-slate-700 dark:text-slate-300 flex items-center gap-2">
                      <Edit3 className="w-4 h-4 text-amber-600" />
                      Alterações do Suporte (Não-Admin)
                    </h3>
                    <div className="border rounded-lg overflow-hidden">
                      <Table>
                        <TableHeader>
                          <TableRow className="bg-slate-50 dark:bg-slate-800">
                            <TableHead>Data</TableHead>
                            <TableHead>Colaborador</TableHead>
                            <TableHead>Entrada</TableHead>
                            <TableHead>Saída</TableHead>
                            <TableHead>Fonte</TableHead>
                            <TableHead>Autor</TableHead>
                            <TableHead>Observação</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {auditoriaData.alteracoes_suporte.map((alt, idx) => (
                            <TableRow key={idx}>
                              <TableCell className="font-mono text-xs">
                                {alt.data ? alt.data.split('-').reverse().join('/') : '-'}
                              </TableCell>
                              <TableCell className="font-medium text-sm">{alt.human_name}</TableCell>
                              <TableCell>
                                <span className="font-mono text-sm">{alt.entrada || '-'}</span>
                                {alt.entrada_source === 'manual' && (
                                  <Badge variant="outline" className="ml-1 text-xs">manual</Badge>
                                )}
                              </TableCell>
                              <TableCell>
                                <span className="font-mono text-sm">{alt.saida || '-'}</span>
                                {alt.saida_source === 'manual' && (
                                  <Badge variant="outline" className="ml-1 text-xs">manual</Badge>
                                )}
                              </TableCell>
                              <TableCell>
                                <Badge variant={alt.entrada_source === 'afd' ? 'default' : 'secondary'} className="text-xs">
                                  {alt.entrada_source || 'manual'}
                                </Badge>
                              </TableCell>
                              <TableCell className="text-sm text-amber-600 font-medium">{alt.autor}</TableCell>
                              <TableCell className="text-xs text-slate-500 max-w-[200px] truncate" title={alt.observacoes}>
                                {alt.observacoes || '-'}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  </div>
                )}

                {/* Divergências AFD */}
                {(auditoriaFiltro === 'todos' || auditoriaFiltro === 'divergencias') && auditoriaData.divergencias?.length > 0 && (
                  <div className="space-y-3">
                    <h3 className="font-semibold text-slate-700 dark:text-slate-300 flex items-center gap-2">
                      <AlertTriangle className="w-4 h-4 text-red-600" />
                      Divergências AFD (Corrigidas/Revisadas)
                    </h3>
                    <div className="border rounded-lg overflow-hidden">
                      <Table>
                        <TableHeader>
                          <TableRow className="bg-slate-50 dark:bg-slate-800">
                            <TableHead>Data</TableHead>
                            <TableHead>Colaborador</TableHead>
                            <TableHead>Entrada</TableHead>
                            <TableHead>Saída</TableHead>
                            <TableHead>Fonte Entrada</TableHead>
                            <TableHead>Fonte Saída</TableHead>
                            <TableHead>Revisado</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {auditoriaData.divergencias.map((div, idx) => (
                            <TableRow key={idx}>
                              <TableCell className="font-mono text-xs">
                                {div.data ? div.data.split('-').reverse().join('/') : '-'}
                              </TableCell>
                              <TableCell className="font-medium text-sm">{div.human_name}</TableCell>
                              <TableCell className="font-mono text-sm">{div.entrada || '-'}</TableCell>
                              <TableCell className="font-mono text-sm">{div.saida || '-'}</TableCell>
                              <TableCell>
                                <Badge variant={div.entrada_source === 'afd' ? 'default' : 'secondary'} className="text-xs">
                                  {div.entrada_source || 'manual'}
                                </Badge>
                              </TableCell>
                              <TableCell>
                                <Badge variant={div.saida_source === 'afd' ? 'default' : 'secondary'} className="text-xs">
                                  {div.saida_source || 'manual'}
                                </Badge>
                              </TableCell>
                              <TableCell>
                                {div.afd_revisado ? (
                                  <TooltipProvider>
                                    <Tooltip>
                                      <TooltipTrigger>
                                        <Badge variant="outline" className="text-green-600 border-green-300">
                                          <Check className="w-3 h-3 mr-1" /> Sim
                                        </Badge>
                                      </TooltipTrigger>
                                      <TooltipContent>
                                        <p>Revisado por: {div.afd_revisado_por}</p>
                                        <p>Em: {div.afd_revisado_em ? new Date(div.afd_revisado_em).toLocaleString('pt-BR') : '-'}</p>
                                      </TooltipContent>
                                    </Tooltip>
                                  </TooltipProvider>
                                ) : (
                                  <Badge variant="outline" className="text-slate-400">Não</Badge>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  </div>
                )}

                {/* Mensagem quando não há dados */}
                {(!auditoriaData.importacoes_afd?.length && !auditoriaData.alteracoes_suporte?.length && !auditoriaData.divergencias?.length) && (
                  <div className="text-center py-12 text-slate-500">
                    <Shield className="w-16 h-16 mx-auto mb-4 text-slate-300" />
                    <p className="text-lg font-medium">Nenhum registro de auditoria encontrado</p>
                    <p className="text-sm">para {months.find(m => m.value === selectedMonth)?.label}/{selectedYear}</p>
                  </div>
                )}
              </div>
            ) : (
              <div className="text-center py-12 text-slate-500">
                <Shield className="w-16 h-16 mx-auto mb-4 text-slate-300" />
                <p>Selecione o período e clique para carregar os dados de auditoria.</p>
              </div>
            )}
          </CardContent>
        </Card>
      ) : viewMode === 'individual' ? (
        !selectedHuman ? (
          <Card className="dark:bg-slate-800/50 dark:border-slate-700 border-2 border-amber-400">
            <CardContent className="py-8">
              <div className="bg-amber-50 dark:bg-amber-900/30 border-2 border-amber-400 rounded-lg p-6 mb-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-amber-400 flex items-center justify-center flex-shrink-0">
                    <AlertTriangle className="w-6 h-6 text-amber-900" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-amber-800 dark:text-amber-300 mb-2">
                      ⚠️ ATENÇÃO: Selecione o Período Correto!
                    </h3>
                    <p className="text-amber-700 dark:text-amber-400 text-sm">
                      Verifique se o mês e ano selecionados estão corretos antes de visualizar os dados.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="text-center">
                <User className="w-16 h-16 mx-auto mb-4 text-slate-300 dark:text-slate-600" />
                <p className="text-slate-600 dark:text-slate-400 font-medium text-lg mb-2">
                  Selecione um funcionário CLT
                </p>
                <p className="text-slate-400 dark:text-slate-500 text-sm">
                  Empresa de pequeno porte com pouquíssimos funcionários
                </p>
              </div>
            </CardContent>
          </Card>
        ) : jornadaData ? (
          <>
            {/* Alerta de Competência Fechada */}
            {competenciaStatus === 'fechada' && (
              <div className="bg-purple-50 border-2 border-purple-300 rounded-lg p-4 flex items-center gap-4">
                <Lock className="w-8 h-8 text-purple-600 flex-shrink-0" />
                <div className="flex-1">
                  <h4 className="font-bold text-purple-800">Competência Fechada - Somente Leitura</h4>
                  <p className="text-sm text-purple-600">
                    Esta competência foi fechada{competenciaInfo?.fechada_por_nome ? ` por ${competenciaInfo.fechada_por_nome}` : ''}.
                    Edição de ponto, classificação e abono estão bloqueados.
                    Consulta e exportação PDF/CSV continuam disponíveis.
                  </p>
                </div>
                <Button
                  onClick={() => setShowReabrirModal(true)}
                  variant="outline"
                  className="border-purple-500 text-purple-600 hover:bg-purple-100"
                >
                  <Unlock className="w-4 h-4 mr-2" />
                  Reabrir
                </Button>
              </div>
            )}
            
            {/* Card do Funcionário */}
            <Card className="dark:bg-slate-800/50 dark:border-slate-700 border-l-4 border-l-blue-500">
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                      <User className="w-6 h-6 text-blue-600 dark:text-blue-400" />
                    </div>
                    <div>
                      <h2 className="text-lg font-bold text-slate-900 dark:text-white">
                        {jornadaData.funcionario.nome}
                      </h2>
                      <div className="flex items-center gap-2 mt-1">
                        <Badge className="bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400">
                          CLT
                        </Badge>
                        <span className="text-sm text-slate-500">
                          {jornadaData.periodo.mes_nome} {jornadaData.periodo.ano}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="text-right text-sm">
                    <div className="flex items-center gap-4">
                      {jornadaData.resumo.dias_registro_presumido > 0 && (
                        <div className="bg-amber-100 px-2 py-0.5 rounded" data-testid="dias-presumidos-badge">
                          <span className="text-slate-500">Presumidos:</span>
                          <span className="font-bold ml-1 text-amber-700">
                            {jornadaData.resumo.dias_registro_presumido}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* BLOCO CULTURA - Abaixo do nome do colaborador, visualmente distinto */}
            {textosInstitucionais.cultura?.conteudo && (
              <div className="bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-indigo-900/20 dark:to-purple-900/20 border border-indigo-200 dark:border-indigo-700 rounded-lg p-4" data-testid="bloco-cultura">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1">
                    {editingTexto === 'cultura' ? (
                      <div className="space-y-3">
                        <div className="flex items-center gap-2">
                          <span className="font-bold text-indigo-700 dark:text-indigo-400 text-sm tracking-wide">Cultura.</span>
                        </div>
                        <Textarea
                          value={textoEditConteudo}
                          onChange={(e) => setTextoEditConteudo(e.target.value)}
                          className="min-h-[100px] text-sm bg-white dark:bg-slate-800"
                          placeholder="Digite o texto de cultura..."
                        />
                        <div className="flex gap-2">
                          <Button
                            size="sm"
                            onClick={() => handleSaveTexto('cultura')}
                            disabled={savingTexto}
                            className="bg-indigo-600 hover:bg-indigo-700 text-white"
                          >
                            {savingTexto ? <Loader2 className="w-3 h-3 animate-spin mr-1" /> : <Save className="w-3 h-3 mr-1" />}
                            Salvar
                          </Button>
                          <Button size="sm" variant="outline" onClick={cancelEditTexto}>
                            Cancelar
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <p className="text-sm text-indigo-700 dark:text-indigo-300 leading-relaxed italic">
                        <span className="font-bold not-italic tracking-wide">Cultura.</span>{' '}
                        {textosInstitucionais.cultura.conteudo}
                      </p>
                    )}
                  </div>
                  {editingTexto !== 'cultura' && (
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => startEditTexto('cultura')}
                      className="text-indigo-400 hover:text-indigo-600 shrink-0"
                      title="Editar texto"
                    >
                      <Edit3 className="w-4 h-4" />
                    </Button>
                  )}
                </div>
              </div>
            )}

            {/* Painel Resumo de Horas do Mês - Layout Profissional */}
            <Card className="dark:bg-slate-800/50 dark:border-slate-700 overflow-hidden">
              <CardHeader className="pb-0 bg-gradient-to-r from-slate-700 to-slate-600 text-white">
                <CardTitle className="text-base flex items-center justify-between py-1">
                  <div className="flex items-center gap-2">
                    <Clock className="w-5 h-5" />
                    <span className="font-bold tracking-wide">
                      FOLHA {jornadaData.periodo.mes_nome.toUpperCase()}/{jornadaData.periodo.ano}
                    </span>
                  </div>
                  <span className="text-sm font-semibold bg-white/20 px-3 py-1 rounded">
                    {jornadaData.funcionario.nome}
                  </span>
                </CardTitle>
              </CardHeader>
              <CardContent className="p-0">
                <div className="overflow-x-auto">
                  <table className="w-full text-sm border-collapse">
                    <thead>
                      <tr className="bg-slate-700 text-white">
                        <th className="p-2 text-left font-bold w-32 border border-slate-600">Categoria</th>
                        <th className="p-2 text-left font-bold border border-slate-600">Descrição</th>
                        <th className="p-2 text-center font-bold w-28 border border-slate-600">Total Horas</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* === DOMINGO E FERIADO - AZUL (100%) === */}
                      <tr className="bg-blue-50 border border-slate-200">
                        <td className="p-2 font-semibold text-blue-700 border border-slate-200 align-top" rowSpan={3}>
                          Domingo e<br/>Feriado<br/><span className="text-xs font-normal">(Extra 100%)</span>
                        </td>
                        <td className="p-2 text-blue-700 border border-slate-200 font-medium">
                          Horas Extras 100% <span className="text-xs font-normal">(Total)</span>
                        </td>
                        <td className="p-2 text-center font-bold text-blue-700 border border-slate-200">
                          {jornadaData.resumo.extra_100 || '00:00'}
                        </td>
                      </tr>
                      <tr className="bg-blue-50/70 border border-slate-200">
                        <td className="p-2 text-blue-600 border border-slate-200 text-sm pl-6">
                          ↳ Diurnas (05h-22h)
                        </td>
                        <td className="p-2 text-center text-blue-600 border border-slate-200">
                          {jornadaData.resumo.extra_100_diurna || '00:00'}
                        </td>
                      </tr>
                      <tr className="bg-blue-50/50 border border-slate-200">
                        <td className="p-2 text-blue-600 border border-slate-200 text-sm pl-6">
                          ↳ Noturnas Red. (22h-05h)
                        </td>
                        <td className="p-2 text-center text-blue-600 border border-slate-200">
                          {jornadaData.resumo.extra_100_noturna || '00:00'}
                        </td>
                      </tr>
                      
                      {/* === SÁBADO - VERDE (50%) === */}
                      <tr className="bg-emerald-50 border border-slate-200">
                        <td className="p-2 font-semibold text-emerald-700 border border-slate-200 align-top" rowSpan={3}>
                          Sábado<br/><span className="text-xs font-normal">(Extra 50%)</span>
                        </td>
                        <td className="p-2 text-emerald-700 border border-slate-200 font-medium">
                          Horas Extras 50% <span className="text-xs font-normal">(Total)</span>
                        </td>
                        <td className="p-2 text-center font-bold text-emerald-700 border border-slate-200">
                          {jornadaData.resumo.extra_50 || '00:00'}
                        </td>
                      </tr>
                      <tr className="bg-emerald-50/70 border border-slate-200">
                        <td className="p-2 text-emerald-600 border border-slate-200 text-sm pl-6">
                          ↳ Diurnas (05h-22h)
                        </td>
                        <td className="p-2 text-center text-emerald-600 border border-slate-200">
                          {jornadaData.resumo.extra_50_diurna || '00:00'}
                        </td>
                      </tr>
                      <tr className="bg-emerald-50/50 border border-slate-200">
                        <td className="p-2 text-emerald-600 border border-slate-200 text-sm pl-6">
                          ↳ Noturnas Red. (22h-05h)
                        </td>
                        <td className="p-2 text-center text-emerald-600 border border-slate-200">
                          {jornadaData.resumo.extra_50_noturna || '00:00'}
                        </td>
                      </tr>
                      
                      {/* === SEGUNDA A SEXTA-FEIRA (BANCO) === */}
                      {/* Linha Principal: RESULTADO A CONSIDERAR - Destaque forte */}
                      <tr className={`border-2 ${
                        jornadaData.resumo.banco_horas_minutos >= 0 
                          ? 'border-green-500 bg-green-100' 
                          : 'border-red-500 bg-red-100'
                      }`}>
                        <td className="p-3 font-bold text-slate-800 border border-slate-200 align-top" rowSpan={7}>
                          Segunda a<br/>Sexta-feira
                        </td>
                        <td className="p-3 border border-slate-200">
                          <div className="flex items-center gap-2">
                            <span className={`text-xs font-bold px-2 py-0.5 rounded ${
                              jornadaData.resumo.banco_horas_minutos >= 0 
                                ? 'bg-green-600 text-white' 
                                : 'bg-red-600 text-white'
                            }`}>
                              {jornadaData.resumo.banco_horas_minutos >= 0 ? '✓ CRÉDITO' : '✗ DÉBITO'}
                            </span>
                            <span className="font-bold text-slate-800">
                              RESULTADO BANCO DE HORAS
                            </span>
                          </div>
                        </td>
                        <td className={`p-3 text-center text-xl font-black border border-slate-200 ${
                          jornadaData.resumo.banco_horas_minutos >= 0 
                            ? 'text-green-700' 
                            : 'text-red-600'
                        }`}>
                          {jornadaData.resumo.banco_horas}
                        </td>
                      </tr>
                      
                      {/* Detalhamento do saldo (texto menor) */}
                      <tr className="bg-slate-50 border border-slate-200">
                        <td colSpan={2} className="p-2 text-slate-500 border border-slate-200 text-xs italic">
                          <span className="font-medium">Detalhamento do saldo (seg-sex):</span>
                        </td>
                      </tr>
                      
                      {/* Linha: Débitos (seg-sex) - VERMELHO */}
                      <tr className="bg-red-50 border border-slate-200">
                        <td className="p-2 text-red-600 border border-slate-200 pl-6 text-xs">
                          ↳ Débitos (dias úteis com jornada menor)
                        </td>
                        <td className="p-2 text-center text-red-600 font-medium border border-slate-200 text-xs">
                          {jornadaData.resumo.banco_debitos_seg_sex || '00:00'}
                        </td>
                      </tr>
                      
                      {/* Linha: Créditos (seg-sex) - VERDE */}
                      <tr className="bg-green-50 border border-slate-200">
                        <td className="p-2 text-green-600 border border-slate-200 pl-6 text-xs">
                          ↳ Créditos (dias úteis com jornada maior)
                        </td>
                        <td className="p-2 text-center text-green-600 font-medium border border-slate-200 text-xs">
                          +{jornadaData.resumo.banco_creditos_seg_sex || '00:00'}
                        </td>
                      </tr>
                      
                      {/* Linha: Saldo do banco - COR BASEADA NO SINAL */}
                      <tr className={`border border-slate-200 ${
                        jornadaData.resumo.banco_horas_minutos >= 0 ? 'bg-green-100' : 'bg-red-100'
                      }`}>
                        <td className={`p-2 border border-slate-200 pl-6 text-xs font-medium ${
                          jornadaData.resumo.banco_horas_minutos >= 0 ? 'text-green-700' : 'text-red-700'
                        }`}>
                          ↳ Saldo do banco (débitos + créditos)
                        </td>
                        <td className={`p-2 text-center font-bold border border-slate-200 text-xs ${
                          jornadaData.resumo.banco_horas_minutos >= 0 ? 'text-green-700' : 'text-red-700'
                        }`}>
                          {jornadaData.resumo.banco_horas}
                        </td>
                      </tr>
                      
                      {/* Linha: Horas Abonadas 08h-09h (somente se elegível ou para mostrar inelegibilidade) */}
                      <tr className="bg-amber-100 border border-slate-200">
                        <td className="p-2 text-amber-800 border border-slate-200 pl-6">
                          <div className="flex items-start gap-1">
                            <span className="text-xs">↳</span>
                            <div className="flex-1">
                              <div className="flex items-center gap-2 flex-wrap">
                                <span className="font-medium">Bonificação 08h-09h</span>
                                <sup className="text-amber-600 cursor-help" title="Ver nota de rodapé">*</sup>
                              </div>
                              <p className="text-[10px] text-amber-700 mt-0.5 leading-tight">
                                Colaborador sem falta de batida e sem divergência previsto×realizado no mês
                              </p>
                              {/* Mensagem de inelegibilidade ou estorno */}
                              {(jornadaData.resumo.abono_08_09_elegivel === false || jornadaData.resumo.abono_08_09_estornado) && (
                                <div className="mt-1 p-1.5 bg-red-100 rounded text-[10px] text-red-700 border border-red-200">
                                  {jornadaData.resumo.abono_08_09_motivo_inelegivel && (
                                    <span className="font-bold">
                                      Inelegivel: Falta(s) de batida e/ou irregularidade(s) registrada(s) no mes
                                    </span>
                                  )}
                                  {jornadaData.resumo.abono_08_09_estornado && (
                                    <div className="mt-1">
                                      <span className="font-bold text-red-800">ABONO ESTORNADO:</span> {jornadaData.resumo.abono_08_09_estornado_motivo}
                                      <span className="text-red-500 text-[9px] ml-1">
                                        (por {jornadaData.resumo.abono_08_09_estornado_por})
                                      </span>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                        <td className={`p-2 text-center font-medium border border-slate-200 ${
                          jornadaData.resumo.abono_08_09_elegivel === false || jornadaData.resumo.abono_08_09_estornado 
                            ? 'text-red-500 line-through' 
                            : 'text-amber-700'
                        }`}>
                          +{jornadaData.resumo.banco_horas_perdoadas || '00:00'}
                        </td>
                      </tr>
                      {/* Linha: Adicional Noturno - Detalhado com subtotais */}
                      <tr className="bg-slate-50 border border-slate-200">
                        <td colSpan="2" className="p-2 text-slate-600 border border-slate-200">
                          <div className="font-medium">Adicional Noturno (22h-05h)</div>
                          <p className="text-[10px] text-slate-500 mt-0.5">
                            Horas trabalhadas no periodo noturno - reducao de 52min30s a cada hora
                          </p>
                        </td>
                        <td className="p-2 text-center text-slate-600 border border-slate-200 font-medium">
                          {jornadaData.resumo.adicional_noturno || '00:00'}
                        </td>
                      </tr>
                      {/* Sub-linha: Horas reais -> convertidas */}
                      {(jornadaData.resumo.adicional_noturno_minutos > 0) && (
                        <tr className="bg-slate-50/50 border-x border-slate-200">
                          <td colSpan="2" className="p-2 pl-6 text-slate-500 text-xs border border-slate-200">
                            <span className="text-slate-400">Horas reais: </span>
                            {jornadaData.resumo.adicional_noturno || '00:00'}
                            <span className="mx-2 text-slate-300">→</span>
                            <span className="text-slate-400">Convertidas (52m30s/h): </span>
                            {jornadaData.resumo.noturno_seg_sex || '00:00'}
                          </td>
                          <td className="p-2 text-center text-slate-400 text-xs border border-slate-200">
                            (+{Math.round((jornadaData.resumo.adicional_noturno_convertido || 0) - (jornadaData.resumo.adicional_noturno_minutos || 0))}min)
                          </td>
                        </tr>
                      )}
                      
                      {/* === INTERJORNADA SUPRIMIDA - CINZA === */}
                      <tr className="bg-slate-100 border border-slate-200">
                        <td className="p-2 font-semibold text-slate-500 border border-slate-200">
                          Suprimida
                        </td>
                        <td className="p-2 text-slate-500 border border-slate-200">
                          INTERJORNADA {jornadaData.resumo.interjornada_count > 0 && <span className="text-slate-400 text-xs">({jornadaData.resumo.interjornada_count}x descanso &lt;11h)</span>}
                        </td>
                        <td className="p-2 text-center text-slate-500 border border-slate-200">
                          {jornadaData.resumo.interjornada_horas || '00:00'}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  
                  {/* NOTA DE RODAPÉ */}
                  <div className="bg-amber-50 border-t border-amber-200 p-3">
                    <p className="text-[10px] text-amber-800 leading-relaxed">
                      <sup>*</sup> <strong>Abono 08h-09h:</strong> Restrito à apuração de jornada desta competência. 
                      NÃO constitui atestado de ausência de outras irregularidades (material, conduta, dano patrimonial). 
                      Divergência ou ocorrência identificada posteriormente reverte automaticamente o abono, 
                      mediante registro em trilha de auditoria.
                    </p>
                  </div>
                </div>
                
                {/* Rodapé com observação */}
                <div className="p-4 border-t-2 border-slate-200 bg-slate-50 dark:bg-slate-800/50">
                  {observacaoFechamento && (
                    <div className="bg-amber-50 dark:bg-amber-900/30 p-3 rounded-lg border border-amber-200 mb-3">
                      <div className="flex items-start gap-2 text-amber-800 dark:text-amber-300">
                        <MessageSquare className="w-4 h-4 mt-0.5 flex-shrink-0" />
                        <p className="text-sm italic">
                          {observacaoFechamento}
                        </p>
                      </div>
                    </div>
                  )}
                  
                  {jornadaData.resumo.banco_horas_minutos < 0 && (
                    <div className="flex items-center justify-center gap-2 text-red-700 dark:text-red-400 font-semibold mb-3">
                      <AlertTriangle className="w-4 h-4" />
                      <span>Saldo de horas negativas a descontar: {jornadaData.resumo.banco_horas}</span>
                    </div>
                  )}
                  
                  <div className="flex justify-center">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={openFechamentoModal}
                      className="text-xs border-slate-300 hover:bg-slate-100"
                    >
                      <Edit3 className="w-3 h-3 mr-1" />
                      {observacaoFechamento ? 'Editar Observação' : 'Adicionar Observação'}
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Tabela Diária */}
            <Card className="dark:bg-slate-800/50 dark:border-slate-700">
              <CardHeader className="pb-2">
                <div className="flex items-center justify-between">
                  <CardTitle className="text-base flex items-center gap-2">
                    <Calendar className="w-4 h-4 text-blue-500" />
                    Detalhamento Diário - {jornadaData.periodo.mes_nome}
                  </CardTitle>
                  {/* Botão de ação em lote quando há dias selecionados */}
                  {selectedDays.length > 0 && (
                    <div className="flex items-center gap-2">
                      <Badge className="bg-amber-100 text-amber-700 border-amber-300">
                        {selectedDays.length} dia(s) selecionado(s)
                      </Badge>
                      <Button 
                        size="sm" 
                        onClick={() => setShowBatchBHModal(true)}
                        className="bg-amber-500 hover:bg-amber-600 text-white"
                      >
                        <Clock className="w-3 h-3 mr-1" />
                        Aplicar Folga BH
                      </Button>
                      <Button 
                        size="sm" 
                        variant="outline"
                        onClick={() => setSelectedDays([])}
                      >
                        Limpar
                      </Button>
                    </div>
                  )}
                </div>
              </CardHeader>
              <CardContent className="p-0">
                <div className="overflow-x-auto">
                  <Table>
                    <TableHeader>
                      <TableRow className="bg-slate-100 dark:bg-slate-900/50">
                        {/* Coluna de Checkbox */}
                        <TableHead className="w-8 text-center">
                          <Checkbox 
                            checked={selectedDays.length > 0 && jornadaData?.dias?.filter(dia => {
                              const ehFds = ['Sábado', 'Domingo', 'Sáb', 'Dom'].includes(dia.dia_semana);
                              return !ehFds && (dia.atraso || dia.banco_minutos < 0) && !dia.atraso_abonado && dia.record_id;
                            }).every(dia => selectedDays.includes(dia.data))}
                            onCheckedChange={toggleSelectAll}
                            title="Selecionar todos elegíveis"
                          />
                        </TableHead>
                        <TableHead className="font-bold w-12 md:w-16 text-[10px] md:text-xs sticky left-0 bg-slate-100 dark:bg-slate-900/50 z-10">Data</TableHead>
                        <TableHead className="font-bold w-8 md:w-10 text-[10px] md:text-xs">Dia</TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs text-center hidden md:table-cell" colSpan={2}>
                          <div className="flex flex-col">
                            <span>Jornada</span>
                            <span className="text-[8px] md:text-[9px] text-slate-400 font-normal">Entrada/Saída</span>
                          </div>
                        </TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs hidden lg:table-cell">
                          <div className="flex flex-col">
                            <span>Escala</span>
                            <span className="text-[8px] md:text-[9px] text-slate-400 font-normal">Pré/Pós Ev.</span>
                          </div>
                        </TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs text-center">Trab.</TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs text-center">
                          <div className="flex flex-col">
                            <span>Saldo</span>
                            <span className="text-[8px] md:text-[9px] font-normal">B.HRS</span>
                          </div>
                        </TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs text-center">
                          <div className="flex flex-col text-amber-600">
                            <span>E50%</span>
                            <span className="text-[7px] md:text-[8px] font-normal hidden sm:block">Sáb (D/N)</span>
                          </div>
                        </TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs text-center">
                          <div className="flex flex-col text-orange-600">
                            <span>E100%</span>
                            <span className="text-[7px] md:text-[8px] font-normal hidden sm:block">Dom/Fer (D/N)</span>
                          </div>
                        </TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs text-center hidden sm:table-cell">
                          <div className="flex flex-col text-indigo-600">
                            <span>Not.</span>
                            <span className="text-[8px] md:text-[9px] font-normal hidden md:block">22h-05h</span>
                          </div>
                        </TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs text-center hidden lg:table-cell">
                          <div className="flex flex-col text-purple-600">
                            <span>Intraj.</span>
                            <span className="text-[8px] md:text-[9px] font-normal">Int.Pago</span>
                          </div>
                        </TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs text-center hidden lg:table-cell">
                          <div className="flex flex-col text-rose-600">
                            <span>Interj.</span>
                            <span className="text-[8px] md:text-[9px] font-normal">pgto</span>
                          </div>
                        </TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs text-center">
                          <div className="flex flex-col text-red-600">
                            <span>!Atraso</span>
                            <span className="text-[8px] md:text-[9px] font-normal hidden sm:block">/BH</span>
                          </div>
                        </TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs text-center">
                          <div className="flex flex-col text-red-800">
                            <span>!Falta</span>
                            <span className="text-[8px] md:text-[9px] font-normal hidden sm:block">+DSR</span>
                          </div>
                        </TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs hidden sm:table-cell max-w-[120px] md:max-w-[180px]">Situação</TableHead>
                        <TableHead className="font-bold text-[10px] md:text-xs text-center w-10 md:w-14">Ações</TableHead>
                      </TableRow>
                      <TableRow className="bg-slate-50 dark:bg-slate-900/30 border-b-2 hidden md:table-row">
                        <TableHead className="sticky left-0 bg-slate-50 dark:bg-slate-900/30 z-10"></TableHead>
                        <TableHead></TableHead>
                        <TableHead className="text-[9px] md:text-[10px] text-center text-slate-500 font-medium py-1">
                          Manhã<br/>até 12:00
                        </TableHead>
                        <TableHead className="text-[9px] md:text-[10px] text-center text-slate-500 font-medium py-1">
                          Tarde<br/>13:12 em diante
                        </TableHead>
                        <TableHead></TableHead>
                        <TableHead></TableHead>
                        <TableHead></TableHead>
                        <TableHead></TableHead>
                        <TableHead></TableHead>
                        <TableHead></TableHead>
                        <TableHead></TableHead>
                        <TableHead></TableHead>
                        <TableHead></TableHead>
                        <TableHead></TableHead>
                        <TableHead></TableHead>
                        <TableHead></TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {jornadaData.dias.map((dia, idx) => {
                        const temTermo = dia.entrada_source === 'manual' || dia.saida_source === 'manual';
                        const ehFimDeSemana = dia.tipo_dia === 'sabado' || dia.tipo_dia === 'domingo';
                        const ehFeriado = dia.eh_feriado;
                        const temAtraso = dia.situacao?.some(s => s.includes('ATRASO:') || s.includes('ATRASO CONFIRMADO'));
                        // "FALTA" pura = não trabalhou (vermelho forte)
                        // "*FALTA BATIDA" = trabalhou mas não bateu ponto (amarelo/leve)
                        const temFaltaReal = dia.situacao?.some(s => s === 'FALTA' || s === 'FALTA (sem apontamento)');
                        const temFaltaBatida = dia.situacao?.some(s => s.includes('FALTA BATIDA'));
                        
                        // Verifica se dia é elegível para seleção (tem atraso/débito e não está abonado)
                        const elegivelParaSelecao = !ehFimDeSemana && (dia.atraso || dia.banco_minutos < 0) && !dia.atraso_abonado && dia.record_id;
                        const isSelected = selectedDays.includes(dia.data);
                        
                        return (
                          <TableRow 
                            key={idx}
                            className={`text-xs ${
                              isSelected ? 'bg-amber-100 dark:bg-amber-900/30 ring-2 ring-amber-400' :
                              dia.abonado ? 'bg-cyan-50 dark:bg-cyan-900/10' :
                              temFaltaReal ? 'bg-red-100 dark:bg-red-900/20' :
                              temFaltaBatida ? 'bg-amber-50 dark:bg-amber-900/10' :
                              temAtraso && !dia.atraso_abonado ? 'bg-red-50 dark:bg-red-900/10' :
                              temTermo ? 'bg-amber-50 dark:bg-amber-900/10' :
                              ehFeriado ? 'bg-yellow-50 dark:bg-yellow-900/10' :
                              dia.tipo_dia === 'domingo' ? 'bg-orange-50/50 dark:bg-orange-900/10' :
                              dia.tipo_dia === 'sabado' ? 'bg-slate-100 dark:bg-slate-800/50' :
                              idx % 2 === 0 ? 'bg-white dark:bg-slate-900' : 'bg-slate-50/50 dark:bg-slate-800/30'
                            }`}
                          >
                            {/* Checkbox de seleção */}
                            <TableCell className="text-center py-1">
                              {elegivelParaSelecao ? (
                                <Checkbox 
                                  checked={isSelected}
                                  onCheckedChange={() => toggleDaySelection(dia)}
                                  className="border-amber-400 data-[state=checked]:bg-amber-500"
                                />
                              ) : (
                                <span className="text-slate-300">—</span>
                              )}
                            </TableCell>
                            <TableCell className="font-medium py-1 md:py-2 text-[10px] md:text-xs sticky left-0 bg-inherit z-10">
                              {formatDate(dia.data)}
                            </TableCell>
                            <TableCell className={`py-1 md:py-2 text-[10px] md:text-xs ${ehFimDeSemana ? 'text-slate-400' : 'font-medium'}`}>
                              {dia.dia_semana}
                            </TableCell>
                            {/* Coluna Manhã - Entrada real até fim da manhã */}
                            <TableCell className="text-center py-1 md:py-2 bg-slate-50/50 dark:bg-slate-800/30 hidden md:table-cell">
                              {(() => {
                                // Verificar se trabalhou
                                if (!dia.entrada || dia.trabalhado_minutos <= 0) {
                                  if (ehFimDeSemana && !dia.trabalhado_minutos) {
                                    return <span className="text-slate-300 text-[10px]">—</span>;
                                  }
                                  return <span className="text-slate-300">—</span>;
                                }
                                
                                // Para jornadas NOTURNAS, mostrar entrada às saída + indicador (not.)
                                if (!dia.eh_jornada_diurna) {
                                  return (
                                    <div className="text-[10px] text-slate-600">
                                      <span className={`font-medium ${dia.entrada_source === 'manual' ? 'bg-red-600 text-white px-1 rounded' : ''}`}>
                                        {dia.entrada_source === 'manual' ? '*' : ''}{dia.entrada || '?'}
                                      </span>
                                      <span className="text-slate-400 mx-0.5">às</span>
                                      <span className={`font-medium ${dia.saida_source === 'manual' ? 'bg-red-600 text-white px-1 rounded' : ''}`}>
                                        {dia.saida || '?'}{dia.saida_source === 'manual' ? '*' : ''}
                                      </span>
                                      <span className="text-purple-500 text-[8px] ml-0.5">(not.)</span>
                                    </div>
                                  );
                                }
                                
                                // Converter saída para minutos para comparar
                                const saidaParts = dia.saida?.split(':').map(Number) || [0, 0];
                                const saidaMinutos = saidaParts[0] * 60 + (saidaParts[1] || 0);
                                const limiteAlmoco = 13 * 60 + 12; // 13:12 em minutos
                                
                                // Converter entrada para minutos
                                const entradaParts = dia.entrada?.split(':').map(Number) || [0, 0];
                                const entradaMinutos = entradaParts[0] * 60 + (entradaParts[1] || 0);
                                const limiteEntradaManha = 12 * 60; // 12:00 em minutos
                                
                                // Se ENTRADA foi depois das 12:00, NÃO trabalhou de manhã
                                // Coluna manhã fica vazia
                                if (entradaMinutos >= limiteEntradaManha) {
                                  return <span className="text-slate-300">—</span>;
                                }
                                
                                // Se saiu antes das 13:12, mostrar entrada às saída real (só manhã)
                                if (saidaMinutos <= limiteAlmoco) {
                                  return (
                                    <div className="text-[10px] text-slate-600">
                                      <span className={`font-medium ${dia.entrada_source === 'manual' ? 'bg-red-600 text-white px-1 rounded' : ''}`}>
                                        {dia.entrada_source === 'manual' ? '*' : ''}{dia.entrada}
                                      </span>
                                      <span className="text-slate-400 mx-0.5">às</span>
                                      <span className={`font-medium ${dia.saida_source === 'manual' ? 'bg-red-600 text-white px-1 rounded' : ''}`}>
                                        {dia.saida}{dia.saida_source === 'manual' ? '*' : ''}
                                      </span>
                                    </div>
                                  );
                                }
                                
                                // Se trabalhou manhã e tarde (entrada < 12:00 e saída > 13:12), mostrar entrada às 12:00
                                return (
                                  <div className="text-[10px] text-slate-600">
                                    <span className={`font-medium ${dia.entrada_source === 'manual' ? 'bg-red-600 text-white px-1 rounded' : ''}`}>
                                      {dia.entrada_source === 'manual' ? '*' : ''}{dia.entrada}
                                    </span>
                                    <span className="text-slate-400 mx-0.5">às</span>
                                    <span className="font-medium">12:00</span>
                                  </div>
                                );
                              })()}
                            </TableCell>
                            {/* Coluna Tarde - 13:12 até saída real (só se saiu depois de 13:12) */}
                            <TableCell className="text-center py-1 md:py-2 bg-slate-50/50 dark:bg-slate-800/30 hidden md:table-cell">
                              {(() => {
                                // Para jornadas noturnas, a coluna manhã já mostra tudo
                                if (!dia.eh_jornada_diurna) {
                                  return <span className="text-slate-300">—</span>;
                                }
                                
                                // Verificar se trabalhou na tarde
                                if (!dia.saida || dia.trabalhado_minutos <= 0) {
                                  if (ehFimDeSemana && !dia.trabalhado_minutos) {
                                    return <span className="text-slate-300 text-[10px]">—</span>;
                                  }
                                  return <span className="text-slate-300">—</span>;
                                }
                                
                                // Converter saída para minutos para comparar
                                const saidaParts = dia.saida?.split(':').map(Number) || [0, 0];
                                const saidaMinutos = saidaParts[0] * 60 + (saidaParts[1] || 0);
                                const limiteAlmoco = 13 * 60 + 12; // 13:12 em minutos
                                
                                // Converter entrada para minutos
                                const entradaParts = dia.entrada?.split(':').map(Number) || [0, 0];
                                const entradaMinutos = entradaParts[0] * 60 + (entradaParts[1] || 0);
                                const limiteEntradaManha = 12 * 60; // 12:00 em minutos
                                
                                // Se ENTRADA foi depois das 12:00, é jornada só da TARDE
                                // Mostrar entrada às saída diretamente
                                if (entradaMinutos >= limiteEntradaManha) {
                                  return (
                                    <div className="text-[10px] text-slate-600">
                                      <span className={`font-medium ${dia.entrada_source === 'manual' ? 'bg-red-600 text-white px-1 rounded' : ''}`}>
                                        {dia.entrada_source === 'manual' ? '+' : ''}{dia.entrada}
                                      </span>
                                      <span className="text-slate-400 mx-0.5">às</span>
                                      <span className={`font-medium ${dia.saida_source === 'manual' ? 'bg-red-600 text-white px-1 rounded' : ''}`}>
                                        {dia.saida}{dia.saida_source === 'manual' ? '*' : ''}
                                      </span>
                                    </div>
                                  );
                                }
                                
                                // Só mostrar coluna tarde se saiu depois de 13:12 E entrou antes das 12:00
                                if (saidaMinutos > limiteAlmoco) {
                                  return (
                                    <div className="text-[10px] text-slate-600">
                                      <span className="font-medium">13:12</span>
                                      <span className="text-slate-400 mx-0.5">às</span>
                                      <span className={`font-medium ${dia.saida_source === 'manual' ? 'bg-red-600 text-white px-1 rounded' : ''}`}>
                                        {dia.saida}{dia.saida_source === 'manual' ? '*' : ''}
                                      </span>
                                    </div>
                                  );
                                }
                                
                                // Não trabalhou à tarde
                                return <span className="text-slate-300">—</span>;
                              })()}
                            </TableCell>
                            <TableCell className="py-1 md:py-2 hidden lg:table-cell">
                              {/* Mostrar Local e Horário Previsto (sem número da OS) */}
                              {(dia.local_evento || dia.local) && (
                                <div className="mb-1 flex items-center gap-1 text-[10px] md:text-[11px] text-slate-600 dark:text-slate-400">
                                  <MapPin className="w-3 h-3 text-slate-400" />
                                  <span className="capitalize">{dia.local_evento || dia.local}</span>
                                </div>
                              )}
                              {dia.escala_prevista_inicio ? (
                                <div className="text-[10px] md:text-[11px]">
                                  <span className="text-blue-600 dark:text-blue-400 font-medium">
                                    Prev: {dia.escala_prevista_inicio}–{dia.escala_prevista_fim || '?'}
                                  </span>
                                  {/* Mostrar divergência Pré/Pós evento - apenas referencial, sem destaque de cor */}
                                  {/* Pré = só mostra se chegou ANTES do início previsto (entrada < previsto) */}
                                  {/* Pós = só mostra se saiu DEPOIS do fim previsto (saída > previsto) */}
                                  {(dia.pre_evento_minutos !== null || dia.pos_evento_minutos !== null) && (
                                    <div className="flex flex-wrap gap-1 mt-0.5">
                                      {dia.pre_evento_minutos !== null && (
                                        <span className="text-[9px] px-1 rounded bg-slate-100 text-slate-600">
                                          {dia.pre_evento_minutos < 0 
                                            ? `Pré: ${formatMinutes(Math.abs(dia.pre_evento_minutos))}`
                                            : 'X'}
                                        </span>
                                      )}
                                      {dia.pos_evento_minutos !== null && (
                                        <span className="text-[9px] px-1 rounded bg-slate-100 text-slate-600">
                                          {dia.pos_evento_minutos > 0 
                                            ? `Pós: +${formatMinutes(dia.pos_evento_minutos)}`
                                            : 'X'}
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </div>
                              ) : dia.escala_dia ? (
                                <div className="text-[11px] text-slate-600 dark:text-slate-400 whitespace-pre-wrap">
                                  {dia.escala_dia}
                                </div>
                              ) : dia.escala_prevista_preenchida === false ? (
                                <TooltipProvider>
                                  <Tooltip>
                                    <TooltipTrigger asChild>
                                      <div className="flex items-center gap-1 text-amber-600">
                                        <Wrench className="w-3 h-3" />
                                        <AlertTriangle className="w-3 h-3" />
                                        <span className="text-[9px]">Sem previsto</span>
                                      </div>
                                    </TooltipTrigger>
                                    <TooltipContent className="max-w-[300px] text-xs">
                                      <p>Escala prevista não preenchida pelo responsável pela escala (Encarregado Administrativo Operacional).</p>
                                      <p className="mt-1 text-slate-400">Acesse a aba OSs (Escalas) para preencher o horário previsto.</p>
                                    </TooltipContent>
                                  </Tooltip>
                                </TooltipProvider>
                              ) : (
                                <span className="text-slate-400">-</span>
                              )}
                            </TableCell>
                            <TableCell className="text-center py-1 md:py-2 font-medium text-[10px] md:text-xs">
                              {dia.trabalhado_minutos > 0 ? (
                                <span className="text-blue-600">{formatMinutes(dia.trabalhado_minutos)}</span>
                              ) : (
                                <span className="text-slate-400">-</span>
                              )}
                            </TableCell>
                            <TableCell className="text-center py-1 md:py-2 text-[10px] md:text-xs">
                              {dia.banco_minutos !== 0 ? (
                                <span className={dia.banco_minutos >= 0 ? 'text-green-600 font-medium' : 'text-red-600 font-medium'}>
                                  {formatMinutes(dia.banco_minutos)}
                                </span>
                              ) : (
                                <span className="text-slate-400">-</span>
                              )}
                            </TableCell>
                            {/* Coluna E50% (Sábado) - Separando Diurna/Noturna */}
                            <TableCell className="text-center py-1 md:py-2 text-[10px] md:text-[11px]">
                              {dia.extra_50_minutos > 0 ? (
                                <div className="flex flex-col">
                                  <span className="text-amber-600 font-medium">
                                    {formatMinutes(dia.extra_50_minutos)}
                                  </span>
                                  {(dia.extra_50_diurna_minutos > 0 || dia.extra_50_noturna_minutos > 0) && (
                                    <span className="text-[8px] text-amber-500">
                                      {dia.extra_50_diurna_minutos > 0 ? `D:${formatMinutes(dia.extra_50_diurna_minutos)}` : ''}
                                      {dia.extra_50_noturna_minutos > 0 ? ` N:${formatMinutes(dia.extra_50_noturna_minutos)}` : ''}
                                    </span>
                                  )}
                                </div>
                              ) : (
                                <span className="text-slate-400">-</span>
                              )}
                            </TableCell>
                            {/* Coluna E100% (Domingo/Feriado) - Separando Diurna/Noturna */}
                            <TableCell className="text-center py-1 md:py-2 text-[10px] md:text-[11px]">
                              {dia.extra_100_minutos > 0 ? (
                                <div className="flex flex-col">
                                  <span className="text-orange-600 font-medium text-[11px]">
                                    {formatMinutes(dia.extra_100_minutos)}
                                  </span>
                                  {(dia.extra_100_diurna_minutos > 0 || dia.extra_100_noturna_minutos > 0) && (
                                    <span className="text-[8px] text-orange-500">
                                      {dia.extra_100_diurna_minutos > 0 ? `D:${formatMinutes(dia.extra_100_diurna_minutos)}` : ''}
                                      {dia.extra_100_noturna_minutos > 0 ? ` N:${formatMinutes(dia.extra_100_noturna_minutos)}` : ''}
                                    </span>
                                  )}
                                </div>
                              ) : (
                                <span className="text-slate-400">-</span>
                              )}
                            </TableCell>
                            {/* Coluna Adicional Noturno (22h-05h) */}
                            <TableCell className="text-center py-1 md:py-2 hidden sm:table-cell text-[10px] md:text-[11px]">
                              {dia.noturno_minutos > 0 ? (
                                <span className="text-indigo-600 font-medium">
                                  {formatMinutes(dia.noturno_minutos)}
                                </span>
                              ) : (
                                <span className="text-slate-400">-</span>
                              )}
                            </TableCell>
                            {/* Coluna Intrajornada (Intervalo Pago) */}
                            <TableCell className="text-center py-1 md:py-2 hidden lg:table-cell text-[10px] md:text-[11px]">
                              {dia.intrajornada_minutos > 0 ? (
                                <span className="text-purple-600 font-medium">
                                  {formatMinutes(dia.intrajornada_minutos)}
                                </span>
                              ) : (
                                <span className="text-slate-400">-</span>
                              )}
                            </TableCell>
                            {/* Coluna Interjornada (<11h descanso) */}
                            <TableCell className="text-center py-1 md:py-2 hidden lg:table-cell text-[10px] md:text-[11px]">
                              {dia.interjornada_minutos > 0 ? (
                                <span className="text-rose-600 font-medium">
                                  {formatMinutes(dia.interjornada_minutos)}
                                </span>
                              ) : (
                                <span className="text-slate-400">-</span>
                              )}
                            </TableCell>
                            {/* Coluna !Atraso - tempo de atraso/saída antecipada para desconto (formato 00h00) */}
                            <TableCell className="text-center py-1 md:py-2 text-[9px] md:text-[10px]">
                              {(() => {
                                // Se dia foi abonado completamente, não mostrar desconto
                                if (dia.abonado) {
                                  return <span className="text-slate-400">-</span>;
                                }
                                
                                // Se atraso foi abonado como Folga Banco de Horas, mostrar em azul (não é desconto)
                                if (dia.atraso_abonado) {
                                  return (
                                    <span className="text-blue-600 font-medium" title="Folga Banco de Horas">
                                      BH
                                    </span>
                                  );
                                }
                                
                                // Verificar se tem atraso real (não abonado) para desconto
                                const temAtrasoDesconto = dia.situacao?.some(s => 
                                  (s.includes('ATRASO:') || s.includes('ATRASO CONFIRMADO')) && !dia.atraso_abonado
                                );
                                
                                if (temAtrasoDesconto) {
                                  // Extrair minutos de atraso da situação
                                  const atrasoSit = dia.situacao?.find(s => s.includes('ATRASO:'));
                                  const atrasoMatch = atrasoSit?.match(/\+(\d+)h(\d+)/);
                                  let atrasoMin = 0;
                                  if (atrasoMatch) {
                                    atrasoMin = parseInt(atrasoMatch[1]) * 60 + parseInt(atrasoMatch[2]);
                                  }
                                  
                                  return (
                                    <span className="text-red-600 font-medium" title="Atraso para desconto">
                                      {atrasoMin > 0 ? formatMinutes(atrasoMin) : '-'}
                                    </span>
                                  );
                                }
                                
                                // Verificar saída antecipada
                                const temSaidaAntecipada = dia.situacao?.some(s => s.includes('SAÍDA ANTECIPADA'));
                                if (temSaidaAntecipada) {
                                  const saidaSit = dia.situacao?.find(s => s.includes('SAÍDA ANTECIPADA'));
                                  const saidaMatch = saidaSit?.match(/(\d+)min/);
                                  const saidaMin = saidaMatch ? parseInt(saidaMatch[1]) : 0;
                                  
                                  return (
                                    <span className="text-red-600 font-medium" title="Saída antecipada">
                                      {saidaMin > 0 ? formatMinutes(saidaMin) : '-'}
                                    </span>
                                  );
                                }
                                
                                return <span className="text-slate-400">-</span>;
                              })()}
                            </TableCell>
                            {/* Coluna !Falta - para falta e DSR */}
                            <TableCell className="text-center py-1 md:py-2 text-[9px] md:text-[10px]">
                              {(() => {
                                // Se dia foi abonado, não mostrar falta
                                if (dia.abonado) {
                                  return <span className="text-slate-400">-</span>;
                                }
                                
                                // Verificar se tem falta REAL (não "FALTA BATIDA" que significa trabalhou mas não bateu ponto)
                                // "FALTA" sozinho = não trabalhou
                                // "*FALTA BATIDA" ou "FALTA BATIDA" = trabalhou mas não bateu ponto (diferente!)
                                const temFaltaReal = dia.situacao?.some(s => s === 'FALTA' || s === 'FALTA (sem apontamento)');
                                
                                // Se não tem batida, não tem escala e é dia útil = FALTA
                                const ehDiaUtil = dia.tipo_dia !== 'sabado' && dia.tipo_dia !== 'domingo' && !dia.eh_feriado;
                                const semBatida = !dia.entrada && !dia.saida;
                                const semTrabalho = dia.trabalhado_minutos === 0;
                                
                                if (temFaltaReal || (ehDiaUtil && semBatida && semTrabalho && !dia.abonado)) {
                                  return (
                                    <Badge className="bg-red-700 text-white text-[8px]">
                                      FALTA
                                    </Badge>
                                  );
                                }
                                
                                return <span className="text-slate-400">-</span>;
                              })()}
                            </TableCell>
                            <TableCell className="py-1 md:py-2 max-w-[100px] md:max-w-[180px] hidden sm:table-cell">
                              <div className="space-y-0.5">
                                {/* Irregularidade registrada (hora dormindo, etc) */}
                                {dia.irregularidade_tipo && (
                                  <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded p-1 mb-1">
                                    <div className="flex items-start gap-1">
                                      <BedDouble className="w-3 h-3 text-red-600 mt-0.5 flex-shrink-0" />
                                      <div className="text-[8px]">
                                        <p className="font-semibold text-red-700 dark:text-red-400">
                                          {dia.irregularidade_tipo === 'hora_dormindo' ? 'INCOERENTE' : dia.irregularidade_tipo.toUpperCase()}
                                        </p>
                                        {dia.irregularidade_apontamento_original && (
                                          <p className="text-slate-600 dark:text-slate-400">
                                            {dia.irregularidade_apontamento_original.entrada || '-'}/{dia.irregularidade_apontamento_original.saida || '-'}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                                
                                {/* Badges de situação - empilhados verticalmente */}
                                <div className="flex flex-col gap-0.5">
                                  {dia.abonado && (
                                    <Badge className="text-[8px] bg-cyan-500 text-white w-fit">
                                      <Shield className="w-2.5 h-2.5 mr-0.5" />
                                      ABONADO
                                    </Badge>
                                  )}
                                  {/* Badge de Folga Banco de Horas (quando atraso foi abonado) */}
                                  {dia.atraso_abonado && (
                                    <Badge className="text-[8px] bg-blue-500 text-white w-fit">
                                      <Clock className="w-2.5 h-2.5 mr-0.5" />
                                      FOLGA BH: +{dia.atraso_abonado_minutos > 0 ? formatMinutes(dia.atraso_abonado_minutos) : formatMinutes(Math.abs(dia.banco_minutos || 0))} 
                                      {dia.atraso_abonado_observacao && (
                                        <span className="text-yellow-200 ml-1">
                                          - {dia.atraso_abonado_observacao}
                                        </span>
                                      )}
                                    </Badge>
                                  )}
                                  {dia.situacao?.map((sit, i) => {
                                    // Se atraso foi abonado como Folga Banco de Horas, não mostrar badge ATRASO nem ATRASO ABONADO
                                    if (dia.atraso_abonado && (sit.includes('ATRASO:') || sit.includes('ATRASO CONFIRMADO') || sit.includes('ATRASO ABONADO'))) {
                                      return null;
                                    }
                                    // Abreviar textos longos
                                    let textoAbreviado = sit
                                      .replace('ESCALA NOTURNA:', 'NOT:')
                                      .replace('ADICIONAL NOTURNO:', 'AD.NOT:')
                                      .replace('Intrajornada paga (FDS)', 'Intraj.FDS')
                                      .replace('Intrajornada suprimida:', 'Intraj:')
                                      .replace('intervalo pago', 'int.pago')
                                      .replace('(Sábado) - Escala Especial', '(Sáb)')
                                      .replace('(Domingo)', '(Dom)')
                                      .replace('crédito total', 'créd.')
                                      .replace('cruzou meia-noite', 'noite')
                                      .replace('Jornada noturna', 'J.Noturna')
                                      .replace('(fim de semana)', '(FDS)')
                                      .replace('Dia do Trabalho', 'Trabalho');
                                    
                                    return (
                                      <Badge 
                                        key={i} 
                                        className={`text-[8px] w-fit ${
                                          sit.includes('NÃO BATEU') ? 'bg-red-600 text-white' :
                                          sit.includes('ATRASO') ? 'bg-red-500 text-white' :
                                          sit.includes('FALTA BATIDA') ? 'bg-amber-500 text-white' :  // FALTA BATIDA = trabalhou mas não bateu (amarelo)
                                          sit === 'FALTA' ? 'bg-red-700 text-white' :  // FALTA pura = não trabalhou (vermelho escuro)
                                          sit.includes('INTERJORNADA') ? 'bg-rose-600 text-white' :
                                          sit.includes('INTRAJORNADA') ? 'bg-purple-600 text-white' :
                                          sit.includes('DIVERGÊNCIA') ? 'bg-amber-500 text-white' :
                                          sit.includes('Feriado') ? 'bg-amber-100 text-amber-700' :
                                          sit.includes('Folga') ? 'bg-slate-200 text-slate-600' :
                                          'bg-slate-100 text-slate-600'
                                        }`}
                                      >
                                        {textoAbreviado}
                                      </Badge>
                                    );
                                  })}
                                </div>
                                
                                {/* Observação */}
                                {dia.observacao && (
                                  <div className="text-[8px] text-slate-600 dark:text-slate-400 whitespace-pre-wrap break-words bg-amber-50 dark:bg-amber-900/20 p-1 rounded border-l-2 border-amber-400 mt-1">
                                    {dia.observacao}
                                  </div>
                                )}
                              </div>
                            </TableCell>
                            <TableCell className="text-center py-1 md:py-2">
                              <div className="flex items-center justify-center gap-0.5 md:gap-1 flex-wrap">
                                {/* Botão de Classificar */}
                                {dia.record_id && dia.trabalhado_minutos > 0 && (
                                  <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => openClassifModal(dia)}
                                    disabled={competenciaStatus === 'fechada'}
                                    className={`text-[10px] h-7 px-2 ${
                                      dia.classificacao_dia && dia.classificacao_dia !== 'normal' 
                                        ? getClassifColor(dia.classificacao_dia) 
                                        : ''
                                    } ${competenciaStatus === 'fechada' ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    title={competenciaStatus === 'fechada' ? 'Competência fechada - somente leitura' : 'Classificar este dia'}
                                    data-testid={`classif-btn-${dia.record_id}`}
                                  >
                                    <Tag className="w-3 h-3" />
                                  </Button>
                                )}
                                {/* Botão de Abonar */}
                                {dia.record_id && !dia.abonado && dia.trabalhado_minutos > 0 && (
                                  <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => openAbonoModal(dia)}
                                    disabled={competenciaStatus === 'fechada'}
                                    className={`text-[10px] h-7 px-2 ${competenciaStatus === 'fechada' ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    title={competenciaStatus === 'fechada' ? 'Competência fechada - somente leitura' : 'Abonar este dia'}
                                  >
                                    <Shield className="w-3 h-3" />
                                  </Button>
                                )}
                                {/* Remover Abono */}
                                {dia.abonado && (
                                  <Button
                                    variant="ghost"
                                    size="sm"
                                    onClick={() => handleRemoverAbono(dia.record_id)}
                                    disabled={competenciaStatus === 'fechada'}
                                    className={`text-[10px] h-7 px-2 text-red-600 hover:text-red-700 ${competenciaStatus === 'fechada' ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    title={competenciaStatus === 'fechada' ? 'Competência fechada - somente leitura' : 'Remover abono'}
                                  >
                                    <Ban className="w-3 h-3" />
                                  </Button>
                                )}
                                {/* Botão de Abonar Atraso/Saída Antecipada (quando há débito no banco e não está abonado) */}
                                {dia.record_id && !dia.abonado && !dia.atraso_abonado && 
                                 ((dia.situacao && dia.situacao.some(s => s.includes('ATRASO:') || s.includes('ATRASO CONFIRMADO'))) ||
                                  (dia.banco_minutos < 0 && dia.trabalhado_minutos > 0)) && (
                                  <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => openAbonoAtrasoModal(dia)}
                                    disabled={competenciaStatus === 'fechada'}
                                    className={`text-[10px] h-7 px-2 border-amber-300 text-amber-700 hover:bg-amber-50 ${competenciaStatus === 'fechada' ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    title={competenciaStatus === 'fechada' ? 'Competência fechada' : 'Folga Banco de Horas (abonar atraso/saída antecipada)'}
                                  >
                                    <Clock className="w-3 h-3" />
                                  </Button>
                                )}
                                {/* Remover Abono de Atraso */}
                                {dia.atraso_abonado && (
                                  <Button
                                    variant="ghost"
                                    size="sm"
                                    onClick={() => handleRemoverAbonoAtraso(dia.record_id)}
                                    disabled={competenciaStatus === 'fechada'}
                                    className={`text-[10px] h-7 px-2 text-amber-600 hover:text-amber-700 ${competenciaStatus === 'fechada' ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    title={competenciaStatus === 'fechada' ? 'Competência fechada' : 'Remover abono do atraso'}
                                  >
                                    <Clock className="w-3 h-3 line-through" />
                                  </Button>
                                )}
                                {/* Botão de Converter Falta em Folga - quando escala é folga/banco mas aparece como FALTA */}
                                {dia.situacao?.some(s => s === 'FALTA' || s.includes('FALTA (')) && 
                                 !dia.abonado && 
                                 (dia.local_evento?.toLowerCase()?.includes('banco') || 
                                  dia.local_evento?.toLowerCase()?.includes('folga') ||
                                  dia.escala_dia?.toLowerCase()?.includes('banco') ||
                                  dia.escala_dia?.toLowerCase()?.includes('folga')) && (
                                  <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => handleConverterFaltaEmFolga(dia)}
                                    disabled={competenciaStatus === 'fechada'}
                                    className={`text-[10px] h-7 px-2 border-green-400 text-green-600 hover:bg-green-50 ${competenciaStatus === 'fechada' ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    title={competenciaStatus === 'fechada' ? 'Competência fechada' : 'Converter falta em folga justificada (escala era folga/banco)'}
                                  >
                                    <CheckCircle className="w-3 h-3" />
                                  </Button>
                                )}
                                {/* Botão Registro Manual Presumido - para dias com FALTA BATIDA (fonte manual) */}
                                {dia.record_id && (dia.entrada_source === 'manual' || dia.saida_source === 'manual') && (
                                  <Button
                                    variant={dia.registro_presumido ? 'default' : 'outline'}
                                    size="sm"
                                    onClick={() => handleTogglePresumido(dia)}
                                    disabled={competenciaStatus === 'fechada'}
                                    data-testid={`presumido-btn-${dia.data}`}
                                    className={`text-[10px] h-7 px-2 ${dia.registro_presumido
                                      ? 'bg-amber-500 hover:bg-amber-600 text-white border-amber-500'
                                      : 'border-amber-400 text-amber-600 hover:bg-amber-50'} ${competenciaStatus === 'fechada' ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    title={competenciaStatus === 'fechada' ? 'Competência fechada' : (dia.registro_presumido
                                      ? 'Dia marcado como REGISTRO MANUAL PRESUMIDO (clique para remover)'
                                      : 'Marcar como REGISTRO MANUAL PRESUMIDO (horário da escala, não do relógio)')}
                                  >
                                    <Edit3 className="w-3 h-3" />
                                  </Button>
                                )}
                                {/* Botão de Ocorrência - também para dias COM apontamento (permite tratar as horas) */}
                                {dia.record_id && dia.entrada && dia.saida && (
                                  <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => openOcorrenciaModal(dia)}
                                    disabled={competenciaStatus === 'fechada'}
                                    data-testid={`ocorrencia-btn-${dia.data}`}
                                    className={`text-[10px] h-7 px-2 border-red-300 text-red-600 hover:bg-red-50 ${competenciaStatus === 'fechada' ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    title={competenciaStatus === 'fechada' ? 'Competência fechada' : 'Registrar ocorrência / tratar horas do dia'}
                                  >
                                    <FileWarning className="w-3 h-3" />
                                  </Button>
                                )}
                                {/* Botão de Adicionar Ocorrência/Abonar para dias SEM batida completa */}
                                {(!dia.entrada || !dia.saida) && !dia.abonado && (dia.trabalhado_minutos === 0 || dia.situacao?.some(s => s.includes('SEM APONTAMENTO') || s === 'FALTA')) && (
                                  <>
                                    <Button
                                      variant="outline"
                                      size="sm"
                                      onClick={() => openOcorrenciaModal(dia)}
                                      disabled={competenciaStatus === 'fechada'}
                                      className={`text-[10px] h-7 px-2 border-red-300 text-red-600 hover:bg-red-50 ${competenciaStatus === 'fechada' ? 'opacity-50 cursor-not-allowed' : ''}`}
                                      title={competenciaStatus === 'fechada' ? 'Competência fechada' : 'Registrar irregularidade'}
                                    >
                                      <FileWarning className="w-3 h-3" />
                                    </Button>
                                    <Button
                                      variant="outline"
                                      size="sm"
                                      onClick={() => openAbonoModal(dia)}
                                      disabled={competenciaStatus === 'fechada'}
                                      className={`text-[10px] h-7 px-2 border-cyan-300 text-cyan-600 hover:bg-cyan-50 ${competenciaStatus === 'fechada' ? 'opacity-50 cursor-not-allowed' : ''}`}
                                      title={competenciaStatus === 'fechada' ? 'Competência fechada' : 'Abonar dia (neutralizar horas)'}
                                    >
                                      <CheckCircle className="w-3 h-3" />
                                    </Button>
                                  </>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      {/* === LINHA DE TOTAIS === */}
                      <TableRow className="bg-slate-800 text-white font-bold text-[9px] md:text-xs border-t-2 border-slate-600">
                        <TableCell colSpan={2} className="py-1 md:py-2 text-right pr-2 md:pr-4 sticky left-0 bg-slate-800 z-10">
                          <span className="hidden sm:inline">TOTAIS DO MÊS →</span>
                          <span className="sm:hidden">TOTAL →</span>
                        </TableCell>
                        <TableCell colSpan={2} className="py-1 md:py-2 text-center hidden md:table-cell">
                          {/* Jornada - vazio */}
                        </TableCell>
                        <TableCell className="py-1 md:py-2 text-center hidden lg:table-cell">
                          {/* Escala - vazio */}
                        </TableCell>
                        <TableCell className="py-1 md:py-2 text-center text-blue-300">
                          {jornadaData.resumo?.trabalhado || formatMinutes(jornadaData.dias?.reduce((acc, d) => acc + (d.trabalhado_minutos || 0), 0) || 0)}
                        </TableCell>
                        <TableCell className="py-1 md:py-2 text-center">
                          <span className={jornadaData.resumo?.banco_horas_minutos >= 0 ? 'text-green-300' : 'text-red-300'}>
                            {jornadaData.resumo?.banco_horas || '00h00'}
                          </span>
                        </TableCell>
                        <TableCell className="py-1 md:py-2 text-center text-amber-300">
                          {jornadaData.resumo?.extra_50 || '00h00'}
                        </TableCell>
                        <TableCell className="py-1 md:py-2 text-center text-orange-300">
                          {jornadaData.resumo?.extra_100 || '00h00'}
                        </TableCell>
                        <TableCell className="py-1 md:py-2 text-center text-indigo-300 hidden sm:table-cell">
                          {jornadaData.resumo?.adicional_noturno || '00h00'}
                        </TableCell>
                        <TableCell className="py-1 md:py-2 text-center text-purple-300 hidden lg:table-cell">
                          {jornadaData.resumo?.intrajornada || '00h00'}
                        </TableCell>
                        <TableCell className="py-1 md:py-2 text-center text-rose-300 hidden lg:table-cell">
                          {jornadaData.resumo?.interjornada_horas || '00h00'}
                        </TableCell>
                        <TableCell className="py-1 md:py-2 text-center text-red-300">
                          {/* Total de atrasos */}
                          -
                        </TableCell>
                        <TableCell className="py-1 md:py-2 text-center text-red-400">
                          {/* Total de faltas */}
                          {jornadaData.resumo?.dias_falta > 0 ? `${jornadaData.resumo.dias_falta}F` : '-'}
                        </TableCell>
                        <TableCell className="py-1 md:py-2 text-center text-slate-400 text-[8px] md:text-[10px] hidden sm:table-cell">
                          {jornadaData.resumo?.dias_trabalhados || 0} dias
                        </TableCell>
                        <TableCell className="py-1 md:py-2">
                          {/* Ações - vazio */}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
              </CardContent>
            </Card>

            {/* Legenda */}
            <Card className="bg-slate-50 dark:bg-slate-800/30 border-slate-200 dark:border-slate-700">
              <CardContent className="p-4">
                <h4 className="font-medium text-sm mb-2">Legenda:</h4>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
                  {/* Cores das linhas */}
                  <div className="flex items-center gap-2">
                    <span className="w-4 h-4 rounded bg-red-100 border border-red-200"></span>
                    <span>Falta</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-4 h-4 rounded bg-red-50 border border-red-100"></span>
                    <span>Atraso</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-4 h-4 rounded bg-amber-50 border border-amber-200"></span>
                    <span>Batida manual</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-4 h-4 rounded bg-cyan-50 border border-cyan-200"></span>
                    <span>Abonado</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-4 h-4 rounded bg-yellow-50 border border-yellow-200"></span>
                    <span>Feriado</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-4 h-4 rounded bg-orange-50 border border-orange-100"></span>
                    <span>Domingo</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-4 h-4 rounded bg-slate-100 border border-slate-200"></span>
                    <span>Sábado</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-4 h-4 rounded bg-blue-500 border border-blue-600"></span>
                    <span className="text-blue-600 font-medium">Folga BH</span>
                  </div>
                </div>
                <div className="mt-3 pt-3 border-t border-slate-200 dark:border-slate-700">
                  <div className="flex flex-wrap gap-4 text-xs">
                    <div className="flex items-center gap-1">
                      <span className="text-amber-600 font-bold">E50%</span>
                      <span>= Sábado</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-orange-600 font-bold">E100%</span>
                      <span>= Dom/Feriado</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-indigo-600 font-bold">Noturno</span>
                      <span>= 22h-05h (+20%)</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-purple-600 font-bold">Intraj.</span>
                      <span>= Intervalo Pago</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-rose-600 font-bold">Interj.</span>
                      <span>= Descanso &lt;11h</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="text-red-600 font-bold">!Atraso</span>
                      <span>= Desconto Folha</span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Regras de Apuração */}
            {jornadaData.regras_aplicadas && (
              <Card className="bg-blue-50 dark:bg-blue-900/10 border-blue-200 dark:border-blue-800">
                <CardContent className="p-4">
                  <h4 className="font-medium text-sm mb-2 flex items-center gap-2">
                    <FileText className="w-4 h-4 text-blue-600" />
                    Regras de Apuração Aplicadas
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-xs text-slate-600 dark:text-slate-400">
                    {jornadaData.resumo?.jornada_contratual && (
                      <div className="flex items-start gap-2">
                        <span className="font-medium text-blue-600">Jornada:</span>
                        <span>{jornadaData.resumo.jornada_contratual}</span>
                      </div>
                    )}
                    {jornadaData.resumo?.intervalo && (
                      <div className="flex items-start gap-2">
                        <span className="font-medium text-blue-600">Intervalo:</span>
                        <span>{jornadaData.resumo.intervalo}</span>
                      </div>
                    )}
                    {jornadaData.resumo?.tolerancia_entrada && (
                      <div className="flex items-start gap-2">
                        <span className="font-medium text-blue-600">Tolerância:</span>
                        <span>Entrada {jornadaData.resumo.tolerancia_entrada}</span>
                      </div>
                    )}
                    <div className="flex items-start gap-2">
                      <span className="font-medium text-blue-600">Banco Horas:</span>
                      <span>{jornadaData.regras_aplicadas.banco_horas}</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <span className="font-medium text-blue-600">Extra 50%:</span>
                      <span>{jornadaData.regras_aplicadas.extra_50}</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <span className="font-medium text-blue-600">Extra 100%:</span>
                      <span>{jornadaData.regras_aplicadas.extra_100}</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <span className="font-medium text-blue-600">Ad. Noturno:</span>
                      <span>{jornadaData.regras_aplicadas.adicional_noturno}</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <span className="font-medium text-blue-600">Abonado:</span>
                      <span>{jornadaData.regras_aplicadas.abonado}</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}
          </>
        ) : null
      ) : (
        // VISUALIZAÇÃO TODOS CLT
        <div className="space-y-4">
          {allCltData.length === 0 ? (
            <Card className="dark:bg-slate-800/50 dark:border-slate-700">
              <CardContent className="py-12 text-center">
                <Users className="w-16 h-16 mx-auto mb-4 text-slate-300" />
                <p className="text-slate-500">Carregando dados de todos os CLT...</p>
              </CardContent>
            </Card>
          ) : (
            allCltData.map(({ human, data }) => {
              if (!data) return null;
              const bancoNegativo = data.resumo?.banco_horas_minutos < 0;
              const temExtras = data.resumo?.extra_50_minutos > 0 || data.resumo?.extra_100_minutos > 0;
              
              return (
                <Card 
                  key={human.id} 
                  className={`dark:bg-slate-800/50 dark:border-slate-700 ${
                    bancoNegativo ? 'border-l-4 border-l-red-500' : 'border-l-4 border-l-green-500'
                  }`}
                >
                  <CardContent className="p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                          bancoNegativo ? 'bg-red-100' : 'bg-green-100'
                        }`}>
                          <User className={`w-5 h-5 ${bancoNegativo ? 'text-red-600' : 'text-green-600'}`} />
                        </div>
                        <div>
                          <h3 className="font-bold text-slate-900 dark:text-white">{human.name}</h3>
                          <div className="flex items-center gap-3 text-xs text-slate-500">
                            <span>{data.resumo.dias_trabalhados} dias</span>
                            <span className={bancoNegativo ? 'text-red-600 font-medium' : 'text-green-600 font-medium'}>
                              Banco: {data.resumo.banco_horas}
                            </span>
                            {temExtras && (
                              <span className="text-amber-600">
                                Extras: {formatMinutes(data.resumo.extra_50_minutos + data.resumo.extra_100_minutos)}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => {
                            setSelectedHuman(human.id);
                            setViewMode('individual');
                          }}
                        >
                          Ver Detalhes
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );
            })
          )}
        </div>
      )}

      {/* Modal de Abono */}
      <Dialog open={showAbonoModal} onOpenChange={setShowAbonoModal}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Shield className="w-5 h-5 text-cyan-600" />
              Abonar Dia
            </DialogTitle>
            <DialogDescription>
              {selectedRecord && (
                <span>
                  Abonar o dia {formatDate(selectedRecord.data)} ({selectedRecord.dia_semana}) - 
                  Este dia não entrará no banco de horas nem nas extras.
                </span>
              )}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Motivo do Abono *</Label>
              <Select value={abonoMotivo} onValueChange={setAbonoMotivo}>
                <SelectTrigger>
                  <SelectValue placeholder="Selecione o motivo..." />
                </SelectTrigger>
                <SelectContent>
                  {motivosAbono.map((m) => (
                    <SelectItem key={m.value} value={m.value}>
                      {m.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            
            {/* Seção de Irregularidade */}
            {(abonoMotivo === 'apontamento_incoerente' || abonoMotivo === 'reincidencia_descanso') && (
              <div className="border border-red-200 dark:border-red-800 rounded p-3 bg-red-50 dark:bg-red-900/20 space-y-3">
                <div className="flex items-center gap-2 text-red-700 dark:text-red-400 font-medium text-sm">
                  <BedDouble className="w-4 h-4" />
                  Registrar Irregularidade de Apontamento
                </div>
                
                <div className="space-y-2">
                  <Label className="text-xs">Tipo de Irregularidade</Label>
                  <Select value={irregularidadeTipo} onValueChange={setIrregularidadeTipo}>
                    <SelectTrigger className="h-8 text-xs">
                      <SelectValue placeholder="Selecione..." />
                    </SelectTrigger>
                    <SelectContent>
                      {tiposIrregularidade.map((t) => (
                        <SelectItem key={t.value} value={t.value}>
                          {t.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                {irregularidadeTipo && (
                  <>
                    <div className="grid grid-cols-2 gap-2">
                      <div className="space-y-1">
                        <Label className="text-xs">Entrada Original</Label>
                        <Input
                          type="time"
                          value={apontamentoOriginalEntrada}
                          onChange={(e) => setApontamentoOriginalEntrada(e.target.value)}
                          className="h-8 text-xs"
                        />
                      </div>
                      <div className="space-y-1">
                        <Label className="text-xs">Saída Original</Label>
                        <Input
                          type="time"
                          value={apontamentoOriginalSaida}
                          onChange={(e) => setApontamentoOriginalSaida(e.target.value)}
                          className="h-8 text-xs"
                        />
                      </div>
                    </div>
                    
                    <div className="space-y-1">
                      <Label className="text-xs">Descrição do Ato (factual)</Label>
                      <Textarea
                        value={irregularidadeDesc}
                        onChange={(e) => setIrregularidadeDesc(e.target.value)}
                        placeholder="Horário de descanso (DORMINDO) apontado como hora trabalhada. É proibido apontar hora dormindo como hora trabalhada. Apontamento incoerente com o serviço prestado — medição anulada."
                        rows={3}
                        className="text-xs"
                      />
                    </div>
                    
                    <p className="text-[10px] text-slate-500">
                      ⚠️ Descreva o ATO (horário de descanso lançado como trabalho), nunca juízo sobre a pessoa.
                      O apontamento original será preservado e visível.
                    </p>
                  </>
                )}
              </div>
            )}
            
            <div className="space-y-2">
              <Label>Observação (opcional)</Label>
              <Textarea
                value={abonoObs}
                onChange={(e) => setAbonoObs(e.target.value)}
                placeholder="Detalhes adicionais sobre o abono..."
                rows={3}
              />
            </div>
            
            <p className="text-[10px] text-slate-400">
              O abono é uma camada por cima — o horário que a pessoa apontou permanece gravado e visível.
              Esta ação será registrada na trilha de auditoria.
            </p>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowAbonoModal(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleSaveAbono} 
              disabled={savingAbono || !abonoMotivo}
              className="bg-cyan-600 hover:bg-cyan-700"
            >
              {savingAbono ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
              Confirmar Abono
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal de Abonar Atraso/Saída Antecipada (Folga Banco de Horas) */}
      <Dialog open={showAbonoAtrasoModal} onOpenChange={setShowAbonoAtrasoModal}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Clock className="w-5 h-5 text-blue-600" />
              Folga Banco de Horas
            </DialogTitle>
            <DialogDescription>
              {abonoAtrasoRecord && (
                <span>
                  Abonar débito do dia <strong>{formatDate(abonoAtrasoRecord.data)}</strong> ({abonoAtrasoRecord.dia_semana}).
                  <br />
                  {abonoAtrasoRecord.banco_minutos < 0 && (
                    <span className="text-red-600 font-medium">
                      Débito a abonar: {formatMinutes(Math.abs(abonoAtrasoRecord.banco_minutos))}
                    </span>
                  )}
                  <br />
                  <span className="text-blue-600 font-medium">
                    O tempo será abonado usando o saldo do banco de horas.
                  </span>
                </span>
              )}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Motivo do Abono *</Label>
              <Select value={abonoAtrasoMotivo} onValueChange={setAbonoAtrasoMotivo}>
                <SelectTrigger>
                  <SelectValue placeholder="Selecione o motivo..." />
                </SelectTrigger>
                <SelectContent>
                  {motivosAbonoAtraso.map((m) => (
                    <SelectItem key={m.value} value={m.value}>
                      {m.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            
            {/* Campo de motivo obrigatório apenas para "Outro motivo" */}
            {abonoAtrasoMotivo === 'outro' && (
              <div className="space-y-2">
                <Label>Especifique o motivo *</Label>
                <Textarea
                  value={abonoAtrasoObs}
                  onChange={(e) => setAbonoAtrasoObs(e.target.value)}
                  placeholder="Descreva o motivo..."
                  rows={2}
                />
              </div>
            )}
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowAbonoAtrasoModal(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleSaveAbonoAtraso} 
              disabled={savingAbonoAtraso || (abonoAtrasoMotivo === 'outro' && !abonoAtrasoObs)}
              className="bg-blue-600 hover:bg-blue-700"
            >
              {savingAbonoAtraso ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
              Confirmar Folga B.HRS
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal de Classificação de Dia */}
      <Dialog open={showClassifModal} onOpenChange={setShowClassifModal}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Tag className="w-5 h-5 text-blue-600" />
              Classificar Dia
            </DialogTitle>
            <DialogDescription>
              {classifRecord && (
                <span>
                  Classificando <strong>{formatDate(classifRecord.data)}</strong> ({classifRecord.dia_semana}) - {' '}
                  Apontamento: <strong>{classifRecord.entrada || '-'} → {classifRecord.saida || '-'}</strong>
                </span>
              )}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            {/* Seleção de Classificação */}
            <div className="space-y-2">
              <Label>Classificação do Dia *</Label>
              <Select value={classifValue} onValueChange={setClassifValue}>
                <SelectTrigger data-testid="classif-select-trigger">
                  <SelectValue placeholder="Selecione..." />
                </SelectTrigger>
                <SelectContent>
                  {classificacoes.map((c) => (
                    <SelectItem key={c.value} value={c.value}>
                      <div className="flex flex-col">
                        <span className="font-medium">{c.label}</span>
                        <span className="text-xs text-slate-500">{c.desc}</span>
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            {/* Campos adicionais para escala noturna/jornada especial */}
            {(classifValue === 'escala_noturna' || classifValue === 'jornada_especial') && (
              <div className="p-3 bg-purple-50 dark:bg-purple-900/20 rounded-lg space-y-3">
                <Label className="text-sm font-medium text-purple-700">Jornada Prevista (opcional)</Label>
                <div className="grid grid-cols-2 gap-2">
                  <div className="space-y-1">
                    <Label className="text-xs">Início</Label>
                    <Input
                      type="time"
                      value={classifJornadaInicio}
                      onChange={(e) => setClassifJornadaInicio(e.target.value)}
                      placeholder="21:00"
                    />
                  </div>
                  <div className="space-y-1">
                    <Label className="text-xs">Fim</Label>
                    <Input
                      type="time"
                      value={classifJornadaFim}
                      onChange={(e) => setClassifJornadaFim(e.target.value)}
                      placeholder="05:00"
                    />
                  </div>
                </div>
                <p className="text-xs text-purple-600">
                  Se não informar, todo o trabalhado será considerado crédito.
                </p>
              </div>
            )}

            {/* Campos adicionais para turno dividido */}
            {classifValue === 'turno_dividido' && (
              <div className="p-3 bg-amber-50 dark:bg-amber-900/20 rounded-lg space-y-3">
                <Label className="text-sm font-medium text-amber-700">Dados dos Turnos</Label>
                <div className="space-y-3">
                  <div>
                    <Label className="text-xs font-medium">Turno 1</Label>
                    <div className="grid grid-cols-3 gap-2 mt-1">
                      <Input
                        type="time"
                        value={classifTurno1Inicio}
                        onChange={(e) => setClassifTurno1Inicio(e.target.value)}
                        placeholder="Início"
                      />
                      <Input
                        type="time"
                        value={classifTurno1Fim}
                        onChange={(e) => setClassifTurno1Fim(e.target.value)}
                        placeholder="Fim"
                      />
                      <Input
                        value={classifLocal1}
                        onChange={(e) => setClassifLocal1(e.target.value)}
                        placeholder="Local"
                      />
                    </div>
                  </div>
                  <div>
                    <Label className="text-xs font-medium">Turno 2</Label>
                    <div className="grid grid-cols-3 gap-2 mt-1">
                      <Input
                        type="time"
                        value={classifTurno2Inicio}
                        onChange={(e) => setClassifTurno2Inicio(e.target.value)}
                        placeholder="Início"
                      />
                      <Input
                        type="time"
                        value={classifTurno2Fim}
                        onChange={(e) => setClassifTurno2Fim(e.target.value)}
                        placeholder="Fim"
                      />
                      <Input
                        value={classifLocal2}
                        onChange={(e) => setClassifLocal2(e.target.value)}
                        placeholder="Local"
                      />
                    </div>
                  </div>
                </div>
                <p className="text-xs text-amber-600">
                  As horas dos dois turnos serão SOMADAS, não abatidas.
                </p>
              </div>
            )}

            {/* Preview do Impacto */}
            <div className="p-3 bg-slate-100 dark:bg-slate-800 rounded-lg">
              <Label className="text-sm font-medium flex items-center gap-2 mb-2">
                <ArrowRight className="w-4 h-4" />
                Impacto da Classificação
              </Label>
              {loadingPreview ? (
                <div className="flex items-center justify-center py-4">
                  <Loader2 className="w-5 h-5 animate-spin text-blue-600" />
                </div>
              ) : previewImpacto ? (
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2">
                    <Badge className={getClassifColor(classifValue)}>
                      {previewImpacto.impacto?.tipo || classifValue}
                    </Badge>
                    <span className="font-bold text-lg">
                      {previewImpacto.impacto?.valor || '0'}
                    </span>
                  </div>
                  <p className="text-slate-600 dark:text-slate-400 text-xs">
                    {previewImpacto.impacto?.descricao}
                  </p>
                  {previewImpacto.impacto?.nota && (
                    <p className="text-amber-600 text-xs font-medium">
                      {previewImpacto.impacto.nota}
                    </p>
                  )}
                  {previewImpacto.adicional_noturno && (
                    <div className="flex items-center gap-2 text-indigo-600">
                      <Moon className="w-3 h-3" />
                      <span className="text-xs">
                        Adicional Noturno: {previewImpacto.adicional_noturno.formatado}
                      </span>
                    </div>
                  )}
                </div>
              ) : (
                <p className="text-slate-500 text-xs">Selecione uma classificação</p>
              )}
            </div>

            {/* Observação */}
            <div className="space-y-2">
              <Label>Observação (opcional)</Label>
              <Textarea
                value={classifObs}
                onChange={(e) => setClassifObs(e.target.value)}
                placeholder="Motivo da classificação..."
                rows={2}
              />
            </div>

            {/* Aviso de Auditoria */}
            <div className="text-xs text-slate-500 bg-slate-50 dark:bg-slate-900 p-2 rounded">
              <strong>Nota:</strong> Esta classificação será registrada na trilha de auditoria com seu usuário e data/hora. 
              O apontamento original (horários batidos) permanece visível e preservado.
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowClassifModal(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleSaveClassif} 
              disabled={savingClassif}
              className="bg-blue-600 hover:bg-blue-700"
              data-testid="aplicar-classificacao-btn"
            >
              {savingClassif ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Tag className="w-4 h-4 mr-2" />}
              Aplicar Classificação
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal de Observação da Folha */}
      <Dialog open={showFechamentoModal} onOpenChange={setShowFechamentoModal}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <MessageSquare className="w-5 h-5 text-amber-600" />
              Controle da Folha
            </DialogTitle>
            <DialogDescription>
              {jornadaData?.funcionario?.nome} - {jornadaData?.periodo?.mes_nome}/{jornadaData?.periodo?.ano}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-6 py-4">
            {/* Seção de Pagamentos Parciais */}
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <Label className="font-semibold flex items-center gap-2">
                  <DollarSign className="w-4 h-4 text-green-600" />
                  Pagamentos Realizados nesta Competencia
                </Label>
                <span className="text-sm text-slate-500">
                  Total: R$ {pagamentosParciais.reduce((acc, p) => acc + (p.valor || 0), 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </span>
              </div>
              
              {/* Lista de pagamentos */}
              {pagamentosParciais.length > 0 && (
                <div className="space-y-2 max-h-32 overflow-y-auto">
                  {pagamentosParciais.map((pag) => (
                    <div key={pag.id} className="flex items-center justify-between bg-green-50 dark:bg-green-900/20 p-2 rounded-lg border border-green-200 dark:border-green-800">
                      <div className="flex items-center gap-3">
                        <span className="text-xs text-slate-500">{pag.data}</span>
                        <span className="text-sm font-medium dark:text-slate-200">{pag.descricao}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-green-600 dark:text-green-400 font-bold">
                          R$ {pag.valor?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                        </span>
                        <Button 
                          variant="ghost" 
                          size="sm" 
                          onClick={() => handleRemovePagamento(pag.id)}
                          className="h-6 w-6 p-0 text-red-500 hover:text-red-700 hover:bg-red-50"
                        >
                          <X className="w-3 h-3" />
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              
              {/* Formulário para adicionar pagamento */}
              <div className="grid grid-cols-12 gap-2 items-end bg-slate-50 dark:bg-slate-800 p-3 rounded-lg">
                <div className="col-span-3">
                  <Label className="text-xs">Data</Label>
                  <Input
                    type="date"
                    value={novoPagamento.data}
                    onChange={(e) => setNovoPagamento({ ...novoPagamento, data: e.target.value })}
                    className="h-8 text-sm"
                  />
                </div>
                <div className="col-span-5">
                  <Label className="text-xs">Descricao</Label>
                  <Input
                    placeholder="Ex: Conducao, Vale, Adiantamento..."
                    value={novoPagamento.descricao}
                    onChange={(e) => setNovoPagamento({ ...novoPagamento, descricao: e.target.value })}
                    className="h-8 text-sm"
                  />
                </div>
                <div className="col-span-3">
                  <Label className="text-xs">Valor (R$)</Label>
                  <Input
                    type="number"
                    step="0.01"
                    placeholder="0,00"
                    value={novoPagamento.valor}
                    onChange={(e) => setNovoPagamento({ ...novoPagamento, valor: e.target.value })}
                    className="h-8 text-sm"
                  />
                </div>
                <div className="col-span-1">
                  <Button 
                    size="sm" 
                    onClick={handleAddPagamento}
                    className="h-8 w-full bg-green-600 hover:bg-green-700"
                  >
                    <Plus className="w-4 h-4" />
                  </Button>
                </div>
              </div>
              <p className="text-xs text-slate-500">
                Registre pagamentos ja realizados (conducao, vales, adiantamentos). Esses valores serao considerados no calculo do liquido restante.
              </p>
            </div>
            
            {/* Separador */}
            <div className="border-t border-slate-200 dark:border-slate-700" />
            
            {/* Observação */}
            <div className="space-y-2">
              <Label className="font-semibold flex items-center gap-2">
                <FileText className="w-4 h-4 text-amber-600" />
                Observacao Geral
              </Label>
              <Textarea
                value={observacaoFechamento}
                onChange={(e) => setObservacaoFechamento(e.target.value)}
                placeholder="Informe detalhes excepcionais: fechamento sem extras devido irregularidades, acordo especial, etc..."
                rows={3}
              />
              <p className="text-xs text-slate-500">
                Esta observacao aparecera no relatorio e no PDF do espelho de ponto.
              </p>
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowFechamentoModal(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleSaveFechamento} 
              disabled={savingFechamento}
              className="bg-green-600 hover:bg-green-700"
            >
              {savingFechamento ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />}
              Salvar Controle
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal de Folga BH em Lote */}
      <Dialog open={showBatchBHModal} onOpenChange={setShowBatchBHModal}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-amber-600">
              <Clock className="w-5 h-5" />
              Aplicar Folga Banco de Horas
            </DialogTitle>
            <DialogDescription>
              Voce selecionou {selectedDays.length} dia(s) para aplicar folga BH.
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
              <p className="text-sm text-amber-700">
                <strong>Dias selecionados:</strong>
              </p>
              <div className="flex flex-wrap gap-1 mt-2">
                {selectedDays.map(day => (
                  <Badge key={day} variant="outline" className="text-xs">
                    {day.split('-').reverse().slice(0, 2).join('/')}
                  </Badge>
                ))}
              </div>
            </div>
            
            <div>
              <Label>Motivo</Label>
              <Select value={batchBHMotivo} onValueChange={setBatchBHMotivo}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="folga_bh">Folga Banco de Horas</SelectItem>
                  <SelectItem value="acordo_compensacao">Acordo de Compensacao</SelectItem>
                  <SelectItem value="servico_externo">Servico Externo</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowBatchBHModal(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleApplyBatchBH} 
              disabled={applyingBatchBH}
              className="bg-amber-500 hover:bg-amber-600"
            >
              {applyingBatchBH ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Clock className="w-4 h-4 mr-2" />}
              Aplicar em {selectedDays.length} dia(s)
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal de Reabertura de Competência */}
      <Dialog open={showReabrirModal} onOpenChange={setShowReabrirModal}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-purple-700">
              <Unlock className="w-5 h-5" />
              Reabrir Competência
            </DialogTitle>
            <DialogDescription>
              A competência {selectedMonth?.toString().padStart(2, '0')}/{selectedYear} está fechada.
              A reabertura será registrada na trilha de auditoria.
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
              <p className="text-sm text-amber-700 flex items-center gap-2">
                <AlertTriangle className="w-4 h-4 flex-shrink-0" />
                <span>
                  <strong>Atenção:</strong> Ao reabrir, a edição de ponto, classificação e abono 
                  voltará a ser permitida. Esta ação ficará registrada para auditoria.
                </span>
              </p>
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="motivoReabertura" className="text-sm font-medium">
                Motivo da Reabertura <span className="text-red-500">*</span>
              </Label>
              <Textarea
                id="motivoReabertura"
                placeholder="Descreva o motivo para reabrir esta competência..."
                value={motivoReabertura}
                onChange={(e) => setMotivoReabertura(e.target.value)}
                className="min-h-[100px]"
              />
              <p className="text-xs text-slate-500">
                O motivo é obrigatório e será registrado na auditoria.
              </p>
            </div>
            
            {competenciaInfo?.fechada_por_nome && (
              <div className="text-xs text-slate-500 bg-slate-50 p-2 rounded">
                <p>Fechada por: <strong>{competenciaInfo.fechada_por_nome}</strong></p>
                {competenciaInfo.fechada_em && (
                  <p>Em: {new Date(competenciaInfo.fechada_em).toLocaleString('pt-BR')}</p>
                )}
              </div>
            )}
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => {
              setShowReabrirModal(false);
              setMotivoReabertura('');
            }}>
              Cancelar
            </Button>
            <Button 
              onClick={handleReabrirCompetencia} 
              disabled={savingCompetencia || !motivoReabertura.trim()}
              className="bg-purple-600 hover:bg-purple-700"
            >
              {savingCompetencia ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Unlock className="w-4 h-4 mr-2" />}
              Confirmar Reabertura
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal de Ocorrência para dias sem registro */}
      <Dialog open={showFolhaConfigModal} onOpenChange={setShowFolhaConfigModal}>
        <DialogContent className="max-w-lg" data-testid="folha-config-modal">
          <DialogHeader>
            <DialogTitle>Configuração da Competência {months.find(m => m.value === selectedMonth)?.label}/{selectedYear}</DialogTitle>
            <DialogDescription>
              Decisão da gestão para esta competência. Os valores continuam calculados e visíveis na Folha Contador, porém <strong>riscados</strong> (registro mantido para auditoria).
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <label className="flex items-start gap-3 cursor-pointer">
              <input
                type="checkbox"
                className="mt-1 h-4 w-4 accent-amber-600"
                checked={!!folhaConfig.nao_descontar_faltas}
                onChange={(e) => setFolhaConfig(prev => ({ ...prev, nao_descontar_faltas: e.target.checked }))}
                data-testid="cfg-nao-descontar-faltas"
              />
              <span>
                <span className="font-medium">Não descontar FALTAS nem DSR</span>
                <span className="block text-xs text-slate-500">As colunas Faltas e DSR aparecem riscadas na Folha Contador</span>
              </span>
            </label>
            <label className="flex items-start gap-3 cursor-pointer">
              <input
                type="checkbox"
                className="mt-1 h-4 w-4 accent-amber-600"
                checked={!!folhaConfig.nao_descontar_banco}
                onChange={(e) => setFolhaConfig(prev => ({ ...prev, nao_descontar_banco: e.target.checked }))}
                data-testid="cfg-nao-descontar-banco"
              />
              <span>
                <span className="font-medium">Não descontar BANCO DE HORAS NEGATIVO</span>
                <span className="block text-xs text-slate-500">A coluna Banco Horas Débito aparece riscada na Folha Contador</span>
              </span>
            </label>
            {folhaConfig.definido_por && (
              <p className="text-xs text-slate-400">Última alteração: {folhaConfig.definido_por}{folhaConfig.definido_em ? ` em ${new Date(folhaConfig.definido_em).toLocaleString('pt-BR')}` : ''}</p>
            )}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowFolhaConfigModal(false)}>Cancelar</Button>
            <Button onClick={handleSaveFolhaConfig} disabled={savingFolhaConfig} data-testid="cfg-salvar-btn" className="bg-amber-600 hover:bg-amber-700 text-white">
              {savingFolhaConfig ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
              Salvar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={showOcorrenciaModal} onOpenChange={setShowOcorrenciaModal}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileWarning className="w-5 h-5 text-red-600" />
              Registrar Ocorrência
            </DialogTitle>
            <DialogDescription>
              {ocorrenciaDia && (
                <span>
                  Registrar ocorrência para <strong>{formatDate(ocorrenciaDia.data)}</strong> ({ocorrenciaDia.dia_semana}).
                  <br />
                  {(ocorrenciaDia.entrada || ocorrenciaDia.saida) ? (
                    <span className="text-blue-600">Este dia possui apontamento — você pode escolher como tratar as horas.</span>
                  ) : (
                    <span className="text-amber-600">Este dia não possui registro de ponto.</span>
                  )}
                </span>
              )}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Tipo de Ocorrência *</Label>
              <Select value={ocorrenciaTipo} onValueChange={setOcorrenciaTipo}>
                <SelectTrigger>
                  <SelectValue placeholder="Selecione o tipo..." />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="irregularidade">⚠️ Irregularidade</SelectItem>
                  <SelectItem value="mentira_termo">🚫 Informação Incorreta</SelectItem>
                  <SelectItem value="falta_injustificada">❌ Falta Injustificada</SelectItem>
                  <SelectItem value="atestado_pendente">📋 Atestado Pendente</SelectItem>
                  <SelectItem value="sem_escala">📅 Sem Escala</SelectItem>
                  <SelectItem value="outro">📝 Outro</SelectItem>
                </SelectContent>
              </Select>
            </div>
            
            <div className="space-y-2">
              <Label>Descrição da Ocorrência *</Label>
              <Textarea
                value={ocorrenciaTexto}
                onChange={(e) => setOcorrenciaTexto(e.target.value)}
                placeholder="Descreva o que ocorreu neste dia..."
                rows={3}
              />
              <p className="text-xs text-slate-500">
                Esta informação ficará registrada na observação do dia.
              </p>
            </div>
            
            <div className="space-y-2">
              <Label>O que fazer com as horas do dia?</Label>
              <Select value={ocorrenciaTratamento} onValueChange={setOcorrenciaTratamento}>
                <SelectTrigger data-testid="ocorrencia-tratamento-select">
                  <SelectValue placeholder="Selecione o tratamento..." />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="manter">Manter cálculo normal (apenas registrar)</SelectItem>
                  <SelectItem value="zerar_neutro">Desconsiderar apontamento — zerar horas (dia neutro)</SelectItem>
                  <SelectItem value="zerar_falta">Desconsiderar apontamento — contar como FALTA</SelectItem>
                  <SelectItem value="escala_prevista">Calcular pela escala prevista (ignora batidas)</SelectItem>
                </SelectContent>
              </Select>
              <p className="text-xs text-slate-500">
                Se escolher desconsiderar, o dia não gera banco, extras nem adicional noturno. Só afeta dias com apontamento.
              </p>
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowOcorrenciaModal(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleSaveOcorrencia} 
              disabled={savingOcorrencia || !ocorrenciaTexto.trim()}
              className="bg-red-600 hover:bg-red-700"
            >
              {savingOcorrencia ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <FileWarning className="w-4 h-4 mr-2" />}
              Registrar Ocorrência
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal de Upload AFD */}
      <Dialog open={showAfdModal} onOpenChange={(open) => !open && resetAfdModal()}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto" data-testid="modal-afd">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-lg">
              <FileUp className="w-5 h-5 text-amber-600" />
              Importar Arquivo AFD
            </DialogTitle>
            <DialogDescription>
              Importe o arquivo AFD do relógio de ponto para comparar com os apontamentos manuais
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-4">
            {/* Upload de arquivo */}
            {!afdResult && (
              <div className="space-y-4">
                <div className="border-2 border-dashed border-slate-300 dark:border-slate-600 rounded-lg p-6 text-center hover:border-amber-400 transition-colors">
                  <input
                    type="file"
                    accept=".txt,.afd"
                    onChange={handleAfdFileSelect}
                    className="hidden"
                    id="afd-file-input"
                    data-testid="afd-file-input"
                  />
                  <label htmlFor="afd-file-input" className="cursor-pointer">
                    <Upload className="w-12 h-12 mx-auto text-slate-400 mb-3" />
                    <p className="text-sm text-slate-600 dark:text-slate-400 mb-1">
                      Clique para selecionar o arquivo AFD
                    </p>
                    <p className="text-xs text-slate-500">
                      Formatos aceitos: .txt, .afd
                    </p>
                  </label>
                </div>

                {afdFile && (
                  <div className="flex items-center justify-between bg-amber-50 dark:bg-amber-900/20 rounded-lg p-3">
                    <div className="flex items-center gap-2">
                      <FileText className="w-5 h-5 text-amber-600" />
                      <span className="text-sm font-medium">{afdFile.name}</span>
                      <span className="text-xs text-slate-500">({(afdFile.size / 1024).toFixed(1)} KB)</span>
                    </div>
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => setAfdFile(null)}
                      className="text-slate-400 hover:text-red-500"
                    >
                      <X className="w-4 h-4" />
                    </Button>
                  </div>
                )}

                <Button
                  onClick={handleAfdUpload}
                  disabled={!afdFile || afdLoading}
                  className="w-full bg-amber-600 hover:bg-amber-700"
                  data-testid="btn-analisar-afd"
                >
                  {afdLoading ? (
                    <Loader2 className="w-4 h-4 animate-spin mr-2" />
                  ) : (
                    <RefreshCw className="w-4 h-4 mr-2" />
                  )}
                  Analisar Arquivo
                </Button>
              </div>
            )}

            {/* Resultado: Precisa mapeamento */}
            {afdResult?.status === 'precisa_mapeamento' && (
              <div className="space-y-4">
                <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700 rounded-lg p-4">
                  <div className="flex items-start gap-3">
                    <AlertCircle className="w-5 h-5 text-amber-600 mt-0.5" />
                    <div>
                      <h4 className="font-medium text-amber-800 dark:text-amber-300">
                        Mapeamento Necessário
                      </h4>
                      <p className="text-sm text-amber-700 dark:text-amber-400 mt-1">
                        {afdResult.message}
                      </p>
                      {afdResult.empresa_afd && (
                        <p className="text-xs text-amber-600 mt-1">
                          Empresa no arquivo: {afdResult.empresa_afd}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="space-y-3">
                  <h4 className="font-medium text-slate-700 dark:text-slate-300 text-sm">
                    Mapear PIS para Colaboradores:
                  </h4>
                  {afdResult.pis_sem_mapeamento?.map((pis, idx) => (
                    <div key={pis} className="flex items-center gap-3 bg-slate-50 dark:bg-slate-800 rounded-lg p-3">
                      <div className="flex-shrink-0">
                        <Badge variant="outline" className="font-mono text-xs">
                          PIS: {pis}
                        </Badge>
                      </div>
                      <ArrowRight className="w-4 h-4 text-slate-400" />
                      <Select
                        value={afdMapeamento[pis] || ''}
                        onValueChange={(v) => setAfdMapeamento(prev => ({ ...prev, [pis]: v }))}
                      >
                        <SelectTrigger className="flex-1">
                          <SelectValue placeholder="Selecione o colaborador..." />
                        </SelectTrigger>
                        <SelectContent>
                          {afdResult.humanos_disponiveis?.map((h) => (
                            <SelectItem key={h.id} value={h.id}>
                              {h.name}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                  ))}
                </div>

                <Button
                  onClick={handleAfdUpload}
                  disabled={afdLoading || Object.keys(afdMapeamento).length !== afdResult.pis_sem_mapeamento?.length}
                  className="w-full bg-amber-600 hover:bg-amber-700"
                >
                  {afdLoading ? (
                    <Loader2 className="w-4 h-4 animate-spin mr-2" />
                  ) : (
                    <RefreshCw className="w-4 h-4 mr-2" />
                  )}
                  Reanalisar com Mapeamento
                </Button>
              </div>
            )}

            {/* Resultado: Análise completa */}
            {afdResult?.status === 'analisado' && (
              <div className="space-y-4">
                {/* Resumo */}
                <div className="grid grid-cols-3 gap-3">
                  <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold text-blue-700">{afdResult.total_registros_afd}</p>
                    <p className="text-xs text-blue-600">Registros AFD</p>
                  </div>
                  <div className="bg-slate-50 dark:bg-slate-800 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold text-slate-700">{afdResult.periodo?.total_dias || 0}</p>
                    <p className="text-xs text-slate-600">Dias no Período</p>
                  </div>
                  <div className={`rounded-lg p-3 text-center ${
                    afdResult.total_inconsistencias > 0 
                      ? 'bg-red-50 dark:bg-red-900/20' 
                      : 'bg-green-50 dark:bg-green-900/20'
                  }`}>
                    <p className={`text-2xl font-bold ${
                      afdResult.total_inconsistencias > 0 ? 'text-red-700' : 'text-green-700'
                    }`}>
                      {afdResult.total_inconsistencias}
                    </p>
                    <p className={`text-xs ${
                      afdResult.total_inconsistencias > 0 ? 'text-red-600' : 'text-green-600'
                    }`}>
                      Inconsistências
                    </p>
                  </div>
                </div>

                {afdResult.empresa_afd && (
                  <p className="text-xs text-slate-500 text-center">
                    Empresa no arquivo: {afdResult.empresa_afd}
                  </p>
                )}

                {/* Tabela de inconsistências */}
                {afdResult.inconsistencias?.length > 0 && (
                  <div className="border rounded-lg overflow-hidden">
                    <Table>
                      <TableHeader>
                        <TableRow className="bg-slate-50 dark:bg-slate-800">
                          <TableHead className="w-24">Data</TableHead>
                          <TableHead>Colaborador</TableHead>
                          <TableHead className="w-36">Tipo</TableHead>
                          <TableHead className="w-24">AFD</TableHead>
                          <TableHead className="w-24">Manual</TableHead>
                          <TableHead className="w-36">Ação</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {afdResult.inconsistencias.map((inc, idx) => (
                          <TableRow key={idx} className="text-sm">
                            <TableCell className="font-mono text-xs">
                              {inc.data}
                            </TableCell>
                            <TableCell className="font-medium">
                              {inc.human_name}
                            </TableCell>
                            <TableCell>
                              <Badge className={`text-xs ${getInconsistenciaTipoColor(inc.tipo)}`}>
                                {getInconsistenciaTipoLabel(inc.tipo)}
                              </Badge>
                            </TableCell>
                            <TableCell className="font-mono text-xs">
                              {inc.afd_entrada && inc.afd_saida ? (
                                <span className="text-amber-600">
                                  {inc.afd_entrada} - {inc.afd_saida}
                                </span>
                              ) : inc.afd_entrada || inc.afd_saida ? (
                                <span className="text-amber-600">
                                  {inc.afd_entrada || inc.afd_saida}
                                </span>
                              ) : (
                                <span className="text-slate-400">-</span>
                              )}
                            </TableCell>
                            <TableCell className="font-mono text-xs">
                              {inc.manual_entrada && inc.manual_saida ? (
                                <span className="text-blue-600">
                                  {inc.manual_entrada} - {inc.manual_saida}
                                </span>
                              ) : inc.manual_entrada || inc.manual_saida ? (
                                <span className="text-blue-600">
                                  {inc.manual_entrada || inc.manual_saida}
                                </span>
                              ) : (
                                <span className="text-slate-400">-</span>
                              )}
                            </TableCell>
                            <TableCell>
                              <Select
                                value={afdAcoes[idx] || 'ignorar'}
                                onValueChange={(v) => setAfdAcoes(prev => ({ ...prev, [idx]: v }))}
                              >
                                <SelectTrigger className="h-8 text-xs">
                                  <SelectValue />
                                </SelectTrigger>
                                <SelectContent>
                                  <SelectItem value="ignorar">
                                    <span className="flex items-center gap-1">
                                      <X className="w-3 h-3" /> Ignorar
                                    </span>
                                  </SelectItem>
                                  <SelectItem value="usar_afd">
                                    <span className="flex items-center gap-1">
                                      <Check className="w-3 h-3 text-green-600" /> Usar AFD
                                    </span>
                                  </SelectItem>
                                  <SelectItem value="manter_manual">
                                    <span className="flex items-center gap-1">
                                      <CheckCircle className="w-3 h-3 text-blue-600" /> Manter Manual
                                    </span>
                                  </SelectItem>
                                </SelectContent>
                              </Select>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                )}

                {afdResult.total_inconsistencias === 0 && (
                  <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 rounded-lg p-6 text-center">
                    <CheckCircle className="w-12 h-12 mx-auto text-green-600 mb-3" />
                    <h4 className="font-medium text-green-800 dark:text-green-300">
                      Nenhuma inconsistência encontrada!
                    </h4>
                    <p className="text-sm text-green-700 dark:text-green-400 mt-1">
                      Os dados do AFD estão compatíveis com os apontamentos manuais.
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>

          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={resetAfdModal}>
              {afdResult?.status === 'analisado' ? 'Fechar' : 'Cancelar'}
            </Button>
            {afdResult?.status === 'analisado' && afdResult.total_inconsistencias > 0 && (
              <Button
                onClick={handleAfdAplicar}
                disabled={applyingAfd || Object.values(afdAcoes).every(a => a === 'ignorar')}
                className="bg-green-600 hover:bg-green-700"
                data-testid="btn-aplicar-afd"
              >
                {applyingAfd ? (
                  <Loader2 className="w-4 h-4 animate-spin mr-2" />
                ) : (
                  <Check className="w-4 h-4 mr-2" />
                )}
                Aplicar Correções
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default FolhaCltPage;
